import { Component, ElementRef, OnInit, signal, ViewChild, ViewChildren, QueryList, HostListener, AfterViewInit, OnDestroy, Renderer2, WritableSignal } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer, MatSidenavContent, MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PromptCreateService } from '../../services/prompt-create.service';
import { MatDialog } from '@angular/material/dialog';
import { OnSaveComponent } from '../../on-save/on-save.component';
import { OnSubmitComponent } from '../../on-submit/on-submit.component';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { DashboardService } from '../../services/shared/dashboard.service';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';

import { PromtUserService } from '../../services/prompt-user.service';
import { ButtonComponent } from '../common/components/button/button.component';
import { SnackBarComponent } from '../common/components/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, debounceTime, finalize, firstValueFrom, Observable, of, Subject } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';
import { DateTimeFormatterPipe } from '../common/pipes/date-time-formatter.pipe';
import { ModifiedChangesComponent } from '../../modified-changes/modified-changes.component';
import { OnPromptDeleteComponent } from '../../on-prompt-delete/on-prompt-delete.component';
import { ErrorNotficationComponent } from '../../error-notfication/error-notfication.component';
import { ContenteditableDirective } from '../../directives/contenteditable.directive';
import { LoaderComponent } from '../common/components/loader/loader.component';
import { ChatHistorySelectionComponent } from '../../chat-history-selection/chat-history-selection.component';
import { PollingDialogComponent } from '../polling-dialog/polling-dialog.component';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { ChatViewerComponent } from '../chat-viewer/chat-viewer.component';


export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Component({
  selector: 'app-prompt-create',
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    CdkAccordionModule,
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
    MatSidenavModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    ButtonComponent,
    DragDropModule,
    DateTimeFormatterPipe,
    ContenteditableDirective,
    MatTooltipModule,
    LoaderComponent,
    PdfViewerComponent,
    ChatViewerComponent
  ],
  templateUrl: './prompt-create.component.html',
  styleUrl: './prompt-create.component.scss'
})
export class PromptCreateComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('chatContainer') chatContainer!: ElementRef;
  @ViewChild('promptInputText', { static: false }) promptInputText!: ElementRef;
  @ViewChild('otherAttachmentsContainer') otherAttachmentsContainer!: ElementRef;

  @ViewChild('pageInput') pageInput!: HTMLInputElement;
  
  promptDetails = new FormControl();
  title = new FormControl()
  showTitle: boolean = true;
  perminentAttachment = new FormControl();
  attachment = new FormControl();
  attachments: any[] = [];
  perminentAttachments: any[] = [];
  savedData: any;
  subcategories: any;
  enableSubmit: boolean = true;
  categories: any = [];
  userid: any;
  modal: any;
  category_id: any = [];
  sub_category_id: any = [];
  createdbyarray: any;
  onMyFavouriteClick: boolean = false;
  onMyPromptsClick: boolean = false;
  user_role: any;
  status: any = [];
  promptText: string = '';
  pdfText: any;
  promptQuestion: string = '';
  projectCode: string = '';
  promptRow: number = 1; // Start with auto height
  promptMaxRow: number = 7;
  isMultiText: boolean = false;
  shrinkFooter: boolean = false;
  fileNames: any = [];
  passedFileNames: any = [];
  enableChatPrompt: boolean = false;
  messages: any = [];
  promptResponse: any;
  typingInterval: any;
  typingInProgress: boolean = false;
  chatId: any;
  isPromptRunning: boolean = false;
  urlParams: any;
  isSidebarOpen = false;
  expandedState: boolean[] = [];
  chatHistory: any[] = [];
  description!: string;
  notes!: string;
  promptId: any = null;
  promptDetailsId: any = null;
  tempAttachements: any;
  isS3ApiCalled: boolean = false;
  isUpdateChatCalled: boolean = false;
  timeOutCounterLimit: number = 360;
  showTooltip1:boolean =false;
  myForm: FormGroup;
  tabs: { label: string, myForm: FormGroup ,originalValues?:any}[] = [];
  originalTabs: any = {}; // Store old values
  isChanged: boolean = false; // Track changes
  model_issue:boolean=false;

  chainpromptdata: any = [];
  disabledelete: boolean = false;
  fordeletobj: any;
  notsubmit: boolean = false;
  // prompt_status: string | null | undefined;promptDetailsStored
  showRejectedInfo: boolean = false;
  showRevokedInfo: boolean = false;
  rejectedPromptDetails: any = {};
  promptDetailsStored: any;
  isEditPrompt: boolean = false;
  newAttachmentFiles: any[] = [];
  generateLoadingText: string = "Generating...";
  createTitle: string = "Create Prompt";
  isExpansion: boolean = false;
  chatHistoryData: any = [];
  isDraft: boolean = false;

  pollingInterval: any;
  pollingRunPromptInterval:any;
  currChatId = signal<{ chat_id: string, message_id: string }>({ chat_id: "", message_id: "" })
  getPromptAnswerLimit: number = 0;
  getPromptRunLimit: number = 0;
  timeOutCounterRunLimit: number = 120;
  models = signal<{ id: number, name: string, value: string }[]>([]);
  selectedModels = signal<{ id: number, name: string, value: string }[]>([]);
  selectedModelId: { id: number, name: string, value: string } | null = null;
  defaultSelectedModelId: { id: number, name: string, value: string } | null = null;
  promptModified = signal<boolean>(false)
  showUnsavedDataChanges = signal<boolean>(false)
  showPromptInstruction = false;
  showVariableInstruction =false;
  showTooltipInstruction = false;
  isVariableScrollable = true;
  isLoading: boolean = false;
  hideTimeout: any;
  pollingDialogRef: any;
  showVersionInstruction=false;
  version_reason:string='';
  created_from:string='';
  tooltipStyle: { [key: string]: string } = {};
  forType='';
  showVariantInstruction:boolean=false;
  variant_created_from:string='';
  variant_reason:string='';
  SELECTED_CHAT_HISTORY_ID:string='';
  estimated_time: number = 0.00;

  constructor(private snackBar: MatSnackBar, private fb: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private promtUserService: PromtUserService, private promptCreateService: PromptCreateService, private dailog: MatDialog, private dashboardService: DashboardService, private sanitizer: DomSanitizer, private eRef: ElementRef, private renderer: Renderer2

  ) {
    // const urlParams =this.router.url.split('?role=');
    this.activatedRoute.queryParams.subscribe((params) => {
      this.urlParams = params;
      

    })

    if (this.urlParams && this.urlParams['role'] === 'creator') {
      // this.enableSubmit = false;
    }

    if (this.urlParams && this.urlParams['for']) {
       this.forType=this.urlParams['for'];
    }
    this.myForm = this.fb.group({
      promptDetails: "",
      title: '',
      attachment: [null],
      perminentAttachment: [null],  // Initialize the file control
      variables: this.fb.array([]),
      variablesCopy: this.fb.array([]),
      gptQuestion: "",
      gptModelID: null,
      notes:"",
    });
  }

  selectedTabIndex = 0;
  ngOnInit(): void {
    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;
    if (localStorage.getItem("hasProjectCode")) {
      this.docsCleanup(localStorage.getItem("hasProjectCode") || "");
      localStorage.removeItem("hasProjectCode");
    }
    this.getAllCate("", this.userid, this.modal, this.category_id, this.sub_category_id, this.createdbyarray, this.onMyFavouriteClick, this.onMyPromptsClick, this.user_role, this.status);
    setTimeout(() => {
      if (this.urlParams['create'] === "Y") {
        this.addTab();
        this.promptCreateService.promptSaveResp$.next(null)
      } else {
        
        this.getPromptDetails();
      }
    }, 300);
    this.promptCreateService.promptSaveResp$.subscribe(resp => {
      if (resp) {
        
        this.fordeletobj = resp
      }

    });

     // Check for changes and enable Save button accordingly

    
   
     
    //   this.tabs.forEach(tab=>tab.myForm.valueChanges.subscribe(() => {

    //     this.isChanged =
    //       JSON.stringify(tab.myForm.value) !== JSON.stringify(this.oldValues);
    //   }));

    
    //   this.tabs.forEach((tab, i) => {
    //     tab.myForm.valueChanges.subscribe(() => {
  
    //       this.isChanged = JSON.stringify(tab.myForm.value) !== JSON.stringify(this.oldValues[i].value);
    //     });
    //   });
    //  this.myForm.valueChanges.subscribe(() => {
   
    //   this.isChanged =
    //     JSON.stringify(this.myForm.value) !== JSON.stringify(this.oldValues);
    // });
    // this.myForm.valueChanges.subscribe(() => {
        //   this.isChanged =
    //     JSON.stringify(this.myForm.value) !== JSON.stringify(this.oldValues);
    // });

    this.getModel();
    // setTimeout(() => {
    //   this.copyChatHistory();
    // }, 5000)

    this.variableChangeSubject.pipe(debounceTime(300)).subscribe(({ index, newValue, isDropdown, tabPositionIndex, vLabel }) => {
      this.handleVariableInit(index, newValue, isDropdown, tabPositionIndex, vLabel);
    });
  }

  ngAfterViewInit() {
    this.tags.changes.subscribe(() => {
        
        this.updateInputOffset();
    });
  }


  // isAnyFormDirty():boolean{

  //   return this.tabs.some(tab=>tab.myForm.dirty);
  // }

  // isAnyFormDirty(): boolean {
  //   return this.tabs.some(tab => 
  //     //JSON.stringify(tab.myForm.value) !== JSON.stringify(tab.originalValues)
  //   tab.myForm.value.notes !== tab.originalValues.notes ||
  //   tab.myForm.value.title !== tab.originalValues.title ||
  //   tab.myForm.value.promptDetails !== tab.originalValues.promptDetails ||
  //   tab.myForm.value.attachment !== tab.originalValues.attachment
  //   );
  // }

  isAnyFormDirty(): boolean {
    // Check if the number of tabs has changed
    const isTabDeleted = this.tabs.length < this.originalTabs.length;
  
    // Check if any tab's form fields have changed
    const isFormChanged = this.tabs.some(tab => 
      tab.myForm.value?.notes !== tab.originalValues?.notes ||
      tab.myForm.value?.title !== tab.originalValues?.title ||
      tab.myForm.value?.promptDetails !== tab.originalValues?.promptDetails ||
      tab.myForm.value?.attachment !== tab.originalValues?.attachment
    );
  
    return isTabDeleted || isFormChanged;
  }
  

  getModel() {
    this.dashboardService.getModel().subscribe({
      next: (model) => {
        if (model.status_code == 200) {
          let model_data = model.data.map((item: any) => ({ id: item.id, name: item.name, value: item.value }))
          this.models.set(model_data);

          // Set the initial value after updating models
          
          if (model_data.length > 0) {
             this.selectedModels().push(model_data[0]);
             this.selectedModelId = model_data[0];
             this.defaultSelectedModelId = model_data[0];
            if( this.promptDetailsStored ){
              this.promptDetailsStored?.data?.prompt_details?.forEach(((data:any,index:number)=>{
                // let {model_id,model_name}= data?.[index]?.llm;
                // this.selectedModels()[index]=this.models().find(model=>model.id === model_id);
                let llm = data?.[index]?.llm;
                if(llm) {
                  const { model_id, model_name } = llm;
                  this.selectedModels.update((arr) => {
                    return arr.map((item, i) => 
                      i === index ? this.models().find(model => model.id === model_id) || item : item
                    );
                  });
                }
              }))
              const  {model_id,model_name }= this.promptDetailsStored?.data?.prompt_details?.[this.selectedTabIndex]?.llm ?? null ;
              this.selectedModelId=this.models().find(model=>model.id === model_id)?? null;
              this.defaultSelectedModelId = this.selectedModelId;
              
            }
          }
          
        }
      },
      error: (err) => { console.log(err) },
      complete: () => { }
    })
  }

  onSelectionChange(event: any) {
    this.selectedModels()[this.selectedTabIndex]=event?.value;
    this.selectedModelId=event?.value;
    

    this.tabs[this.selectedTabIndex].myForm.patchValue({
      gptModelID: this?.selectedModelId?.id
    });
  }

  // Comparison function for `compareWith`
  compareById(model1: { id: number; name: string }, model2: { id: number; name: string }): boolean {
    return model1 && model2 && model1.id === model2.id;
  }

  toggleDropdown(select: MatSelect): void {
    if (select.panelOpen) {
      select.close(); // Close the dropdown if it's open
    } else {
      select.open(); // Open the dropdown if it's closed
    }
  }

  addTab() {
    const newIndex = this.tabs.length + 1;
    this.myForm = this.fb.group({
      promptDetails: "",
      title: '',
      attachment: [null],
      perminentAttachment: [null],
      variables: this.fb.array([]),
      variablesCopy: this.fb.array([]),
      gptQuestion: "",
      gptModelID: null,
      notes:"",
    });
    this.tabs.push({ label: `Prompt ${newIndex}`, myForm: this.myForm });
    this.selectedTabIndex = newIndex - 1
    this.isButtonDisabled();
    if(this.tabs.length > 1) {
      this.promptModified.set(true);
    }

    this.chatHistory = []
    if(this.models().length>0){
    this.selectedModels().push(this.models()[0]);
   
    }
  }

  promptVariableResetHandler(event: Event) {
    const variablesArray = this.tabs[this.selectedTabIndex].myForm.get('variables') as FormArray;
    variablesArray.clear();
    

    const variablesCopyArray = this.tabs[this.selectedTabIndex].myForm.get('variablesCopy') as FormArray;
    variablesCopyArray.clear();
    this.parsePromptText(this.selectedTabIndex);
  }

  // getSafeHtml(content: string): SafeHtml {
  //   return this.sanitizer.bypassSecurityTrustHtml(content);
  // }

  // renderBotMsg(content: any) {
  //   content.map((msg: any) => {
  //     if (!msg.isPrompt) {
  //       const rawHtml = marked(msg.value);
  //       msg.safeValue = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
  //       // this.safeMessage.set(this.sanitizer.bypassSecurityTrustHtml(msg.value))
  //       setTimeout(() => {
  //         this.scrollToBottom();
  //       }, 50);
  //     }
  //   })
  // }

  @ViewChild('tooltipRef') tooltipRef!: ElementRef;

  citationTooltipVisible: boolean = false;
  citationTooltipTitle: string = '';
  citationTooltipPresignedTitle: string = '';
  citationTooltipContent: string = '';
  citationTooltipStyle: any = {};
  citationType: string = '';
  citationPromptId: number = 0;
  citationPromptVersionId: number = 0;
  citationPromptNumber: number = 0;
  citationFullChat: boolean = true;
 
  showPdfViewer: boolean = false;
  citationPresignedUrl: string = '';
  citationDocumentName: string = '';
  citationCoordinates: any = [];

  // showChatViewer: boolean = false;
  showChatViewer: WritableSignal<boolean> = signal(false)
  citationChatData: {} = {};
  citationChatId: string = '';
  citationVariableData: string = '';

  async renderBotMsg(content: any) {
    
    for (const msg of content) {
      if (!msg.isPrompt) {
        try {
          // Resolve the value if it's a Promise
          const value = await Promise.resolve(msg.value);
          // Parse the Markdown into raw HTML
          let rawHtml: string = value ? await marked(value) : '';

          // Replace placeholders with icons and event handlers
          rawHtml = rawHtml.replace(/\[\^(\d+)\^\]/g, (match, citationKey) => {
            const citation = msg.citations[match]; // citations["[^1^]"], citations["[^2^]"], etc.
            if (!citation) return match; // If no match, return as-is

            let iconHtml = '';
            if (citation.type === "document") {
                let doc_name = citation.document_name;
                let pdf_presigned_title = citation.document_name;
                if(citation.selected_pages?.length > 0) {
                  pdf_presigned_title = citation.selected_pages.join("_") + '_' + citation.document_name
                }
                iconHtml = `<img class="citation-icon" src="/assets/icons/document.svg" alt="PDF" data-type="document" data-id="${citationKey}" data-citation-title="${doc_name}" data-citation-presigned-title="${pdf_presigned_title}" data-citation-value="${citation.highlight_content}" data-citation-coordinates="${JSON.stringify(citation.coordinates).replace(/"/g, '&quot;')}" />`;
            } else if (citation.type === "chat_history") {
                iconHtml = `<img class="citation-icon" src="/assets/icons/chat-doc-icon.svg" alt="Chat" data-type="chat_history" data-id="${citationKey}" data-citation-title="${citation.chat_name}" data-citation-prompt-version-id="${citation.prompt_detail_version_id}" data-citation-prompt-id="${citation.prompt_id}" data-citation-chat-id="${citation.chat_id}" data-citation-value="${citation.highlight_content}" />`;
            } else if (citation.type === "variable_input") {
              iconHtml = `<img class="citation-icon" src="/assets/icons/variable_input_icon.svg" alt="Chat" data-type="variable_input" data-id="${citationKey}" data-citation-title="${citation.variable_name}" data-citation-prompt-version-id="${citation.prompt_detail_version_id}" data-citation-prompt-id="${citation.prompt_id}" data-citation-chat-id="${citation.chat_id}" data-citation-value="${citation.highlight_content}" data-variable-data="${JSON.stringify(citation.variable_value).replace(/"/g, '&quot;')}" />`;
            }

            return `<span class="citation-icon-wrap" data-id="${citationKey}" data-type="${citation.type}">${iconHtml}</span>`;
          });

          
          // Sanitize the HTML
         
          msg.safeValue = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
          
          // Scroll to the bottom after rendering messages
          setTimeout(() => {
            this.scrollToBottom();
            this.addClickEvents();
          }, 50);
        } catch (error) {
          console.error('Error processing message:', error);
          msg.safeValue = 'Error rendering message';
        }
      }
    }
  }

  addClickEvents() {
    const icons = this.eRef.nativeElement.querySelectorAll('.citation-icon');
    icons.forEach((icon: HTMLElement) => {
      this.renderer.listen(icon, 'mouseenter', (event) => {
        event.preventDefault();
        const fileId = icon.getAttribute('data-id') ?? ''; // Default to empty string
        const fileType = icon.getAttribute('data-type') ?? '';
        const citationTitle = icon.getAttribute('data-citation-title') ?? '';
        const citationPresignedTitle = icon.getAttribute('data-citation-presigned-title') ?? '';
        const citationValue = icon.getAttribute('data-citation-value') ?? '';
        const citationPromptId =  icon.getAttribute('data-citation-prompt-id') ?? 0;
        const citationPromptVersionId = icon.getAttribute('data-citation-prompt-version-id') ?? 0;
        const citationChatId = icon.getAttribute('data-citation-chat-id') ?? '';
        const citationVariableData = icon.getAttribute('data-variable-data') ?? '';
        let citationCoordinates;
        const coords = icon.getAttribute('data-citation-coordinates');
        if (coords) {
          citationCoordinates = JSON.parse(coords);
        }

        this.citationTooltipTitle = citationTitle || '';
        this.citationTooltipPresignedTitle = citationPresignedTitle || '';
        this.citationTooltipContent = citationValue || '';
        this.citationTooltipVisible = true;
        this.citationType = fileType;
        this.citationPromptId = Number(citationPromptId);
        this.citationPromptVersionId = Number(citationPromptVersionId);
        this.citationChatId = citationChatId;
        this.citationCoordinates = citationCoordinates;
        this.citationVariableData = citationVariableData;
        this.positionTooltip(event.target as HTMLElement);
      });
    });
  }

  positionTooltip(target: HTMLElement) {
    // const rect = target.getBoundingClientRect();
    // const tooltipHeight = 90;
    // const tooltipWidth = 300;
    // const padding = 10;
  
    // const fitsAbove = rect.top >= tooltipHeight + padding;
    // const fitsBelow = window.innerHeight - rect.bottom >= tooltipHeight + padding;
  
    // const top = fitsAbove
    //   ? rect.top - tooltipHeight - padding
    //   : fitsBelow
    //   ? rect.bottom + padding
    //   : rect.top;
  
    // const left = Math.min(
    //   Math.max(rect.left - tooltipWidth / 2 + rect.width / 2, padding),
    //   window.innerWidth - tooltipWidth - padding
    // );
  
    // this.citationTooltipStyle = {
    //   top: `${top}px`,
    //   left: `${left}px`,
    // };

    const windowInnerHeight = window.innerHeight;
    const rect = target.getBoundingClientRect();

    let varCardPosition = (windowInnerHeight - rect.top) - rect.height - 90;
    let transVarCardTopPosition: number = 0;
    if(varCardPosition < 0) {
      transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 90;
    } else {
      transVarCardTopPosition = rect.top - rect.height - 90
    }

    let varCardHozPosition = window.innerWidth - rect.left - 300
    if(varCardHozPosition < 0) {
      varCardHozPosition = rect.left - Math.abs(varCardHozPosition) - 60;
    } else {
      varCardHozPosition = rect.left - 150
    }

    this.citationTooltipStyle = {
      top: `${transVarCardTopPosition}px`,
      left: `${varCardHozPosition}px`,
    };
  }

  async handleCitationPanel(type: string, title: string, promptId: number, promptVersionId: number) {
    this.showPdfViewer = false;
    if(type == 'document') {
      this.isLoading = true;

      // Get the file extension to check it it's a Word document
      const fileExtension: string = (() => {
        if (typeof title !== 'string') return '';
        const ext = title.split('.').pop();
        return ext ? ext.toLowerCase() : '';
      })();
      let fileName = title;
      // If it's a Word document, use the PDF version instead
      if(['docx', 'doc', 'rtf'].includes(fileExtension)) {
        // Replace the extension with .pdf
        fileName = title.substring(0, title.lastIndexOf('.')) + '.pdf';
      }

      const presSignedUrlRequest = {
        prompt_id: this.promptDetailsStored?.data?.prompt_id,
        title: this.tabs[this.selectedTabIndex].myForm.value.title,
        url_type: 'get_object',
        prompt_detail_id: this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id,
        attachment_type: "other_attachments",
        file_name: title, // Use the PDF file name for Word documents
        user_id: this.userid
      }

      const response = await this.promptCreateService.getPresignedUrl(presSignedUrlRequest).toPromise();

      if(response.status_code == 200) {
        this.isLoading = false;
        this.showPdfViewer = true;
        this.citationPresignedUrl = response.data.url
        // this.citationDocumentName = title
        this.citationDocumentName = this.citationTooltipTitle
        

        // this.citationCoordinates = [{

        //             "Width": 0.4215604364871979,

        //             "Height": 0.011238890700042248,

        //             "Left": 0.5212028622627258,

        //             "Top": 0.36133435368537903,

        //             "Page": 2

        //         }]
      }

   
    } else if(type == 'chat_history') {
      this.showChatViewer.set(false);
      // let  filteredChatsParams = this.chatHistoryData.flatMap((chatHistory: any) =>
      //   chatHistory.prompt_variables.chat_history
      //     .filter((chat: any) => chat.chat_id == this.citationChatId)
      //     .map((chat: any) => ({
      //       chat_id: chat.chat_id,
      //       messages_selected: chat.messages_selected,
      //       prompt_detail_version_id: chat.prompt_detail_version_id,
      //       prompt_id: chat.prompt_id
      //     }))
      // );
      let  filteredChatsParams = this.chatHistoryData
          .filter((item: any) => item.id == this.SELECTED_CHAT_HISTORY_ID)
          .flatMap((chatHistory: any) =>
            chatHistory.prompt_variables.chat_history
          .filter((chat: any) => chat.chat_id == this.citationChatId)
          .map((chat: any) => ({
            chat_id: chat.chat_id,
            messages_selected: chat.messages_selected,
            prompt_detail_version_id: chat.prompt_detail_version_id,
            prompt_id: chat.prompt_id
          })));

      const getChatsParams = filteredChatsParams.length > 0
      ? filteredChatsParams
      : [{
          chat_id: this.citationChatId,
          messages_selected: [],
          prompt_detail_version_id: this.citationPromptVersionId,
          prompt_id: this.citationPromptId
        }];

      

      // this.promptCreateService.getChatsById({id: this.citationChatId}).subscribe({
      this.promptCreateService.getChatsById(getChatsParams[0]).subscribe({
        next: (res) => {
          if(res.data.messages.length > 0) {
            this.showChatViewer.set(true);
            this.citationChatData = res.data.messages
            this.citationTooltipTitle = res.data.name
            this.citationPromptNumber = this.promptDetailsStored.data.prompt_details.findIndex((item: any) => item.prompt_detail_id == res.data.prompt_detail_version_id) + 1
            this.citationFullChat = res.data.is_full_chat_history_input
          }
        },
        error: (err) => {
          this.openSnackbar('Unable to get citation value', 'An error occurred', 'error-snackbar')
        },
      });
    } else if(type == "variable_input") {
      this.showChatViewer.set(false);
      if(this.citationVariableData) {
        setTimeout(() => {
          this.showChatViewer.set(true);
        }, 50)
      }
    }
  }

  getPromptDetails() {
    
    this.promtUserService.getPromptUser(
      this.promtUserService.prompt_id,
      this.promtUserService.user_id).subscribe((promptDetails: any) => {
      
        this.isEditPrompt = true;
        this.promptDetailsStored = promptDetails;
        
       
        if(this.selectedTabIndex == 0 || this.selectedTabIndex ){
          
          const  {model_id,model_name }= this.promptDetailsStored?.data?.prompt_details?.[this.selectedTabIndex]?.llm ?? null ;
          this.selectedModelId=this.models().find(model=>model.id === model_id)?? null;
         
        }
        this.selectedModels.set([]);
        for(let i=0;i<this.promptDetailsStored?.data?.prompt_details?.length;i++){
          const  {model_id,model_name }= this.promptDetailsStored?.data?.prompt_details?.[i]?.llm ;
          let val=this.models().find(model=>model.id == model_id);
          if(val){
          this.selectedModels().push(val)
          }
       
        }

        
        if (promptDetails?.data?.prompt_details[0]?.status === "DRAFT" || promptDetails?.data?.prompt_details[0]?.status === "REJECTED" || promptDetails?.data?.prompt_details[0]?.status === "PUBLISHED" || promptDetails?.data?.prompt_details[0]?.status === "REVOKED") {
          this.rejectedPromptDetails = promptDetails?.data;
          // this.prompt_status = localStorage.getItem('prompt_status');
          if (promptDetails?.data?.prompt_details[0]?.status === "REJECTED") {
            this.showRejectedInfo = true;
          } else {
            this.showRejectedInfo = false;
          }
          if (promptDetails?.data?.prompt_details[0]?.status === "REVOKED") {
            this.showRevokedInfo = true;
          } else {
            this.showRevokedInfo = false;
          }
          this.createTitle = promptDetails?.data?.title || "Create Prompt";
          this.estimated_time = promptDetails?.data?.estimated_time || 0.00;
          promptDetails?.data?.prompt_details.map((data: any, index: number) => {

            data?.attachments.map((attachment: any) => (this.attachments.push({ "selected": { "name": attachment }, "index": index }))) ?? [];
            data?.permanent_attachments.map((attachment: any) => (this.perminentAttachments.push({ "selected": { "name": attachment }, "index": index }))) ?? [];
            this.title.setValue(promptDetails?.data?.title);
            this.category_id = promptDetails?.data?.category ? { name: promptDetails?.data?.category?.category_name, value: promptDetails?.data?.category?.category_id } : null;
            this.sub_category_id = promptDetails?.data?.sub_category ? { name: promptDetails?.data?.sub_category?.sub_category_name, value: promptDetails?.data?.sub_category?.sub_category_id } : null;
            this.subcategories = promptDetails?.data?.sub_category ? this.categories.find((category: any) => category?.name === promptDetails?.data?.category?.category_name)?.value?.subcategories : [];
            this.description = promptDetails?.data?.description;
            this.notes = promptDetails?.data?.notes;
            this.promptId = promptDetails?.data?.prompt_id;
            this.promptDetailsId = data?.prompt_detail_id;
            const newIndex = this.tabs.length + 1;
            // this.oldValues={
            //   promptDetailsId: this.promptDetailsId,
            //   promptDetails: data?.prompt,
            //   title: promptDetails?.data?.prompt_details.length == 1 ? promptDetails?.data?.title:data?.prompt_name,
            //   notes: data?.notes,
            //   //  attachment:[null], 
            //   attachment: [this.attachments.filter((attachment: any) => attachment.index === index && attachment.selected)], // Only push selected attachments
            //   perminentAttachment: [null],
            //   variables: this.fb.array((data?.variables || []).map((variable: string) => this.fb.control(variable))),
            //   variablesCopy: this.fb.array([]),
            //   gptQuestion: "",
            //   gptModelID: data.llm.model_id
            // };
            // this.myForm = this.fb.group({
            //   promptDetailsId:[this.oldValues.promptDetailsId],
            //   promptDetails: [this.oldValues.promptDetails],
            //   title: [this.oldValues.title],
            //   notes: [this.oldValues.notes],
            //   //  attachment:[null], 
            //   attachment: [this.oldValues.attachment], // Only push selected attachments
            //   perminentAttachment: [this.oldValues.perminentAttachment],
            //   variables: [this.oldValues.variables],
            //   variablesCopy: [this.oldValues.variablesCopy],
            //   gptQuestion: [this.oldValues.gptQuestion],
            //   gptModelID: [this.oldValues.gptModelID],
            // });

            this.myForm = this.fb.group({
              promptDetailsId: this.promptDetailsId,
              promptDetails: data?.prompt,
              title: promptDetails?.data?.prompt_details.length == 1 && !this.forVersioningCheck() ? promptDetails?.data?.title:data?.prompt_name,
              notes: data?.notes,
              //  attachment:[null], 
              attachment: [this.attachments.filter((attachment: any) => attachment.index === index && attachment.selected)], // Only push selected attachments
              perminentAttachment: [null],
              variables: this.fb.array((data?.variables || []).map((variable: string) => this.fb.control(variable))),
              variablesCopy: this.fb.array([]),
              gptQuestion: "",
              gptModelID: data.llm.model_id
            });

            // Store the original values
            const originalValues = { ...this.myForm.value }; 
            this.tabs.push({ label: `Prompt ${newIndex}`, myForm: this.myForm ,originalValues: originalValues  });

            
            let lastSelectedIndex= promptDetails?.data?.lastselectedTabIndex;
            if(lastSelectedIndex){
              this.selectedTabIndex = lastSelectedIndex;//promptDetails?.data?.lastselectedTabIndex;
            }
            this.isButtonDisabled();
            this.parsePromptText(index);
            this.isEditPrompt = true;
            //this.onRunPrompt();
          })

          this.originalTabs = [...this.tabs]; // Clone the original tabs array
          //this.oldValues= this.tabs.map(tab=>tab.myForm.value);
          
          
          this.isDraft = true;
          let prompt_id = this.promptDetailsStored?.data?.prompt_id;
          let prompt_detail_id = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id;
          
          this.fetchChats(prompt_id, prompt_detail_id);
      
           //if it is for versioning disable title
        // if(this.promptDetailsStored?.data?.status == "PUBLISHED" || this.promptDetailsStored?.data?.version >0){
        //   this.tabs.forEach(element => {
        //     element?.myForm?.get('title')?.disable();
        //   });
        // }
       

          //     if(promptDetails?.data?.prompt_details?.length > 0){
          //   this.promptDetailsId = promptDetails?.data?.prompt_details[0]?.prompt_detail_id;
          //   this.promptDetails.setValue(promptDetails?.data?.prompt_details[0]?.prompt);
          //     }
          //     // this.promptDetails.setValue(promptDetails?.data?.description);
          // this.attachments = promptDetails?.data?.prompt_details[0]?.attachments.map((attachment: any) => ({name: attachment})) ?? [];
          // this.perminentAttachments = promptDetails?.data?.prompt_details[0]?.permanent_attachments.map((attachment: any) => ({name: attachment})) ?? [];
        }
      });
  }





  drop(event: CdkDragDrop<string[]>) {
    const prevActive = this.tabs[this.selectedTabIndex];

    moveItemInArray(this.tabs, event.previousIndex, event.currentIndex);


    this.selectedTabIndex = this.tabs.indexOf(prevActive);
 
    if(event){
      moveItemInArray(this.selectedModels(), event.previousIndex, event.currentIndex);
    }

    //this.perminentAttachments.push({"selected":selectedFiles[i],"index":index});
   
    let temp: any[] = [];
    let temp1: any[] = []
    this.perminentAttachments.map((file: any) => {

      if (file.index == event.previousIndex) {
        file.index = event.currentIndex
      } else if (file.index == event.currentIndex) {
        file.index = event.previousIndex
      }
      temp.push(file);
    })
    this.perminentAttachments = temp;
    this.attachments.map((file: any) => {

      if (file.index == event.previousIndex) {
        file.index = event.currentIndex
      } else if (file.index == event.currentIndex) {
        file.index = event.previousIndex
      }
      temp1.push(file);
    })
    this.attachments = temp1

  }

  // drop(event: CdkDragDrop<string[]>) {
  //   const prevActive = this.tabs[this.selectedTabIndex];
  //   moveItemInArray(this.tabs, event.previousIndex, event.currentIndex);
  //   this.selectedTabIndex = this.tabs.indexOf(prevActive);
  // }

  removeTab(index: number,title:any) {
    let titleName = '';
    if (title && title != '') {
      titleName = title;
    } else {
      titleName = `Prompt ${index + 1}`;
    }
    const dialogRef = this.dailog.open(OnPromptDeleteComponent, {
      data: {
        promptId: 1,
        title: titleName,
        removeTab: true
      },
      height: '400px',
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((resp:any) => {
      titleName = '';
      if(resp == 'remove') {
        this.tabs.splice(index, 1);
        this.selectedTabIndex = this.tabs.length - 1
  
        let tempres = null;
        if (this.fordeletobj) {
          this.fordeletobj.prompt_details.splice(index, 1);
          this.promptCreateService.promptSaveResp$.next(this.fordeletobj);
        }
        this.tabs.forEach((item: any, i) => {
          item.label = "Prompt " + (i + 1)
        })
    
        //delete a element by given index.
        this.selectedModels.update(items => items.filter((_, i) => i !== index));
      
        if(this.tabs.length == 1 && this.forVersioningCheck()){
          this.tabs[0].myForm.get('title')?.setValue(this.createTitle);
      }
      }
    })

  }
  onEdit() {
    this.showTitle = false;
  }
  isDragOver = false;

  onDragOver(event: any, uploadType: string, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: any, uploadType: string, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: any, uploadType: string, index: number) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;


    if (event.dataTransfer?.files) {
      const droppedFiles = Array.from(event.dataTransfer.files);
     
      this.onFileChange(event, uploadType, index)
    }
  }

  // onFileChange(event: any, uploadType: string , index : number) {
  //   let get_file_extension_re = /(?:\.([^.]+))?$/;
  //   if(event.target.files) {
  //     const  selectedFiles  = event.target.files;
  //     for (let i = 0; i < selectedFiles.length; i++) {
  //       if (uploadType === 'perminentAttachments') {
  //         if(this.perminentAttachments.some((existingFile) => existingFile.selected.name === selectedFiles[i]?.name)) {
  //           alert(`duplicate permanent attachment', ${selectedFiles[i]?.name}`)
  //           break;
  //         }
  //         let file_extension: string | null = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || null;
  //         this.perminentAttachments.push({"selected":selectedFiles[i],"index":index, "file_type": file_extension});
  //         // this.perminentAttachments.push(selectedFiles);



  //       } else {
  //         if(this.attachments.some((existingFile) => existingFile.selected.name === selectedFiles[i]?.name)) {
  //           alert(`duplicate attachment', ${selectedFiles[i]?.name}`)
  //           break;
  //         }
  //         let file_extension: string | null = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || null;
  //         this.attachments.push({ "selected": selectedFiles[i], "index": index, "page_number": '', "file_type": file_extension });

  //         // this.tabs[index].myForm.patchValue({
  //         //   attachment: this.attachments
  //         // });
  //     

  //       }

  //     }
  //     this.otherAttachmentsContainer?.nativeElement.scrollIntoView({
  //       behavior: 'smooth',
  //       block: 'end'
  //     });
  //     let tempperment:any[]=[];
  //     tempperment= this.perminentAttachments.filter((x)=>{ 
  //       if(x.index == index){
  //         return x.selected
  //       }
  //     })
  //     this.tabs[index].myForm.patchValue({
  //       perminentAttachment: tempperment
  //     });

  //     let tempattachment:any[]=[];
  //     tempattachment= this.attachments.filter((x)=>{
  //       if(x.index == index){
  //         return x.selected
  //       }
  //     })
  //     this.tabs[index].myForm.patchValue({
  //       attachment: tempattachment
  //     });
  //   }
  //   else{
  //     const selectedFiles = event.dataTransfer.files
  //      for (let i = 0; i < selectedFiles.length; i++) {
  //     if (uploadType === 'perminentAttachments') {
  //       if(this.perminentAttachments.some((existingFile) => existingFile.selected.name === selectedFiles[i]?.name)) {
  //         alert(`duplicate permanent attachment', ${selectedFiles[i]?.name}`)
  //         break;
  //       }
  //       let file_extension: string | null = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || null;
  //       this.perminentAttachments.push({"selected":selectedFiles[i],"index":index, "file_type": file_extension});
  //    // this.perminentAttachments.push(selectedFiles);



  //     } else {
  //       if(this.attachments.some((existingFile) => existingFile.selected.name === selectedFiles[i]?.name)) {
  //         alert(`duplicate attachment', ${selectedFiles[i]?.name}`)
  //         break;
  //       }
  //       let file_extension: string | null = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || null;
  //       this.attachments.push({"selected":selectedFiles[i],"index":index, "file_type": file_extension})
  //       // this.tabs[index].myForm.patchValue({
  //       //   attachment: this.attachments
  //       // });
  //     }

  //   }
  //   this.otherAttachmentsContainer?.nativeElement.scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'end'
  //   });
  //   let tempperment:any[]=[];
  //   tempperment= this.perminentAttachments.filter((x)=>{ 
  //     if(x.index == index){
  //       return x.selected
  //     }
  //   })
  //   this.tabs[index].myForm.patchValue({
  //     perminentAttachment: tempperment
  //   });

  //   let tempattachment:any[]=[];
  //   tempattachment= this.attachments.filter((x)=>{ 
  //     if(x.index == index){
  //       return x.selected
  //     }
  //   })
  //   this.tabs[index].myForm.patchValue({
  //     attachment: tempattachment
  //   });
  //   }
  //  // this.perminentAttachments=[];


  //   // let temp:any[]= this.tabs[index].myForm.get('perminentAttachment')?.value ==null ? [] :this.tabs[index].myForm.get('perminentAttachment')?.value;
  //   // this.perminentAttachments.map((x)=>temp.push(x.selected));
  //   // this.tabs[index].myForm.patchValue({
  //   //   perminentAttachment: temp
  //   // });


  // }


  onFileChange(event: any, uploadType: string, index: number) {
    type AttachmentType = {
      file_type: string;
      index: number;
      selected: File;
      page_number: string;
    }[];
    let get_file_extension_re = /(?:\.([^.]+))?$/;
    if (event.target.files) {
      const selectedFiles = event.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        //if(selectedFiles[i]?.type === 'application/pdf'){
          if (uploadType === 'perminentAttachments') {
            let permanentAttachmentDup: AttachmentType = this.tabs[index].myForm.value.perminentAttachment || [];
            if (permanentAttachmentDup.length > 0) {
              if (
                permanentAttachmentDup.some(
                  (existingFile) => existingFile.selected.name === selectedFiles[i]?.name
                )
              ) {
                //alert(`Duplicate permanent attachment: ${selectedFiles[i]?.name}`);
                this.openSnackbar("Duplicate prompt attachment: " + selectedFiles[i]?.name, 'An error occurred', 'error-snackbar')
                break;
              } else {
                let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";
                permanentAttachmentDup.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension, "page_number": "" })
                this.tabs[index].myForm.patchValue({
                  perminentAttachment: permanentAttachmentDup
                });
                this.perminentAttachments.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension });
              }
            } else {
              let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";

              const newAttachment = {
                selected: selectedFiles[i],
                index: index,
                file_type: file_extension,
              };
              const updatedAttachments = [newAttachment];
              this.tabs[index].myForm.patchValue({
                perminentAttachment: updatedAttachments
              });
              this.perminentAttachments.push(newAttachment)
            }

            // this.perminentAttachments.push(selectedFiles); prev commented

          } else {

            let AttachmentDup: AttachmentType = this.tabs[index].myForm.value.attachment || [];
            if (AttachmentDup.length > 0) {
              if (
                AttachmentDup.some(
                  (existingFile) => existingFile.selected.name === selectedFiles[i]?.name
                )
              ) {
                //alert(`duplicate attachment', ${selectedFiles[i]?.name}`);
                this.openSnackbar("Duplicate attachment: " + selectedFiles[i]?.name, 'An error occurred', 'error-snackbar')
                break;
              } else {
                let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";
                AttachmentDup.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension, "page_number": "" })
                this.tabs[index].myForm.patchValue({
                  attachment: AttachmentDup
                });
                this.attachments.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension });
              }
            } else {
              let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";

              const newAttachment = {
                selected: selectedFiles[i],
                index: index,
                file_type: file_extension,
              };
              const updatedAttachments = [newAttachment];
              this.tabs[index].myForm.patchValue({
                attachment: updatedAttachments
              });
              this.attachments.push(newAttachment)
            }

          }
        //} else {
        //  this.openSnackbar('Only PDF files are allowed', 'An error occurred', 'error-snackbar')
        //}
      }
      event.target.value = "";
      this.otherAttachmentsContainer?.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
    else {
      const selectedFiles = event.dataTransfer.files
      for (let i = 0; i < selectedFiles.length; i++) {
        //if(selectedFiles[i]?.type === 'application/pdf'){
          if (uploadType === 'perminentAttachments') {
            let permanentAttachmentDup: AttachmentType = this.tabs[index].myForm.value.perminentAttachment || [];
            if (permanentAttachmentDup.length > 0) {
              if (
                permanentAttachmentDup.some(
                  (existingFile) => existingFile.selected.name === selectedFiles[i]?.name
                )
              ) {
                //alert(`Duplicate permanent attachment: ${selectedFiles[i]?.name}`);
                this.openSnackbar("Duplicate prompt attachment: " + selectedFiles[i]?.name, 'An error occurred', 'error-snackbar')
                break;
              } else {
                let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";
                permanentAttachmentDup.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension, "page_number": "" })
                this.tabs[index].myForm.patchValue({
                  perminentAttachment: permanentAttachmentDup
                });
                this.perminentAttachments.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension });
              }
            } else {
              let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";

              const newAttachment = {
                selected: selectedFiles[i],
                index: index,
                file_type: file_extension,
              };
              const updatedAttachments = [newAttachment];
              this.tabs[index].myForm.patchValue({
                perminentAttachment: updatedAttachments
              });
              this.perminentAttachments.push(newAttachment)
            }
          } else {
            let AttachmentDup: AttachmentType = this.tabs[index].myForm.value.attachment || [];
            if (AttachmentDup.length > 0) {
              if (
                AttachmentDup.some(
                  (existingFile) => existingFile.selected.name === selectedFiles[i]?.name
                )
              ) {
                //alert(`duplicate attachment', ${selectedFiles[i]?.name}`);
                this.openSnackbar("Duplicate attachment: " + selectedFiles[i]?.name, 'An error occurred', 'error-snackbar')
                break;
              } else {
                let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";
                AttachmentDup.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension, "page_number": "" })
                this.tabs[index].myForm.patchValue({
                  attachment: AttachmentDup
                });
                this.attachments.push({ "selected": selectedFiles[i], "index": index, "file_type": file_extension });
              }
            } else {
              let file_extension: string = get_file_extension_re.exec(selectedFiles[i].name)?.[1] || "";

              const newAttachment = {
                selected: selectedFiles[i],
                index: index,
                file_type: file_extension,
              };
              const updatedAttachments = [newAttachment];
              this.tabs[index].myForm.patchValue({
                attachment: updatedAttachments
              });
              this.attachments.push(newAttachment)
            }
          }
        //} else {
        //  this.openSnackbar('Only PDF files are allowed', 'An error occurred', 'error-snackbar')
        //}

      }
      this.otherAttachmentsContainer?.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
    this.promptModified.set(true);
  }






  deleteFile(fileIndex: number, fileType: string, tabIndex: number) {
    if (fileType === 'perminentAttachments') {
      this.perminentAttachments = this.perminentAttachments.filter(

        (_, index) => !(fileIndex === index && _.index == tabIndex)
      );
    } else {
      this.attachments = this.attachments.filter(
        (_, index) => !(fileIndex === index && _.index == tabIndex)
      );
    }

    let tempperment: any[] = [];
    tempperment = this.perminentAttachments.filter((x) => {
      if (x.index == tabIndex) {
        return x.selected
      }
    })
    this.tabs[tabIndex].myForm.patchValue({
      perminentAttachment: tempperment
    });

    let tempattachment: any[] = [];
    tempattachment = this.attachments.filter((x) => {
      if (x.index == tabIndex) {
        return x.selected
      }
    })
    this.tabs[tabIndex].myForm.patchValue({
      attachment: tempattachment
    });
  }
  goback() {
    this.promptDetails.reset();
    this.title.reset();
    this.router.navigateByUrl('/home/dashboard');
  }

  checkChanges(mode: string) {
    let getShowUnsavedData = localStorage.getItem("showUnsavedDataChanges")
    if(getShowUnsavedData == 'true') {
      this.showUnsavedDataChanges.set(true);
    }

    // if(this.urlParams['create'] === "Y") {
    //   this.tabs.forEach(item => {
    //     let item_val = item.myForm.value;
    //     if(item_val.title.trim() != "") {
    //       this.promptModified.set(true);
    //     } else if(item_val.promptDetails.trim() != "") {
    //       this.promptModified.set(true);
    //     } else if(item_val.attachment != null) {
    //       if(item_val.attachment.length > 0) {
    //         this.promptModified.set(true);
    //       }
    //     } else if(item_val.perminentAttachment != null) {
    //       if(item_val.perminentAttachment.length > 0) {
    //         this.promptModified.set(true);
    //       }
    //     } else {
    //       this.promptModified.set(false);
    //     }
    //   })
    // }

    if(this.promptModified() == true && !this.showUnsavedDataChanges()) {
      const dialogRef = this.dailog.open(ModifiedChangesComponent, {
        // data: {
        //   actionType: actionType,
        //   title: title,
        //   promId: promId ? promId : this.promptUserService.prompt_id
        // },
        data: {
          mode: mode
        },
        height: '280px',
        width: '450px'
      });
  
      dialogRef.afterClosed().subscribe((result) => {
        if(result.goBack && result.mode == 'non-edit') {
          this.goback();
        }
        this.showUnsavedDataChanges.set(result.showAgain) 
        localStorage.setItem("showUnsavedDataChanges", result.showAgain)
      });    
    } else {
      this.goback();
    }
  }

  onPromptUpdate(event: any) {
    this.promptModified.set(true);
  }
  
  getAllCate(search_text: '', userid: number, modal: [], category_id: [], sub_category_id: [], createdbyarray: [], onMyFavouriteClick: boolean, onMyPromptsClick: boolean, user_role: string, status: []) {
    this.promptCreateService.getAllCate("", userid, modal, category_id, sub_category_id, createdbyarray, onMyFavouriteClick, onMyPromptsClick, user_role, status).subscribe(res => {
      res?.data?.forEach((r: any) => {
        this.categories.push({ id: r.id, name: r.name, value: r })
      })
      this.category_id = this.categories[0].id
      this.subcategories = this.categories[0]?.value?.subcategories ? this.categories[0].value.subcategories : [];

    })
  }
  onSaveClick(event: any, isInsert: boolean) {

    if(!this.forVersioningCheck() && this.forType !='variant' && !this.isAnyFormDirty()){
      this.openSnackbar('No changes detected. There is nothing to save.', 'Information', 'error-snackbar');
    }else{

    const a = this.tabs.map(tab => tab.myForm.value)

    
    if(a.length==2 && this.promptDetailsStored?.data?.prompt_details?.length==1 && this.promptDetailsStored?.data?.prompt_details[0]?.prompt_name == a[0].title){
     // if(a[0].promptDetailsId == null){  
    
      a[0].promptDetailsId=this.promptDetailsStored?.data?.prompt_details[0].prompt_detail_id;
      
      //}
    }

    let temparry: any = []
    let temattach: any = []
    let tempperm: any = []
    for (let i = 0; i < a.length; i++) {
      let temp1: any = [];
      let temp2: any = [];

      this.attachments.map((x: any) => { if (x.index == i) { temp1.push(x.selected.name) } })
      this.perminentAttachments.map((x: any) => { if (x.index == i) { temp2.push(x.selected.name) } })

      let temp = {
        prompt: a[i].promptDetails,
        prompt_name: a[i].title,
        input: null,
        // attachments: a[i].attachment?.map((name : any)=>{ return name.selected.name}),
        // permanent_attachments: a[i].perminentAttachment?.map((name : any)=>{ return name.selected.name}),
        attachments: temp1,
        permanent_attachments: temp2,
        category_id: this.savedData?.category_id,
        notes: a[i].notes,//this.savedData?.notes,
        order_number: i + 1,
        // model_id: 2,
        model_id: a[i].gptModelID ? a[i].gptModelID : this.defaultSelectedModelId?.id,
        prompt_detail_id: a[i].promptDetailsId ?? null,
        variables: a[i].variables,
        //variablesCopy: a[i].variablesCopy,
        //gptQuestion: a[i].gptQuestion
      }
      temparry.push(temp)

      this.attachments.map((x: any) => { if (x.index == i) { temattach.push(x.selected) } })
      this.perminentAttachments.map((x: any) => { if (x.index == i) { tempperm.push(x.selected) } })

    }

    
    // if(this.tabs.length == 1 && this.myForm?.get('title')){
    //   this.createTitle = this.myForm.get('title')?.value ;
    // }
    if(this.tabs.length == 1 && this.tabs[0].myForm.get('title')?.value && !this.forVersioningCheck()){
      this.createTitle = this.tabs[0].myForm.get('title')?.value ;
    
    }else if(this.tabs.length > 1 &&  this.createTitle == this.tabs[0].myForm.get('title')?.value ){
      if(!this.forVersioningCheck()){
        this.createTitle="";
      }   
    }
  

    const dialogRef = this.dailog.open(OnSaveComponent, {
      data: {

        title:this.createTitle,//this.myForm.get('title'),
        // title:  temparry.length == 1 ? this.title : "",
        categories: this.categories,
        subcategories: this.subcategories,
        promptDetails: this.promptDetails.value,
        promptInput: null,
        attachments: this.attachments,
        perminentAttachments: this.perminentAttachments,
        // category_id: this.category_id?.value ? this.category_id?.value : this.category_id,
        // sub_category_id: this.sub_category_id?.value ? this.sub_category_id?.value : this.sub_category_id,
        category_id: this.category_id?.value,
        sub_category_id: this.sub_category_id?.value,
        description: this.description,
        promptId: this.promptId,
        promptDetailsId: this.promptDetailsId,
        notes: this.notes,
        action_type: 'save',
        promptData: temparry,
        attachment: temattach,
        permenet: tempperm,
        selectedTabIndex:this.selectedTabIndex,
        'isInsert': isInsert,
        versionStatus:this.promptDetailsStored?.data?.status == "PUBLISHED" ? true :false, 
        source_prompt_id : this.promptDetailsStored?.data?.source_prompt_id,
        source_version: this.promptDetailsStored?.data?.version,
        version_reason: this.promptDetailsStored?.data?.version_reason?? "",
        version: this.promptDetailsStored?.data?.version,
        latest_version: this.promptDetailsStored?.data?.latest_version,
        variant: this.promptDetailsStored?.data?.variant,
        variant_reason: this.promptDetailsStored?.data?.variant_reason?? "",
        variant_source:this.promptDetailsStored?.data?.source_prompt_id,
        forType:this.forType,
        variant_source_id:this.promptDetailsStored?.data?.variant_source_id,
        estimated_time: this.estimated_time
        // promptData: {
        //   promptDetails: this.promptDetails.value,

        //   title: this.title,
        //   attachments: this.attachments,
        //   perminentAttachments: this.perminentAttachments,
        //   category_id: this.savedData?.category_id,
        //   description: this.savedData?.description,
        //   notes: this.savedData?.notes,
        //   action_type: 'save',
        // },
        // message:res.message,
        // action_type: 'add'
      },
    });

    dialogRef.afterClosed().subscribe((res: any) => {
  
   
      if (res?.data) {
        localStorage.removeItem("hasProjectCode");
        this.savedData = res.data;
   
        if (this.projectCode && this.projectCode.includes("temp")) {
          this.callesAfterSaveSubmit(this.projectCode);
        } else {
          if (this.chatId && !this.isUpdateChatCalled) {
           
           
            // this.updateChats(this.projectCode);
          }
        }
        this.createTitle = res.data?.prompt?.title || "Create Prompt";
        if(res?.data.prompt_details.length == 1){
      
          
          if(this.forVersioningCheck()){
          
           
          }else{
          
            this.updateTitle(res?.data?.prompt_details[0]?.prompt_name);
          }
        }
        this.notes = res.data?.prompt?.notes;
        this.description = res.data?.prompt?.description;
        // this.category_id = res.data?.prompt?.category_id;
        // this.sub_category_id = res.data?.prompt?.sub_category_id;
        
        this.estimated_time = res.data?.prompt?.estimated_time;

        this.categories.map((item: any) => {
          if(item.id == res.data?.prompt?.category_id) {
            this.category_id = {
              name: item.name,
              value: item.id
            }
            if(item.value?.subcategories.length > 0) {
              item.value?.subcategories.map((subItem: any) => {
                if(subItem.id == res.data?.prompt?.sub_category_id) {
                  this.sub_category_id = {
                    name: subItem.name,
                    value: subItem.id
                  }
                }
              })
            }
          }
        });


        // if(res.data?.prompt_details?.length == 1) {
        //   this.updateTitle(res.data?.prompt_details[0]?.prompt_name);
        // }
        //this.updateTitle(res.data?.prompt_details[0]?.prompt_name);
        //this.title=res.data?.prompt?.title;


        if(this.urlParams['create'] === "Y") {
          this.router.navigateByUrl('/home/prompt-create?role=creator')
          this.promtUserService.prompt_id = res?.data?.prompt?.id
          this.promptId = res?.data?.prompt?.id
        }
        this.promptModified.set(false);


        if(res?.data?.prompt?.source_prompt_id != null){
          this.promtUserService.prompt_id = res?.data?.prompt?.id;
          localStorage.setItem("promptId", res?.data?.prompt?.id);
       
        }


        this.promtUserService.getPromptUser(
          this.promtUserService.prompt_id,
          this.promtUserService.user_id).subscribe((promptDetails: any) => {
            this.isEditPrompt = true;
            this.promptDetailsStored = promptDetails;
            


              if (promptDetails?.data?.prompt_details[0]?.status === "DRAFT" || promptDetails?.data?.prompt_details[0]?.status === "REJECTED" || promptDetails?.data?.prompt_details[0]?.status === "REVOKED") {
                // this.tabs = [];
                // this.createTitle = promptDetails?.data?.title || "Create Prompt";
                promptDetails?.data?.prompt_details.map((data: any, index: number) => {
                  
                  this.myForm = this.fb.group({
                    ...this.tabs[index]?.myForm.value, // Keep all existing values
                    // variables: this.tabs[index].myForm.value.variables?.length > 0 ? this.tabs[index].myForm.value.variables : this.fb.array([]),
                    // variablesCopy: this.tabs[index].myForm.value.variablesCopy?.length > 0 ? this.tabs[index].myForm.value.variablesCopy : this.fb.array([]),
                    variables: this.tabs[index]?.myForm.value.variables?.length > 0 ? this.fb.array((this.tabs[index].myForm.value.variables || []).map((variable: string) => this.fb.control(variable))) : this.fb.array([]),
                    variablesCopy: this.tabs[index]?.myForm.value.variablesCopy?.length > 0 ? this.fb.array((this.tabs[index].myForm.value.variablesCopy || []).map((variableCopy: string) => this.fb.control(variableCopy))) : this.fb.array([]),
                    attachment: this.tabs[index]?.myForm.value.attachment?.length > 0 ? [this.tabs[index].myForm.value.attachment] : [null],
                    perminentAttachment: this.tabs[index]?.myForm.value.perminentAttachment?.length > 0 ? [this.tabs[index].myForm.value.perminentAttachment] : [null],
                    promptDetailsId: data.prompt_detail_id, // Update only promptDetailsId
                  });

                  this.tabs[index].myForm = this.myForm
                })
                if(isInsert) {
                  this.onInsertPrompt(event)
                }
              }
          })
      }

      if (res === true) {
        this.disabledelete = true
      }
    });

  }
  }

  forVersioning():boolean{
    if(this.promptDetailsStored?.data?.status == "PUBLISHED" || this.promptDetailsStored?.data?.version >0){
      return true;
    }else{
      return false;
    }
  }

  forVersioningCheck():boolean {
    let versionStatus=(this.promptDetailsStored?.data?.status == "PUBLISHED");
    let version=this.promptDetailsStored?.data?.version;
    if((versionStatus && this.forType == 'version') || (!versionStatus && version>0)){
      return true;
    }else{
      return false;
    }

  }
  updateTitle(newTitle: string): void {
    this.myForm.get('title')?.setValue(newTitle);
  }

  // onSubmitClick(event: any) {
  //   if (this.chainpromptdata.length <= 1) {
  //   
  //     const a = this.tabs.map(tab => tab.myForm.value)



  //     let temparry: any = []
  //     for(let i = 0 ; i< a.length ; i++) {
  //       let temp1 :any =[];
  //       let temp2 :any=[];
  //       this.attachments.map((x:any)=>{  if(x.index == i){  temp1.push(x.selected.name)  }})
  //         this.perminentAttachments.map((x:any)=>{  if(x.index == i){ temp2.push(x.selected.name)} })
  //       let temp = {
  //         prompt: a[i].promptDetails,
  //         prompt_name: a[i].title,
  //         attachments: temp1,
  //         permanent_attachments: temp2,
  //         order_number : i+1,
  //         model_id : 2,
  //         prompt_detail_id :a[i].promptDetailsId ?? null,
  //         variables: [
  //       "c7",
  //       ["c7_1", "c7_2"]
  //     ]
  //   }
  //   temparry.push(temp)

  //   this.notsubmit = false
  //   temparry.map((x:any)=>{
  //     if(x.prompt_name == '' || x.prompt == ''){
  //       this.openSnackbar("!Can't Submit. please provide the required details for the prompt", 'error', 'error-snackbar')
  //     this.notsubmit = true
  //     }
  //   })
  // }

  // if(!this.notsubmit) {

  //   const dialogRef = this.dailog.open(OnSubmitComponent, {
  //     data: {

  //        title: this.title ,
  //        categories: this.categories,
  //        subcategories: this.subcategories,       
  //         attachments: this.attachments,
  //         perminentAttachments: this.perminentAttachments,
  //         prompt_id:
  //           this.savedData !== undefined ? this.savedData?.prompt?.id : null,
  //         prompt_detail_id:
  //           this.savedData !== undefined
  //             ? this.savedData?.prompt_details?.prompt_detail_id
  //             : null,
  //         action_type: 'submit',
  //         category_id: this.category_id,
  //         sub_category_id: this.sub_category_id,
  //         description: this.description,
  //         promptId: this.promptId,
  //         promptDetailsId: this.promptDetailsId,
  //         notes: this.notes,

  //          promptData : temparry

  //       // message:res.message,
  //       // action_type: 'add'
  //     },
  //   });
  //   dialogRef.afterClosed().subscribe((res: any) => {
  //     this.savedData = res;
 
  //     if( typeof this.savedData == 'object'){
  //       this.enableSubmit = false
  //       this.router.navigateByUrl('/home/dashboard');
  //     }
  //   });

  // }

  // }



  // }

  onSubmitClick(event: any) {
    let temparry: any = []
    if (this.chainpromptdata.length <= 1) {
      const a = this.tabs.map(tab => {
        return {
          ...tab.myForm.value,
          label: tab.label
        }
      })

      //let temparry: any = []
      for (let i = 0; i < a.length; i++) {
        let temp1: any = [];
        let temp2: any = [];
        this.attachments.map((x: any) => { if (x.index == i) { temp1.push(x.selected.name) } })
        this.perminentAttachments.map((x: any) => { if (x.index == i) { temp2.push(x.selected.name) } })
        let temp = {
          prompt: a[i].promptDetails,
          prompt_name: a[i].title,
          attachments: temp1,
          permanent_attachments: temp2,
          order_number: i + 1,
          notes:a[i].notes,
          // model_id: 2,
          model_id: a[i].gptModelID ? a[i].gptModelID : this.defaultSelectedModelId?.id,
          prompt_detail_id: a[i].promptDetailsId ?? null,
          //variables: ["c7", ["c7_1", "c7_2"]],
          prompt_variables: a[i].variables,
          label: a[i].label
        }
        temparry.push(temp)
      }

      this.notsubmit = false

      let errorMessages: string[] = [];
      temparry.map((x: any, index: number) => {
        if (x.prompt_name == '' || x.prompt == '') {
          //this.openSnackbar("!Can't Submit. please provide the required details for the " + x.label, 'error', 'error-snackbar')
          errorMessages.push(x.label)
          this.notsubmit = true
        }
      })
      if (errorMessages.length > 0) {
        if (errorMessages.length === 1) {
          this.openSnackbar("Can't Submit. Please provide the required details for the " + errorMessages[0], 'Submission error', 'error-snackbar');
        } else if (errorMessages.length === 2) {
          this.openSnackbar("Can't Submit. Please provide the required details for the " + errorMessages.join(" and "), 'Submission error', 'error-snackbar');
        } else {
          this.openSnackbar("Can't Submit. Please provide the required details for the " + errorMessages.slice(0, -1).join(", ") + ", and " + errorMessages[errorMessages.length - 1], 'Submission error', 'error-snackbar');
        }
      }
    }

   
    if(this.tabs.length == 1 && this.tabs[0].myForm.get('title')?.value && !this.forVersioningCheck()){
      this.createTitle = this.tabs[0].myForm.get('title')?.value ;
      
    }else if(this.tabs.length > 1 &&  this.createTitle == this.tabs[0].myForm.get('title')?.value ){
      if(!this.forVersioningCheck()){
        this.createTitle="";
      } 
    }
    if (!this.notsubmit) {

      const dialogRef = this.dailog.open(OnSubmitComponent, {
        data: {

          title: this.createTitle,//this.title,
          categories: this.categories,
          subcategories: this.subcategories,
          attachments: this.attachments,
          perminentAttachments: this.perminentAttachments,
          prompt_id:
            this.savedData !== undefined ? this.savedData?.prompt?.id :  localStorage.getItem('prompt_id') ?? null,
          prompt_detail_id:
            this.savedData !== undefined
              ? this.savedData?.prompt_details?.prompt_detail_id
              : null,
          action_type: 'submit',
          category_id: this.category_id,
          sub_category_id: this.sub_category_id,
          description: this.description,
          promptId: this.promptId,
          promptDetailsId: this.promptDetailsId,
          notes: this.notes,
          selectedTabIndex:this.selectedTabIndex,
          promptData: temparry,
          versionStatus:this.promptDetailsStored?.data?.status == "PUBLISHED" ? true :false,
          source_prompt_id : this.promptDetailsStored?.data?.source_prompt_id,
          version_reason: this.promptDetailsStored?.data?.version_reason?? "",
          version:this.promptDetailsStored?.data?.version,
          variant: this.promptDetailsStored?.data?.variant,
          variant_reason: this.promptDetailsStored?.data?.variant_reason?? "",
          variant_source:this.promptDetailsStored?.data?.source_prompt_id,
          forType:this.forType,
          variant_source_id:this.promptDetailsStored?.data?.variant_source_id,
          source_version: this.promptDetailsStored?.data?.version,
          latest_version: this.promptDetailsStored?.data?.latest_version,
          estimated_time: this.estimated_time

          // message:res.message,
          // action_type: 'add'
        },
      });
      dialogRef.afterClosed().subscribe((res: any) => {
        this.savedData = res;
   
        localStorage.removeItem("hasProjectCode");
        if (typeof this.savedData == 'object') {
          // this.enableSubmit = false;
          if (this.projectCode && this.projectCode.includes("temp")) {
            this.callesAfterSaveSubmit(this.projectCode);
          } else {
            if (this.chatId && !this.isUpdateChatCalled) {
              this.updateChats(this.projectCode);
            }
          }
          this.createTitle = this.savedData?.prompt?.title || "Create Prompt";
          this.updateTitle(this.savedData?.prompt?.title)
          this.estimated_time = res.data?.prompt?.estimated_time;
        }

      });

    }

  }

  submit() {
    const a = this.tabs.map(tab => tab.myForm.value)

  }
  resetClick() {
    this.promptDetails.reset();
    this.attachments = [];
    this.perminentAttachments = [];
    this.title.reset();

    this.tabs[this.selectedTabIndex].myForm.reset({
      promptDetails: "",
      title: '',
      attachment: [],
      perminentAttachment: [],
      variables: this.fb.array([]),
      variablesCopy: this.fb.array([]),
      gptQuestion: ""
    })

    this.parsePromptText(this.selectedTabIndex);
  }

  showGptEditIcon = signal<boolean>(false)
  adjustHeight(): void {
    this.template_converted=false;
    
    // if(this.promptInputText) {
    //   const textarea = this.promptInputText.nativeElement as HTMLTextAreaElement
    //   if(textarea.clientHeight > 60) {
    //     this.showGptEditIcon.set(true)
    //   } else {
    //     this.showGptEditIcon.set(false)
    //   }

    // }
    
    let mainContainer = document.getElementById("rightSideChatCOntext") as HTMLElement;
    let maxHeight = Math.round(mainContainer.offsetHeight / 2);

    setTimeout(() => {
      const textarea = document.getElementById("chatPromptTextArea") as HTMLTextAreaElement;
      if(textarea == null) return; 
      //textarea.style.height = 'auto'; // Reset height to allow shrinking
      // if (textarea.scrollHeight > 21) {
      if (textarea.scrollHeight > 28) {
        this.isMultiText = true;
      } else {
        this.isMultiText = false;
      }

      if (textarea.scrollHeight > 37) {
        this.shrinkFooter = true;
      } else {
        this.shrinkFooter = false;
      }

      if (textarea.scrollHeight > maxHeight) {
        textarea.style.height = `${maxHeight}px`;
        textarea.style.overflow = `auto`;
      } else {
        textarea.style.height = 'auto'; // Reset height to allow shrinking
        textarea.style.height = `${textarea.scrollHeight}px`
        textarea.style.overflow = `hidden`;
      }

      if(textarea.scrollHeight > 100) {
        this.showGptEditIcon.set(true)
      } else {
        this.showGptEditIcon.set(false)
      }

      //textarea.scrollTop = textarea.scrollHeight;
    }, 200)
  }
  openSnackbar(message: string, title: string, cssClass: string) {
      const dialogRef = this.dailog.open(ErrorNotficationComponent, {
               data: {
                 message: message,
                 title: title,
                 action_type: 'add',
                 cssClass: cssClass
               }
             });
          
    // this.snackBar.openFromComponent(SnackBarComponent, {
    //   data: { message: message, type: type },
    //   duration: 3000, // Duration in milliseconds,
    //   horizontalPosition: 'center',
    //   verticalPosition: 'bottom',
    //   panelClass: [cssClass],
    // });
  }

  async onInsertPrompt(event: any = undefined) : Promise<void> {
    this.isLoading = true;
    this.template_converted=true;
    const selectedVariablescopy = this.tabs[this.selectedTabIndex].myForm.get('variablesCopy') as FormArray;
    const selectedVariables = this.tabs[this.selectedTabIndex].myForm.get('variables') as FormArray;

    let time=10000; // 10sec
    // Check if any variable is empty
  
    const hasEmptyVariable = selectedVariablescopy.value.some((item: any) => {
      if(item?.historyFlowStates === "inprogress") {
        return true 
      } else if(item === "" || item === null) {
        return true
      }
      return false;
    });

    if (hasEmptyVariable) {
      this.openSnackbar("Please complete the variable selection to insert and execute the prompt", 'Incomplete variable selection', 'error-snackbar');
      this.isLoading = false;
      return;
    }

    let promptDetailsId = this.tabs[this.selectedTabIndex].myForm.get('promptDetailsId')?.value;
    if(!promptDetailsId) {
      this.onSaveClick(event, true)
      this.isLoading = false;
      return;
    }

    this.isPromptRunning = true;
    let runPromptRequest: any = {};

    let otherAttachmentsList: any = this.tabs[this.selectedTabIndex].myForm.value.attachment || []
    let newOtherFiles = otherAttachmentsList.filter((item: any) => {
      if (item.selected instanceof File || item.selected instanceof Blob || item.selected instanceof ArrayBuffer) {
        return item.selected
      }
    })

    let permanentAttachmentsList: any = this.tabs[this.selectedTabIndex].myForm.value.perminentAttachment || []
    let newPermanentFiles = permanentAttachmentsList.filter((item: any) => {
      if (item.selected instanceof File || item.selected instanceof Blob || item.selected instanceof ArrayBuffer) {
        return item.selected
      }
    })

    let uploaded_files_items = otherAttachmentsList.map((file: any) => {
      return {
        file_name: file.selected?.name || '',
        selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
      }
    })
 

    let vPdfDocData = selectedVariablescopy.value.map((vItem: any) => {
        if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
          return {
            file_name: vItem?.pdfDocData?.file_name,
            selected_pages: vItem?.pdfDocData?.selected_pages,
            label_name: vItem?.pdfDocData?.label_name.replace('\n', '').trim('')
          };
        }
        return null; // Explicitly return null or undefined
      }).filter((item: any) => item !== null); // Remove null values
      

    // let merged_uploaded_files_items = uploaded_files_items.map((uploaded_file: any) => {
    //   let match = vPdfDocData.find((vPdf: any) => vPdf.file_name === uploaded_file.file_name);
    //   return match ? match : uploaded_file
    // })


    let merged_uploaded_files_items = [...vPdfDocData]
    
    uploaded_files_items.forEach((uploadedItem: any) => {
      if (!merged_uploaded_files_items.some((pdfItem: any) => pdfItem.file_name === uploadedItem.file_name)) {
        merged_uploaded_files_items.push(uploadedItem);
      }
    });
    
    if(vPdfDocData?.length == 0 || (vPdfDocData?.length > 0 && vPdfDocData.every((doc:any) => doc?.selected_pages?.length === 0))){
      time=0;
      
    }

    let passedFiles = otherAttachmentsList.map((file: any) => {
      return {
        selected: {
          name: file.selected?.name || '',
          page_number: file.page_number && file.page_number.trim() ? file.page_number : ""
        }
      }
    })

    if(!this.promptDetailsStored?.data?.prompt_id || this.promptDetailsStored?.data?.prompt_id == null) {
      let ls_project_code = localStorage.getItem('project_code');
      if(ls_project_code) {
        runPromptRequest['project_code'] = ls_project_code
      }
    }
    console.log("newOtherFiles", newOtherFiles)

    let promptDetailStoredData = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex];

    console.log("promptDetailStoredData", promptDetailStoredData)
    console.log("this.tabs", this.tabs)

    // newOtherFiles.forEach(async (newFile: any) => {
    //   if(!promptDetailStoredData.attachments.includes(newFile.selected.name)) {
    //     const presSignedUrlRequest = {
    //       prompt_id: this.promptDetailsStored?.data?.prompt_id,
    //       title: this.tabs[this.selectedTabIndex].myForm.value.title,
    //       url_type: 'put_object',
    //       prompt_detail_id: promptDetailStoredData?.prompt_detail_id,
    //       attachment_type: "attachments",
    //       file_name: newFile.selected.name,
    //       user_id:this.userid
    //     }

    //     const response = await this.promptCreateService.getPresignedUrl(presSignedUrlRequest).toPromise();
    //     if (response?.data) {
    //       const presignedUrl = response?.data?.url;
    //       const file = newFile;
    //       this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
    //         next: (res) => {
    //           console.log("Upload successful:", res);
    //         },
    //         error: (error) => {
    //           console.error("Error uploading file:", error);
    //         }
    //       });
    //     } else {
    //       console.log('Failed to get presigned URL');
    //     }

    //     // this.promptCreateService.getPresignedUrl(presSignedUrlRequest).subscribe(response => {
    //     //   if (response?.data) {
    //     //     const presignedUrl = response?.data?.url;
    //     //     const file = newFile;
    //     //     this.promptCreateService.uploadFileToS3(presignedUrl, file.selected!).subscribe({
    //     //       next: (res) => {
    //     //         console.log("Upload successful:", res);
    //     //       },
    //     //       error: (error) => {
    //     //         console.error("Error uploading file:", error);
    //     //       }
    //     //     });
    //     //   } else {
    //     //     console.log('Failed to get presigned URL');
    //     //   }
    //     // })
    //   }
    // })

    const uploadPromises = newOtherFiles.map(async (newFile: any) => {
      if(!promptDetailStoredData.attachments.includes(newFile.selected.name)) {
        const presSignedUrlRequest = {
          prompt_id: this.promptDetailsStored?.data?.prompt_id,
          title: this.tabs[this.selectedTabIndex].myForm.value.title,
          url_type: 'put_object',
          prompt_detail_id: promptDetailStoredData?.prompt_detail_id,
          attachment_type: "attachments",
          file_name: newFile.selected.name,
          user_id:this.userid
        }
        try {
          const response = await this.promptCreateService.getPresignedUrl(presSignedUrlRequest).toPromise();
          if (response?.data) {
            const presignedUrl = response.data.url;
            await this.promptCreateService.uploadFileToS3(presignedUrl, newFile.selected!).toPromise();
            console.log(`Uploaded: ${newFile.selected.name}`);
          }
        } catch (err) {
          console.error(`Error uploading ${newFile.selected.name}:`, err);
        }
      }
    });
    
    await Promise.all(uploadPromises); 

    if (this.isEditPrompt) {
      const promptDetail = this.promptDetailsStored?.data?.prompt_details[this.promptDetailsStored.data.prompt_details.length - 1];
    

      if (promptDetail) {

        // this.attachments.forEach((attachment: any) => {
        //   if (attachment.selected?.name && !promptDetail.attachments.includes(attachment.selected.name)) {
        //     const isDuplicate = this.newAttachmentFiles.some((file: any) => file.selected?.name === attachment.selected.name);
        //     if (!isDuplicate) {
        //       this.newAttachmentFiles.push(attachment);
        //     }
        //   }
        // });

      
        runPromptRequest = {
          ...runPromptRequest,
          // question: this.tabs[0].myForm.value.promptDetails,
          // question: this.tabs[this.selectedTabIndex].myForm.value.promptDetails,
          question: this.tabs[this.selectedTabIndex].myForm.value.gptQuestion,
          user_id: this.userid,
          // prompt_title: this.tabs[0].myForm.value.title,
          prompt_title: this.tabs[this.selectedTabIndex].myForm.value.title,
          prompt_id: this.promptDetailsStored?.data?.prompt_id ?? null,
          is_draft_prompt: promptDetail.status === 'DRAFT',
          // permanentAttachments: promptDetail.permanent_attachments?.map((file: any) => file),
          permanentAttachments: newPermanentFiles?.map((file: any) => file.selected),
          // attachments: this.newAttachmentFiles?.map((file: any) => file),
          // attachments: this.newAttachmentFiles?.map((file: any) => file.selected),
          attachments: newOtherFiles?.map((file: any) => file.selected),
          uploaded_files: merged_uploaded_files_items,
          // uploaded_files: uploaded_files_items,
          // uploaded_files: this.attachments.map((file: any) => {
          //   return {
          //     file_name: file.selected?.name || '',
          //     selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
          //   };
          // })
        };
       
      }
    } else {
      runPromptRequest = {
        ...runPromptRequest,
        // question: this.tabs[0].myForm.value.promptDetails,
        // question: this.tabs[this.selectedTabIndex].myForm.value.promptDetails,
        question: this.tabs[this.selectedTabIndex].myForm.value.gptQuestion,
        user_id: this.userid,
        // prompt_title: this.tabs[0].myForm.value.title,
        prompt_title: this.tabs[this.selectedTabIndex].myForm.value.title,
        prompt_id: this.savedData?.prompt?.id ?? null,
        is_draft_prompt: this.savedData?.prompt?.id === null ? false : this.savedData?.prompt_details[0]?.status == 'DRAFT' ? true : false,
        // permanentAttachments: this.perminentAttachments.map((file: any) => { return file.selected }),
        // attachments: this.attachments.map((file: any) => { return file.selected }),
        // uploaded_files: this.attachments.map((file: any) => {
        //   return {
        //     file_name: file.selected?.name || '',
        //     selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
        //   };
        // })
        permanentAttachments: newPermanentFiles?.map((file: any) => file.selected),
        attachments: newOtherFiles?.map((file: any) => file.selected),
        uploaded_files: merged_uploaded_files_items
        // uploaded_files: uploaded_files_items
      };
    }

    // if(time == 0){
      this.promptCreateService.onRunPrompt(runPromptRequest)
    .pipe(
      catchError((error) => {
        console.error('Error occurred:', error);
        
        this.isLoading = false;
        
        // Ensure UI doesn't freeze
        this.isPromptRunning = false;
        if(error.status == 400) {
          this.openSnackbar('Please enter valid page number within the PDF page range', 'An error occurred', 'error-snackbar');
        } 
        

        // Return an empty observable to prevent breaking the subscription
        return of(null);
      }),
      finalize(() => {
        // Always reset the loading state, whether success or error
        this.isPromptRunning = false;
        this.isLoading = false;
      })
    ).subscribe((res) => {
      
      if (res && res["status_code"] === 200) {
       
        localStorage.setItem('project_code', res.data.project_code);
        this.isPromptRunning = false;
        this.enableChatPrompt = true;
        // this.promptText = this.promptQuestion = res.data.question;
        // Escape HTML-like tags before updating promptText
        let escapeNonHtmlTags = this.escapeNonHtmlTags(res.data.question);
        this.promptText = escapeNonHtmlTags.replace(/\[\^\d+\^\]/g, '');

        let extractedPdfContent = res.data.pdf_text;
        if(extractedPdfContent?.length > 0) {
          let vcTransformedData = selectedVariablescopy.value.map((vItem: any) => {
            if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
              let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
              if(match) {
                return {
                  ...vItem,
                  "pdfDocData": {
                    ...vItem.pdfDocData,
                    page_content: match.page_content
                  },
                  "varGptData": match.page_content
                }
              }
            }
            return vItem; // Explicitly return null or undefined
          }).filter((item: any) => item !== null); // Remove null values
       

          let vTransformedData = selectedVariables.value.map((vItem: any) => {
            if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
              let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
              if(match) {
                return {
                  ...vItem,
                  "pdfDocData": {
                    ...vItem.pdfDocData,
                    page_content: match.page_content
                  },
                  "varGptData": match.page_content
                }
              }
            }
            return vItem; // Explicitly return null or undefined
          }).filter((item: any) => item !== null); // Remove null values

          
         

          selectedVariables.patchValue(vTransformedData);
          selectedVariablescopy.patchValue(vcTransformedData);

         
          this.updateInputPromptText(this.selectedTabIndex);
          // this.promptText = this.tabs[this.selectedTabIndex].myForm.value.gptQuestion;
          let escapeNonHtmlTags = this.escapeNonHtmlTags(this.tabs[this.selectedTabIndex].myForm.value.gptQuestion);
          this.promptText =  escapeNonHtmlTags.replace(/\[\^\d+\^\]/g, '');
       
        }






        // if (res.data && res.data.pdf_text) {
        //   this.pdfText = res.data.pdf_text;
        //   let tempStr = "";
        //   this.pdfText.forEach((pdftext: any) => {
        //     tempStr += pdftext + "\n"
        //   });
        //   if (tempStr) {
        //     this.promptText = tempStr + "\n" + this.promptQuestion;
        //   } else {
        //     this.promptText = this.promptQuestion;
        //   }
        // }

        this.projectCode = res.data.project_code ? res.data.project_code : undefined;
        if (this.projectCode.includes("temp")) {
          localStorage.setItem("hasProjectCode", this.projectCode);
        }
        this.fileNames = JSON.parse(JSON.stringify(res.data.file_names));
        // this.passedFileNames = JSON.parse(JSON.stringify(this.attachments));
        this.passedFileNames = JSON.parse(JSON.stringify(passedFiles));
        this.promptResponse = res.data;
        this.chatId = undefined;
        this.currChatId.set({ chat_id: "", message_id: "" });
        this.adjustHeight();
        this.isLoading = false;
      } else if (res && res["status_code"] === 202) {
        let pagesWithStr: any = {};
        let questionData: any;
        questionData = res?.data?.question;
        runPromptRequest.uploaded_files.forEach((item:any) => {
          pagesWithStr[item.file_name] = item.selected_pages.join('_');
        })
        
        let postData = {
          project_code: res?.data?.project_code,
          user_id: this.userid,
          filenames: res?.data?.file_names,
          pages_as_string: pagesWithStr
        }

        
        this.pollingDialogRef = this.dailog.open(PollingDialogComponent, {
          height: '250px',
          width: '450px',
          disableClose: true
        });

        this.pollingRunPromptInterval = setInterval(() => {
          this.promptCreateService.pollingApi(postData).pipe(
            catchError((error) => {
              console.error('Error occurred:', error);
              this.isLoading = false;
              this.isPromptRunning = false;
              this.openSnackbar('Please enter valid page number within the PDF page range', 'An error occurred', 'error-snackbar');
              return of(null);
            }),
            finalize(() => {
              this.isPromptRunning = false;
              this.isLoading = false;
            })
        ).subscribe((resp:any) => {
          if (resp && resp.data && resp.data.length) {
            this.promptCreateService.updateData(true);
            // this.clearPolling();
            clearInterval(this.pollingRunPromptInterval);
            // this.pollingDialogRef.close();
            this.isPromptRunning = false;
            this.enableChatPrompt = true;
            
            const quetionText = this.escapeNonHtmlTags(questionData);
            // this.promptText = `${quetionText}</br> <span class="var-text doc">${resp.data[0].page_content}</span>`;
            // this.promptText = `${quetionText}</br> <span class="var-text doc">${resp.data.map((item: any) => item.page_content).join(' ')}</span>`;

            // let extractedPdfContent = res.data.pdf_text;
            let extractedPdfContent = resp.data;
            if(extractedPdfContent?.length > 0) {
              let vcTransformedData = selectedVariablescopy.value.map((vItem: any) => {
                if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
                  let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
                  if(match) {
                    return {
                      ...vItem,
                      "pdfDocData": {
                        ...vItem.pdfDocData,
                        page_content: match.page_content
                      },
                      "varGptData": match.page_content
                    }
                  }
                }
                return vItem;
              }).filter((item: any) => item !== null);
           

              let vTransformedData = selectedVariables.value.map((vItem: any) => {
                if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
                  let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
                  if(match) {
                    return {
                      ...vItem,
                      "pdfDocData": {
                        ...vItem.pdfDocData,
                        page_content: match.page_content
                      },
                      "varGptData": match.page_content
                    }
                  }
                }
                return vItem;
              }).filter((item: any) => item !== null);
              selectedVariables.patchValue(vTransformedData);
              selectedVariablescopy.patchValue(vcTransformedData);
              this.updateInputPromptText(this.selectedTabIndex);
              let escapeNonHtmlTags = this.escapeNonHtmlTags(this.tabs[this.selectedTabIndex].myForm.value.gptQuestion);
              this.promptText = escapeNonHtmlTags.replace(/\[\^\d+\^\]/g, '');
            }
            this.projectCode = res?.data?.project_code ? res?.data?.project_code : undefined;
            if (this.projectCode?.includes("temp")) {
              localStorage.setItem("hasProjectCode", this.projectCode);
              localStorage.setItem('project_code', this.projectCode);
            }
            this.fileNames = JSON.parse(JSON.stringify(resp.data.map((item: any) => item.filename)));
            
            
            this.passedFileNames = JSON.parse(JSON.stringify(passedFiles));
            this.promptResponse = res.data;
            this.chatId = undefined;
            this.currChatId.set({ chat_id: "", message_id: "" });
            this.adjustHeight();
            this.isLoading = false;
          }
        }, (error) => {
          clearInterval(this.pollingRunPromptInterval);
        }
      )
      }, 5000);
      }
    })
    // return;
    // }

 
  //   this.pollingRunPromptInterval = setInterval(() => {
  //     if (this.getPromptRunLimit < this.timeOutCounterRunLimit) {
  //       //this.getPromptAnswer();
      

  //   this.promptCreateService.onRunPrompt(runPromptRequest)
  //   .pipe(
  //     catchError((error) => {
  //       console.error('Error occurred:', error);
        
  //       this.isLoading = false;
        
  //       // Ensure UI doesn't freeze
  //       this.isPromptRunning = false;
        
  //       this.openSnackbar('Please enter valid page number within the PDF page range', 'An error occurred', 'error-snackbar');

  //       // Return an empty observable to prevent breaking the subscription
  //       return of(null);
  //     }),
  //     finalize(() => {
  //       // Always reset the loading state, whether success or error
  //       this.isPromptRunning = false;
  //       this.isLoading = false;
  //     })
  //   ).subscribe((res) => {
      
  //     if (res && res["status_code"] === 200 && Object.keys(res.data).length !== 0) {

  //       this.isPromptRunning = false;
  //       this.enableChatPrompt = true;
  //       this.clearRunPolling();
  //       // this.promptText = this.promptQuestion = res.data.question;
  //       // Escape HTML-like tags before updating promptText
  //       this.promptText = this.escapeNonHtmlTags(res.data.question);

  //       let extractedPdfContent = res.data.pdf_text;
  //       if(extractedPdfContent?.length > 0) {
  //         let vcTransformedData = selectedVariablescopy.value.map((vItem: any) => {
  //           if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
  //             let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
  //             if(match) {
  //               return {
  //                 ...vItem,
  //                 "varGptData": match.page_content
  //               }
  //             }
  //           }
  //           return vItem; // Explicitly return null or undefined
  //         }).filter((item: any) => item !== null); // Remove null values


  //         let vTransformedData = selectedVariables.value.map((vItem: any) => {
  //           if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
  //             let match = extractedPdfContent.find((ePdf: any) => ePdf.filename === vItem?.pdfDocData?.file_name);
  //             if(match) {
  //               return {
  //                 ...vItem,
  //                 "varGptData": match.page_content
  //               }
  //             }
  //           }
  //           return vItem; // Explicitly return null or undefined
  //         }).filter((item: any) => item !== null); // Remove null values

          


  //         selectedVariables.patchValue(vTransformedData);
  //         selectedVariablescopy.patchValue(vcTransformedData);


  //         this.updateInputPromptText(this.selectedTabIndex);
  //         // this.promptText = this.tabs[this.selectedTabIndex].myForm.value.gptQuestion;
  //         this.promptText = this.escapeNonHtmlTags(this.tabs[this.selectedTabIndex].myForm.value.gptQuestion);

  //       }






  //       // if (res.data && res.data.pdf_text) {
  //       //   this.pdfText = res.data.pdf_text;
  //       //   let tempStr = "";
  //       //   this.pdfText.forEach((pdftext: any) => {
  //       //     tempStr += pdftext + "\n"
  //       //   });
  //       //   if (tempStr) {
  //       //     this.promptText = tempStr + "\n" + this.promptQuestion;
  //       //   } else {
  //       //     this.promptText = this.promptQuestion;
  //       //   }
  //       // }

  //       this.projectCode = res.data.project_code ? res.data.project_code : undefined;
  //       if (this.projectCode.includes("temp")) {
  //         localStorage.setItem("hasProjectCode", this.projectCode);
  //       }
  //       this.fileNames = JSON.parse(JSON.stringify(res.data.file_names));
  //       // this.passedFileNames = JSON.parse(JSON.stringify(this.attachments));
  //       this.passedFileNames = JSON.parse(JSON.stringify(passedFiles));
  //       this.promptResponse = res.data;
  //       this.chatId = undefined;
  //       this.currChatId.set({ chat_id: "", message_id: "" });
  //       this.adjustHeight();
  //       this.isLoading = false;
  //     }
  //   })
  // } else {
  //   this.clearRunPolling(); // Stop run polling
   
  // }

  //   this.getPromptRunLimit += 1
  //   if(time == 0)return;

  //   }, time); // Poll every 10 seconds
  }

escapeNonHtmlTags(text: string): string {
  // Define a whitelist of valid HTML tags
  const validTags = ['b', 'i', 'u', 'strong', 'em', 'p', 'br', 'span', 'div', 'ul', 'li', 'ol', 'a', 'img', 'table', 'tr', 'td', 'th', 'thead', 'tbody', 'tfoot'];

  // if(text) {
    return text.replace(/<\/?([a-zA-Z0-9-]+)[^>]*>/g, (match, tag) => {
      // If the tag is in the valid list, return it unchanged
      if (validTags.includes(tag.toLowerCase())) {
        return match;
      }
      // Otherwise, escape it
      return match.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    });
  // }
  // return '';
}

  getFormattedFileNames(fileNames: any) {
    return fileNames.join(" ,");
  }

  template_converted:boolean=false;


  sendChatPrompt() {
    if(this.selectedModelId == null){
      // confirm("Select some Model.....");
      this.openSnackbar('Model selection is required for prompt execution.', 'Model selection', 'error-snackbar');
      this.model_issue=true;
      return;
    }

    const selectedVariablescopy = this.tabs[this.selectedTabIndex].myForm.get('variablesCopy') as FormArray;
    const selectedVariables = this.tabs[this.selectedTabIndex].myForm.get('variables') as FormArray;
    
    let requestData: any;

    let otherAttachmentsList: any = this.tabs[this.selectedTabIndex].myForm.value.attachment || []

    let prompt_id = this.promptDetailsStored?.data?.prompt_id;
    let prompt_detail_id = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id ? this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id : this.savedData?.prompt_details[this.selectedTabIndex]?.id;

    let uploaded_files_items = otherAttachmentsList.map((file: any) => {
      return {
        file_name: file.selected?.name || '',
        selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
      }
    })
   

    let vPdfDocData = selectedVariablescopy.value.map((vItem: any) => {
        if (Object.keys(vItem?.pdfDocData || {}).length > 0) {
          return {
            file_name: vItem?.pdfDocData?.file_name,
            selected_pages: vItem?.pdfDocData?.selected_pages,
            label_name: vItem?.pdfDocData?.label_name.replace('\n', '').trim(''),
            page_content: vItem?.pdfDocData?.page_content
          };
        }
        return null; // Explicitly return null or undefined
      }).filter((item: any) => item !== null); // Remove null values
     

    let merged_uploaded_files_items = uploaded_files_items.map((uploaded_file: any) => {
      let match = vPdfDocData.find((vPdf: any) => vPdf.file_name === uploaded_file.file_name);
      return match ? match : uploaded_file
    })
   

    // let merged_uploaded_files_items = [...vPdfDocData]
   
    // uploaded_files_items.forEach((uploadedItem: any) => {
    //   if (!merged_uploaded_files_items.some((pdfItem: any) => pdfItem.file_name === uploadedItem.file_name)) {
    //     merged_uploaded_files_items.push(uploadedItem);
    //   }
    // });
    
    

    let var_uploaded_files: any = []
    selectedVariablescopy.value.forEach((vItem: any) => {
      if(vItem?.chatHistoryDocs?.length > 0) {
        vItem?.chatHistoryDocs.forEach((item: any) => {
          var_uploaded_files.push(item);
        })
      }
    })

    let vChatVarData = selectedVariablescopy.value.map((vChatItem: any) => {
      if (Object.keys(vChatItem?.chatVar || {}).length > 0) {
        return {
          ...vChatItem.chatVar,
          prompt_id: vChatItem.promptId,
          prompt_detail_version_id: vChatItem.promptVersionId
        };
      }
      return null; // Explicitly return null or undefined
    }).filter((item: any) => item !== null); // Remove null values
   

    let vUserData = selectedVariablescopy.value.map((userInput: any, i: number) => {
      if (this.isString(userInput)) {
        let userInputKey = selectedVariables.value[i];
        return {
          userInputKey: userInputKey,
          userInputValue: userInput
        };
      }
      return null; // Explicitly return null or undefined
    }).filter((item: any) => item !== null); // Remove null values

    let variables = {
      document: vPdfDocData,
      chat_history: vChatVarData,
      uploaded_attachments: [],
      user_input_variable: vUserData
      // uploaded_attachments is part of chat var will uncomment if required.
      // uploaded_attachments: var_uploaded_files
    }
    let marked_prompt_text;
    if(this.template_converted){
     marked_prompt_text = marked(this.promptText);
     this.template_converted=false;
    
    }else{
      marked_prompt_text = marked(this.escapeNonHtmlTags(this.promptText));
      
    } 
    const safe_prompt_text =
    marked_prompt_text instanceof Promise
        ? marked_prompt_text
            .then((htmlString: string) =>
              this.htmlToPlainText(htmlString)
            )
            .catch((error) => {
              console.error(
                "Error processing async markdown:",
                error
              );
              return null;
            })
        : this.htmlToPlainText(marked_prompt_text);

        
    if (this.isEditPrompt) {
      let promptDetail = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex];

      // Temp fix need to revert.
      if (!prompt_detail_id && !promptDetail) {
        promptDetail = this.promptDetailsStored?.data?.prompt_details[this.promptDetailsStored.data.prompt_details.length - 1];
      } else {
        promptDetail = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex];
      }

      if (promptDetail) {
        requestData = {
          // "question": this.promptText,
          "question": safe_prompt_text,
          "user_id": this.userid,
          // "prompt_title": this.savedData.prompt.title,
          "prompt_id": this.promptDetailsStored?.data?.prompt_id ?? null,
          "prompt_detail_version_id": promptDetail?.prompt_detail_id || null,
          "version_number": promptDetail?.version_number || null,
          // "llm_model": "gpt-4o",
          // "llm_model_id": promptDetail?.llm?.model_id || 2,
          "llm_model": this?.selectedModelId?.value,
          "llm_model_id": this?.selectedModelId?.id,
          "pdf_text": this.pdfText || "",
          "embedding_model": "text-embedding-3-large",
          "chat_id": this.currChatId().chat_id ? this.currChatId().chat_id : undefined,
          // "chat_id": this.chatId ? this.chatId : undefined,
          "is_prompt_saved_or_submitted": promptDetail?.status === 'DRAFT',
          "project_code": this.projectCode,
          "uploaded_files": merged_uploaded_files_items,
          "prompt_variables": variables
          // "uploaded_files": uploaded_files_items
          // "uploaded_files": this.attachments.map((file: any) => {
          //   return {
          //     file_name: file.selected?.name || '',
          //     selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
          //   };
          // })
          // "pdf_text": , Pass if pdf Text receivedx
        }
      }
    } else {
      requestData = {
        // "question": this.promptText,
        "question": safe_prompt_text,
        "user_id": this.userid,
        // "prompt_title": this.savedData.prompt.title,
        "prompt_id": this.savedData?.prompt?.id || null,
        // "prompt_detail_version_id": this.savedData?.prompt_details[0]?.id || null,
        // "version_number": this.savedData?.prompt_details[0]?.version_number || null,
        "prompt_detail_version_id": this.savedData?.prompt_details[this.selectedTabIndex]?.id || null,
        "version_number": this.savedData?.prompt_details[this.selectedTabIndex]?.version_number || null,
        // "llm_model": "gpt-4o",
        // "llm_model_id": 2,
        "llm_model": this?.selectedModelId?.value,
        "llm_model_id": this?.selectedModelId?.id,
        "pdf_text": this.pdfText || "",
        "embedding_model": "text-embedding-3-large",
        "chat_id": this.currChatId().chat_id ? this.currChatId().chat_id : undefined,
        // "chat_id": this.chatId ? this.chatId : undefined,
        // "is_prompt_saved_or_submitted": this.savedData?.prompt?.id === null ? false : this.savedData?.prompt_details[0]?.status == 'DRAFT' ? true : false,
        "is_prompt_saved_or_submitted": this.savedData?.prompt?.id === null ? false : this.savedData?.prompt_details[this.selectedTabIndex]?.status == 'DRAFT' ? true : false,
        "project_code": this.projectCode,
        "uploaded_files": merged_uploaded_files_items,
        "prompt_variables": variables
        // "uploaded_files": uploaded_files_items
        // "uploaded_files": this.attachments.map((file: any) => {
        //   return {
        //     file_name: file.selected?.name || '',
        //     selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
        //   };
        // })
        // "pdf_text": , Pass if pdf Text receivedx
      }
    }
    if (requestData) {
      this.passedFileNames.forEach((file: any) => {
        this.messages.push({
          type: "file",
          value: file.selected?.name,
          isPrompt: true,
          page_number: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : [],
          question: '',
        });
      });
      this.messages.push({
        type: "text",
        value: this.template_converted?this.promptText:marked_prompt_text,
        //value: safe_prompt_text,
        isPrompt: true,
        question: ''
      });
      this.messages.push({
        type: "text",
        value: this.generateLoadingText,
        isPrompt: false,
        question: safe_prompt_text
        // question: 'Searched for ' + this.promptText
      });
      this.fileNames = [];
      this.passedFileNames = [];
      this.promptText = "";
      this.isMultiText = false;
      this.shrinkFooter = false;
      this.pdfText = "";
       // Log messages after updates

      this.enableChatPrompt = false;
      let isFirstTime = false;
      this.renderBotMsg(this.messages);
      setTimeout(() => {
        this.scrollToBottom();
      }, 50);
      this.enableChatPrompt = false;



      this.promptCreateService.executePromptApi(requestData).then(async (response) => {
        const { data, message, status_code } = await response;
        if (status_code == 200) {
          this.currChatId.set({ chat_id: data.chat_id, message_id: data.message_id })

          //Reset polling limit
          this.getPromptAnswerLimit = 0;

          // Start polling executePrompt every 5 seconds
          this.startExecutePromptPolling();
          
        }
      }, (err) => {
        this.typingInProgress = false;
        this.enableChatPrompt = true;
        // this.isPromptGenerating = false;
        this.messages[this.messages.length - 1].value = "Something went wrong while generating the answer";
        // this.fetchChats(this.promptUserDetails?.prompt_id, promptDetails.prompt_detail_id);
        this.renderBotMsg(this.messages);
      });
    } else {
      this.openSnackbar("Save and run prompt", 'An error occurred', 'error-snackbar')
    }
  }

  getPromptAnswer() {
    let prompt_id = this.promptDetailsStored?.data?.prompt_id;
    let promptDetail = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex];
    let prompt_detail_id = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id ? this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id : this.savedData?.prompt_details[this.selectedTabIndex]?.id;

    const chataData = this.currChatId()

    let requestData = {
      // "prompt_id": this.promptUserDetails?.prompt_id,
      "chat_id": chataData.chat_id,
      "message_id": chataData.message_id
    }
    this.promptCreateService.getPromptAnswerApi(requestData).then(async (res) => {
      try {
        //let api_res = await res.json();
        if (Object.keys(res.data).length !== 0 && res.data.constructor === Object) {

          // Temp fix need to revert.
          if (!prompt_detail_id && !promptDetail) {
            promptDetail = this.promptDetailsStored?.data?.prompt_details[this.promptDetailsStored.data.prompt_details.length - 1];
          } else {
            promptDetail = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex];
          }
          this.clearPolling(); // Stop polling

          let isFirstTime = false;
          if (!isFirstTime) {
            this.messages[this.messages.length - 1].value = "";
            isFirstTime = true;
          }

          this.currChatId.set({ chat_id: res.data.chat_id, message_id: chataData.message_id })
          this.chatId = res.data.chat_id;
          this.messages[this.messages.length - 1].value += res.data.answer; // Append answer
          this.messages[this.messages.length - 1].citations = res.data.citations; // Append answer

          // let citations = api_res.data.citations
          // let citations = {
          //   "[^1^]": {
          //     "type":  "document",
          //     "document_name": "abc.pdf",
          //     "highlight_content": "Deep learning models are based on artificial neural networks, which are inspired by the structure and function of the human brain.",
          //     "coordinates": [{
          //         "Width": 0.4215604364871979,
          //         "Height": 0.011238890700042248,
          //         "Left": 0.5212028622627258,
          //         "Top": 0.36133435368537903,
          //         "Page": 0
          //     }]
          //   },
          //   "[^2^]" : {
          //       "type":  "chat_history",
          //       "document_name": null,
          //       "chat_name": "abc",
          //       "chat_id": "a71f7055-6a4b-497a-996d-c22036d97606",
          //       "prompt_id": 1667,
          //       "prompt_detail_version_id": 2531,
          //       "highlight_content": "The final layer that produces the output, such as classification or prediction.",
          //       "coordinates": null,
          //       "chat_details": [{question: 'test question example',answer: 'test answer example'}]
          //   },
          //   "[^3^]": {
          //     "type":  "document",
          //     "document_name": "xyz.pdf",
          //     "highlight_content": "This process often involves techniques like backpropagation and optimization algorithms.",
          //     "coordinates": [{
          //         "Width": 0.4215604364871979,
          //         "Height": 0.011238890700042248,
          //         "Left": 0.5212028622627258,
          //         "Top": 0.36133435368537903,
          //         "Page": 0
          //     }]
          //   },
          //   "[^4^]" : {
          //       "type":  "chat_history",
          //       "document_name": null,
          //       "chat_name": "chat history 123",
          //       "chat_id": "0f1aa72d-3a41-4cda-ab5d-1ede34600214",
          //       "prompt_id": 1667,
          //       "prompt_detail_version_id": 2531,
          //       "highlight_content": "computations and extract features from the data. Deep learning models typically have multiple hidden layers.",
          //       "coordinates": null,
          //       "chat_details": [{question: 'test question example',answer: 'test answer example'}]
          //   },
          // }
          // this.scrollToBottom();
          // this.renderBotMsg(this.messages, citations);
          this.renderBotMsg(this.messages);
          setTimeout(() => {
            this.scrollToBottom();
          }, 50);

          this.typingInProgress = false;
          this.enableChatPrompt = true;
          // this.isPromptGenerating = false;
          this.fetchChats(prompt_id, prompt_detail_id);
        }
        
      } catch (error) {
        console.log("try_catch_api_error", error)
        // this.clearPolling(); // Stop polling
        // this.messages[this.messages.length - 1].value = "Something went wrong while generating the answer";
        // this.typingInProgress = false;
        // this.enableChatPrompt = true;
      }
    }).catch(err => {
      console.log("getPromptAnswerApi_PromiseError", err)
      this.clearPolling(); // Stop polling
      this.messages[this.messages.length - 1].value = "Something went wrong while generating the answer";
      this.typingInProgress = false;
      this.enableChatPrompt = true;
      this.renderBotMsg(this.messages);
    })
  }

  startExecutePromptPolling() {
   
    this.pollingInterval = setInterval(() => {
      if (this.getPromptAnswerLimit < this.timeOutCounterLimit) {
        this.getPromptAnswer();
      } else {
        this.clearPolling(); // Stop polling
        this.messages[this.messages.length - 1].value = "Timeout error";
        this.typingInProgress = false;
        this.enableChatPrompt = true;
        this.renderBotMsg(this.messages);
      }

      this.getPromptAnswerLimit += 1
      
    }, 5000); // Poll every 5 seconds
  }

  clearPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      console.log('Polling stopped');
    }
  }

  clearRunPolling() {
    if (this.pollingRunPromptInterval) {
      clearInterval(this.pollingRunPromptInterval);
      console.log('Run Polling stopped');
    }
  }

  // Working code...
  // sendChatPrompt() {
  //   let requestData: any;

  //   let otherAttachmentsList: any = this.tabs[this.selectedTabIndex].myForm.value.attachment || []

  //   let uploaded_files_items = otherAttachmentsList.map((file: any) => {
  //     return {
  //       file_name: file.selected?.name || '',
  //       selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
  //     }
  //   })

  //   let prompt_id = this.promptDetailsStored?.data?.prompt_id;
  //   let prompt_detail_id = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id ? this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id : this.savedData?.prompt_details[this.selectedTabIndex]?.id;

  //   if (this.isEditPrompt) {
  //     let promptDetail = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex];

  //     // Temp fix need to revert.
  //     if(!prompt_detail_id && !promptDetail) {
  //       promptDetail = this.promptDetailsStored?.data?.prompt_details[this.promptDetailsStored.data.prompt_details.length - 1];
  //     } else {
  //       promptDetail = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex];
  //     }

  //     if (promptDetail) {
  //       requestData = {
  //         "question": this.promptText,
  //         "user_id": this.userid,
  //         // "prompt_title": this.savedData.prompt.title,
  //         "prompt_id": this.promptDetailsStored?.data?.prompt_id ?? null,
  //         "prompt_detail_version_id": promptDetail?.prompt_detail_id || null,
  //         "version_number": promptDetail?.version_number || null,
  //         "llm_model": "gpt-4o",
  //         "llm_model_id": promptDetail?.llm?.model_id || 2,
  //         "pdf_text": this.pdfText || "",
  //         "embedding_model": "text-embedding-3-large",
  //         "chat_id": this.chatId ? this.chatId : undefined,
  //         "is_prompt_saved_or_submitted": promptDetail?.status === 'DRAFT',
  //         "project_code": this.projectCode,
  //         "uploaded_files": uploaded_files_items
  //         // "uploaded_files": this.attachments.map((file: any) => {
  //         //   return {
  //         //     file_name: file.selected?.name || '',
  //         //     selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
  //         //   };
  //         // })
  //         // "pdf_text": , Pass if pdf Text receivedx
  //       }
  //     }
  //   } else {
  //     requestData = {
  //       "question": this.promptText,
  //       "user_id": this.userid,
  //       // "prompt_title": this.savedData.prompt.title,
  //       "prompt_id": this.savedData?.prompt?.id || null,
  //       // "prompt_detail_version_id": this.savedData?.prompt_details[0]?.id || null,
  //       // "version_number": this.savedData?.prompt_details[0]?.version_number || null,
  //       "prompt_detail_version_id": this.savedData?.prompt_details[this.selectedTabIndex]?.id || null,
  //       "version_number": this.savedData?.prompt_details[this.selectedTabIndex]?.version_number || null,
  //       "llm_model": "gpt-4o",
  //       "llm_model_id": 2,
  //       "pdf_text": this.pdfText || "",
  //       "embedding_model": "text-embedding-3-large",
  //       "chat_id": this.chatId ? this.chatId : undefined,
  //       // "is_prompt_saved_or_submitted": this.savedData?.prompt?.id === null ? false : this.savedData?.prompt_details[0]?.status == 'DRAFT' ? true : false,
  //       "is_prompt_saved_or_submitted": this.savedData?.prompt?.id === null ? false : this.savedData?.prompt_details[this.selectedTabIndex]?.status == 'DRAFT' ? true : false,
  //       "project_code": this.projectCode,
  //       "uploaded_files": uploaded_files_items
  //       // "uploaded_files": this.attachments.map((file: any) => {
  //       //   return {
  //       //     file_name: file.selected?.name || '',
  //       //     selected_pages: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : []
  //       //   };
  //       // })
  //       // "pdf_text": , Pass if pdf Text receivedx
  //     }
  //   }
  //   if(requestData) {
  //     this.passedFileNames.forEach((file: any) => {
  //       this.messages.push({
  //         type: "file",
  //         value: file.selected?.name,
  //         isPrompt: true,
  //         page_number: file.page_number && file.page_number.trim() ? file.page_number.split(',').map((page: string) => Number(page.trim())) : [],
  //         question: '',
  //       });
  //     });
  //     this.messages.push({
  //       type: "text",
  //       value: this.promptText,
  //       isPrompt: true,
  //       question: ''
  //     });
  //     this.messages.push({
  //       type: "text",
  //       value: this.generateLoadingText,
  //       isPrompt: false,
  //       question: this.promptText
  //     });
  //     this.fileNames = [];
  //     this.passedFileNames = [];
  //     this.promptText = "";
  //     this.isMultiText = false;
  //     this.shrinkFooter = false;
  //     this.pdfText = "";
  

  //     this.enableChatPrompt = false;
  //     let isFirstTime = false;

  //     setTimeout(() => {
  //       this.scrollToBottom();
  //     }, 10);
  //     this.enableChatPrompt = false;

  //     this.promptCreateService.fetchJsonStream(requestData).then(async (response) => {
  //       const reader = response.body?.getReader();
  //       const decoder = new TextDecoder('utf-8');

  //       if (!reader) {
  //         console.error('Failed to read the stream.');
  //         return;
  //       }

  //       let done = false;
  //       // let chunk = '';
  //       let partialChunk = ''; // To store incomplete JSON chunks

  //       while (!done) {
  //         const { value, done: streamDone } = await reader.read();
  //         done = streamDone;

  //         if (value) {

  //           const chunk = decoder.decode(value, {stream: true});
  //           partialChunk += chunk; // Accumulate chunk data

  //           // Split the accumulated chunk into potential JSON objects
  //           const jsonStrings = partialChunk.split('}{');

  //           // Clear partialChunk to reaccumulate incomplete JSON chunks
  //           partialChunk = '';

  //           const jsonArray = []; // Temporary array for complete JSON objects
  //           for (let i = 0; i < jsonStrings.length; i++) {
  //             let jsonString = jsonStrings[i];

  //             // Add missing braces to form valid JSON
  //             if (i > 0) jsonString = `{${jsonString}`;
  //             if (i < jsonStrings.length - 1) jsonString += `}`;

  //             try {
  //               const parsedObject = JSON.parse(jsonString);
  //               jsonArray.push(parsedObject); // Collect valid JSON objects
  //             } catch (e) {
  //               // If JSON parsing fails, save as a partial chunk
  //               partialChunk = jsonString;
  //             }
  //           }

  //           // Process the collected JSON objects
  //           jsonArray.forEach((item: any) => {
  //             if (!isFirstTime) {
  //               this.messages[this.messages.length - 1].value = ""; // Clear initial message
  //               isFirstTime = true;
  //             }

  //             this.chatId = item.chat_id;
  //             this.messages[this.messages.length - 1].value += item.answer; // Append answer
  //             this.scrollToBottom();
  //           });

  //           // Fix boundaries to make valid JSON objects
  //           // for (let i = 0; i < jsonStrings.length; i++) {
  //           //   let jsonString = jsonStrings[i];

  //           //   // Add missing braces to form valid JSON
  //           //   if (i > 0) jsonString = `{${jsonString}`;
  //           //   if (i < jsonStrings.length - 1) jsonString += `}`;

  //           //   try {
  //           //     const parsedObject = JSON.parse(jsonString);

  //           //     if (!isFirstTime) {
  //           //       this.messages[this.messages.length - 1].value = "";
  //           //       isFirstTime = true;
  //           //     }

  //           //     this.chatId = parsedObject.chat_id;
  //           //     this.messages[this.messages.length - 1].value += parsedObject.answer;
  //           //     this.scrollToBottom();
  //           //   } catch (e) {
  //           //     // If JSON parsing fails, it's an incomplete chunk; keep accumulating
  //           //     if (i === jsonStrings.length - 1) {
  //           //       partialChunk = jsonString; // Save for the next iteration
  //           //     } else {
  //           //       console.error('Failed to parse chunk:', e, jsonString);
  //           //     }
  //           //   }
  //           // }

  //           // chunk = decoder.decode(value, { stream: true });
  //           // let lines = chunk.split('\n');
  //           // chunk = lines.pop() || '';
  //           // if (!isFirstTime) {
  //           //   this.messages[this.messages.length - 1].value = "";
  //           //   isFirstTime = true;
  //           // }
  //           // if(chunk.length > 0) {
  //           //   const jsonArray = chunk.split('}{').map((str, index) => {
  //           //     // Fix the string to be a valid JSON object by adding braces
  //           //     if (index > 0) str = `{${str}`;
  //           //     if (index < chunk.split('}{').length - 1) str = `${str}}`;
  //           //     return JSON.parse(str);
  //           //   });
  //           //   jsonArray.forEach((item: any) => {
  //           //     this.chatId = item.chat_id;
  //           //     this.messages[this.messages.length - 1].value += item.answer;
  //           //     this.scrollToBottom();
  //           //   });
  //           // }
  //         }
  //         if (done) {
  //           this.typingInProgress = false;
  //           this.enableChatPrompt = true;
  //           // this.fetchChats();
  //           this.fetchChats(prompt_id, prompt_detail_id);
  //         }
  //       }
  //     });
  //   } else {
  //     this.openSnackbar("Save and run prompt", 'error', 'error-snackbar')
  //   }
  // }

  scrollToBottom() {
    const container = this.chatContainer?.nativeElement;
    if(container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: 'smooth', // Enables smooth scrolling
      });
    }
    // container.scrollTop = container.scrollHeight;
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  toggleGroup(index: number) {
    this.expandedState[index] = !this.expandedState[index];
  }

  fetchChats(prompt_id: any, prompt_version_id: any) {
    if (this.savedData && typeof this.savedData == 'object') {
  
      const requestData = {
        user_id: this.userid,
        prompt_id: this.savedData && this.savedData.prompt ? this.savedData.prompt.id : this.savedData.data.prompt_id,
        prompt_detail_version_id: this.savedData && this.savedData.prompt_details ? this.savedData.prompt_details[this.selectedTabIndex].id : this.savedData.data.prompt_details[this.selectedTabIndex].prompt_detail_id,
        // prompt_detail_version_id: this.savedData && this.savedData.prompt_details ? this.savedData.prompt_details[0].id : this.savedData.data.prompt_details[0].prompt_detail_id,
      };

      this.promptCreateService.getChats(requestData).subscribe((res) => {
        if (res && res["status_code"] === 200) {
          this.chatHistoryData = res.data;
          // Call getChats with the response data from the API
          this.getChats(res.data);
          this.expandedState[0] = true;
        }
      });
    }
    if (prompt_id && prompt_version_id && this.isDraft) {
      const requestData = {
        user_id: this.userid,
        prompt_id: prompt_id,
        prompt_detail_version_id: prompt_version_id,
      };

      this.promptCreateService.getChats(requestData).subscribe((res) => {
        if (res && res["status_code"] === 200) {
          this.chatHistoryData = res.data;
          // Call getChats with the response data from the API
          this.getChats(res.data);
          this.expandedState[0] = true;
        }
      });
    }
  }
  getChats(data: any[]) {
    const groupedChats: { today: any[], yesterday: any[], otherDates: any[] } = {
      today: [],
      yesterday: [],
      otherDates: []
    };

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    data.forEach((chat: any) => {

      const chatDate = new Date(chat.created_datetime);
      const chatDateString = chatDate.toDateString();  // Get only the date part (ignores time)

      // Check if the message is "Today"
      if (this.isSameDay(today, chatDate)) {
        chat["chat_id"] = chat.id;
        chat["isEdit"] = false;
        groupedChats.today.push(chat);
      }
      // Check if the message is "Yesterday"
      else if (this.isSameDay(yesterday, chatDate)) {
        chat["chat_id"] = chat.id;
        chat["isEdit"] = false;
        groupedChats.yesterday.push(chat);
      }
      // Otherwise, group by specific date
      else {
        const existingDateGroup = groupedChats.otherDates.find(group => group.date === chatDateString);
        if (existingDateGroup) {
          chat["chat_id"] = chat.id;
          chat["isEdit"] = false;
          existingDateGroup.chats.push(chat);
          // existingDateGroup.messages.push(chat);
        } else {
          chat["chat_id"] = chat.id;
          chat["isEdit"] = false;
          groupedChats.otherDates.push({
            date: chatDateString,
            chats: [chat]
            // messages: [chat]
          });
        }
      }
    });

    // Construct the final chat history array
    this.chatHistory = [
      { date: 'Today', chats: groupedChats.today },
      { date: 'Yesterday', chats: groupedChats.yesterday },
      ...groupedChats.otherDates
    ];

    //Set initial chat
    if(data.length > 0) {
      this.loadChats({...data[0], chat_id: data[0].id}, false)
    }
  }

  isSameDay(date1: Date, date2: Date) {
    return date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear();
  }

  newPrompt() {
    this.messages = [];
    this.enableChatPrompt = true;
    this.promptText = '';
    this.fileNames = [];
    this.passedFileNames = [];
    this.chatId = undefined;
    this.currChatId.set({ chat_id: "", message_id: "" });
    this.renderBotMsg(this.messages);
  }

  copyChatHistoryData: SafeHtml | null = null;
  copyChatHistory(prompt_id: any, prompt_detail_version_id: any) {
    const requestData = {
      user_id: this.userid,
      prompt_id: prompt_id,
      prompt_detail_version_id: prompt_detail_version_id,
    };

    return new Promise((resolve, reject) => {
      this.promptCreateService.getChats(requestData).subscribe({
        next: (res) => {
          if (res && res["status_code"] === 200) {
            if (res?.data?.length > 0) {
             
              const chatData = res.data.flatMap((chat: any) => {
                let question = chat.name ? chat.name : chat.messages[0].question
                let chatQuest ;
                if(this.template_converted){
                  chatQuest = marked(question)
                 }else{
                  chatQuest = marked(this.escapeNonHtmlTags(question))
                  } 
                // const chatQuest = marked(question);
                const chatAnswer = chat.messages[0].answer ? marked(chat.messages[0].answer) : '';
  
                const safeQuest =
                  chatQuest instanceof Promise
                    ? chatQuest
                        .then((htmlString: string) =>
                          this.htmlToPlainText(htmlString)
                        )
                        .catch((error) => {
                          console.error(
                            "Error processing async markdown:",
                            error
                          );
                          return null;
                        })
                    : this.htmlToPlainText(chatQuest);

                const safeAnswer =
                  chatAnswer instanceof Promise
                    ? chatAnswer
                        .then((htmlString: string) =>
                          this.htmlToPlainText(htmlString)
                        )
                        .catch((error) => {
                          console.error(
                            "Error processing async markdown:",
                            error
                          );
                          return null;
                        })
                    : this.htmlToPlainText(chatAnswer);

                return {
                  id: chat.id,
                  question: safeQuest,
                  // question: chatQuest,
                  menuName: safeQuest,
                  answer: chatAnswer,
                  // answer: safeAnswer,
                  name: 'Chat History Selection',
                  chatData: res.data
                };

                // return chat.messages.map((message: any) => {
                //   const chatQuest = marked(message.question);
                //   const chatAnswer = marked(message.answer);
  
                //   const safeQuest =
                //     chatQuest instanceof Promise
                //       ? chatQuest
                //           .then((htmlString: string) =>
                //             this.htmlToPlainText(htmlString)
                //           )
                //           .catch((error) => {
                //             console.error(
                //               "Error processing async markdown:",
                //               error
                //             );
                //             return null;
                //           })
                //       : this.htmlToPlainText(chatQuest);
  
                //   const safeAnswer =
                //     chatAnswer instanceof Promise
                //       ? chatAnswer
                //           .then((htmlString: string) =>
                //             this.htmlToPlainText(htmlString)
                //           )
                //           .catch((error) => {
                //             console.error(
                //               "Error processing async markdown:",
                //               error
                //             );
                //             return null;
                //           })
                //       : this.htmlToPlainText(chatAnswer);
  
                //   return {
                //     id: chat.id,
                //     question: safeQuest,
                //     // question: chatQuest,
                //     menuName: safeQuest,
                //     answer: chatAnswer,
                //     // answer: safeAnswer,
                //     name: 'Chat History Selection'
                //   };
                // });
              });
  
              resolve(chatData);
            } else {
              resolve([]); // No data, return an empty array
            }
          } else {
            reject("Invalid response status code");
          }
        },
        error: (err) => {
          reject(err); // Handle HTTP errors
        },
      });
    });

    // this.promptCreateService.getChats(requestData).subscribe((res) => {
    //   // let storeMarkedString = ""
    //   if (res && res["status_code"] === 200) {
    //     // this.getChats(res.data);
    //     if(res?.data?.length > 0) {
    //       let chatData = res.data.flatMap((chat: any) => {
    //         return chat.messages.map((message: any) => {
    //           let chatQuest = marked(message.question);
    //           let chatAnswer = marked(message.answer);
    //           let safeQuest: any
    //           let safeAnswer: any

    //           if(chatQuest instanceof Promise) {
    //             chatQuest.then((htmlString: string) => {
    //               // safeQuest = this.sanitizer.bypassSecurityTrustHtml(htmlString);
    //               safeQuest = this.htmlToPlainText(htmlString);
    //             }).catch((error) => {
    //               console.error('Error processing async markdown:', error);
    //             });
    //           } else {
    //             // safeQuest = this.sanitizer.bypassSecurityTrustHtml(chatQuest)
    //             safeQuest = this.htmlToPlainText(chatQuest)
    //           }

    //           if(chatAnswer instanceof Promise) {
    //             chatAnswer.then((htmlString: string) => {
    //               // safeAnswer = this.sanitizer.bypassSecurityTrustHtml(htmlString);
    //               safeAnswer = this.htmlToPlainText(htmlString);
    //             }).catch((error) => {
    //               console.error('Error processing async markdown:', error);
    //             });
    //           } else {
    //             // safeAnswer = this.sanitizer.bypassSecurityTrustHtml(chatAnswer)
    //             safeAnswer = this.htmlToPlainText(chatAnswer)
    //           }
              
    //           return {
    //             id: chat.id,
    //             question: safeQuest,
    //             answer: safeAnswer
    //           }
    //         })
    //       })
 
    //       return chatData;
    //     }
  
    //     // res.data.forEach((chat: any) => {
    //     //   chat.messages.forEach((message: any) => {
   
    //     //     storeMarkedString += message.question + '\n' + message.answer + '\n';
    //     //   })
    //     // })
    //     // try {
    //     //   // Parse the Markdown into raw HTML
    //     //   const rawHtml = marked(storeMarkedString);
    //     //   // Sanitize the HTML
    //     //   // let safe: any = this.sanitizer.bypassSecurityTrustHtml(rawHtml);

    //     //   if (rawHtml instanceof Promise) {
    //     //     // Handle async marked
    //     //     rawHtml
    //     //       .then((htmlString: string) => {
    //     //         const safeHtml = this.sanitizer.bypassSecurityTrustHtml(htmlString);
    //     //        
    //     //         this.copyChatHistoryData = safeHtml;
    //     //         const htmlElement = this.convertSafeHtmlToElement(safeHtml);
    //     //         
    //     //         // this.copyToClipboard(htmlElement, 0)
    //     //       })
    //     //       .catch((error) => {
    //     //         console.error('Error processing async markdown:', error);
    //     //       });
    //     //   } else {
    //     //     // Handle sync marked
    //     //     const safeHtml = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
    //     //     
    //     //     this.copyChatHistoryData = safeHtml;
    //     //     setTimeout(() => {
    //     //       let chatDataDom = document.getElementById("copyChatHistoryData");
    //     //       if(chatDataDom) {
    //     //         this.copyToClipboard(chatDataDom, 0)
    //     //       }
    //     //     }, 1000)
    //     //     // const htmlElement = this.convertSafeHtmlToElement(safeHtml);
 
    //     //   }

    //     // } catch (error) {
    //     //   console.error('Error processing message:', error);
    //     // }
    //   }
    // });
    
  }

  // Utility function to convert sanitized HTML to plain text
  private htmlToPlainText(htmlContent: string): string {
    const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
    return doc.body.textContent || "";
  }

  // private convertSafeHtmlToElement(safeHtml: SafeHtml): HTMLElement {
  //   // Create a temporary div element
  //   const tempDiv = document.createElement('div');
  //   // Assign the safe HTML to innerHTML
  //   tempDiv.innerHTML = safeHtml as string; // SafeHtml is trusted, so casting is fine here.
  //   // Return the first child as HTMLElement
  //   return tempDiv as HTMLElement;
  // }


  // copyToClipboard(copiedContent: string, ind: number) {
  //   navigator.clipboard.writeText(copiedContent).then(() => {
  //     const copiedMessageElement = document.getElementById("copied-message-" + ind);
  //     if (copiedMessageElement) {
  //       copiedMessageElement.innerHTML = "Copied";
  //       setTimeout(() => {
  //         copiedMessageElement.innerHTML = "";
  //       }, 400);
  //     }

  //   }).catch(err => {
  //     console.error('Failed to copy: ', err);
  //   });
  // }

  // copyToClipboard(copiedContent: HTMLElement, ind: number) {
  //   // const textContent = copiedContent?.textContent?.trim() || '';

  //   // Remove unwanted CSS rules using regex or a filter
  //   // const cleanedText = textContent.replace(/(body|h1|h2|pre|p|ul|li|.container)\s*\{[^}]*\}/g, '').trim();

  //   // Retrieve the HTML content, including tags
  //   const htmlContent = copiedContent?.innerHTML?.trim() || '';

  //   // Remove <style> tags and their content
  //   const cleanedText = htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

  //   // Optionally, use .textContent to get plain text after cleaning
  //   // const plainText = new DOMParser().parseFromString(cleanedText, 'text/html').body.textContent?.trim() || '';
  //   const parsedHtml = new DOMParser().parseFromString(cleanedText, 'text/html');

  //   // Check if the content includes a table
  //   const tableElement = parsedHtml.querySelector('table');

  //   // If a table exists, copy the HTML table; otherwise, copy plain text
  //   const clipboardContent = tableElement
  //     ? tableElement.outerHTML // Copy the table HTML if a table is found
  //     : parsedHtml.body.textContent?.trim() || ''; // Otherwise, copy plain text

  //   navigator.clipboard.writeText(clipboardContent).then(() => {
  //     const copiedMessageElement = document.getElementById("copied-message-" + ind);
  //     if (copiedMessageElement) {
  //       copiedMessageElement.innerHTML = "Copied";
  //       setTimeout(() => {
  //         copiedMessageElement.innerHTML = "";
  //       }, 400);
  //     }

  //   }).catch(err => {
  //     console.error('Failed to copy: ', err);
  //   });
  // }


  // copyToClipboard(copiedContent: HTMLElement, ind: number) {
  //   // Retrieve the HTML content, including tags
  //   const htmlContent = copiedContent?.innerHTML?.trim() || '';

  //   // Remove <style> tags and their content
  //   const cleanedText = htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

  //   // Parse the cleaned HTML content
  //   const parsedHtml = new DOMParser().parseFromString(cleanedText, 'text/html');

  //   // Check if the content includes a table
  //   const tableElement = parsedHtml.querySelector('table');

  //   // If a table exists, copy the HTML table; otherwise, copy plain text
  //   const clipboardContent = tableElement
  //       ? tableElement.outerHTML // Copy the table HTML if a table is found
  //       : parsedHtml.body.textContent?.trim() || ''; // Otherwise, copy plain text

  //   if (navigator.clipboard && navigator.clipboard.writeText) {
  //       // Use Clipboard API if available
  //       navigator.clipboard.writeText(clipboardContent).then(() => {
  //           this.showCopyMessage(ind);
  //       }).catch(err => {
  //           console.error('Failed to copy with Clipboard API: ', err);
  //       });
  //   } else {
  //       // Fallback to document.execCommand for insecure contexts
  //       const textarea = document.createElement('textarea');
  //       textarea.value = clipboardContent;
  //       textarea.style.position = 'fixed'; // Prevent scrolling to bottom
  //       textarea.style.opacity = '0';
  //       document.body.appendChild(textarea);
  //       textarea.select();

  //       try {
  //           const successful = document.execCommand('copy');
  //           if (successful) {
  //               this.showCopyMessage(ind);
  //           } else {
  //               console.error('Fallback: Copy command unsuccessful');
  //           }
  //       } catch (err) {
  //           console.error('Fallback: Failed to copy with execCommand: ', err);
  //       } finally {
  //           document.body.removeChild(textarea);
  //       }
  //   }
  // }

  // showCopyMessage(ind: number) {
  //   const copiedMessageElement = document.getElementById("copied-message-" + `${ind}`);
  //   if (copiedMessageElement) {
  //       copiedMessageElement.innerHTML = "Copied";
  //       setTimeout(() => {
  //           copiedMessageElement.innerHTML = "";
  //       }, 400);
  //   }
  // }


  copyToClipboard(copiedContent: HTMLElement, ind: number) {
    if (!copiedContent) {
      console.error("No content to copy");
      return;
    }

    // Extract HTML content
    let htmlContent = copiedContent.outerHTML;
    htmlContent = htmlContent.replace(/<span class="citation-icon-wrap"[^>]*>[\s\S]*?<\/span>/g, '');

    // Extract plain text content for fallback (tab-separated values for tables)
    const plainTextContent = this.convertToPlainText(copiedContent);

    if (navigator.clipboard && navigator.clipboard.write) {
      // Copy both text/plain and text/html formats
      const clipboardItem = new ClipboardItem({
        "text/html": new Blob([htmlContent], { type: "text/html" }),
        "text/plain": new Blob([plainTextContent], { type: "text/plain" }),
      });

      navigator.clipboard.write([clipboardItem]).then(() => {
        this.showCopyMessage(ind); // Show confirmation message
      }).catch((err) => {
        console.error("Failed to copy content: ", err);
      });
    } else {
      // Fallback for older browsers
      const cleanedPlainText = htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
      const parsedHtml = new DOMParser().parseFromString(cleanedPlainText, 'text/html');
      const clipboardContent = parsedHtml.body.textContent?.trim() || '';

      const textarea = document.createElement("textarea");
      textarea.value = clipboardContent;
      document.body.appendChild(textarea);
      textarea.select();

      try {
        const successful = document.execCommand("copy");
        if (successful) {
          this.showCopyMessage(ind); // Show confirmation message
        } else {
          console.error("Fallback: Copy command unsuccessful");
        }
      } catch (err) {
        console.error("Fallback: Failed to copy with execCommand: ", err);
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }

  convertToPlainText(element: HTMLElement): string {
    let plainText = "";

    if (element.tagName.toLowerCase() === "table") {
      // Convert table to tab-separated values
      const rows = element.querySelectorAll("tr");
      rows.forEach((row) => {
        const cells = row.querySelectorAll("td, th");
        const cellTexts = Array.from(cells).map(cell => cell.textContent?.trim() || "");
        plainText += cellTexts.join("\t") + "\n"; // Tab-separated for Excel compatibility
      });
    } else {
      // Recursively extract text for other elements
      element.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          plainText += node.textContent?.trim() || "";
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          plainText += this.convertToPlainText(node as HTMLElement) + "\n";
        }
      });
    }

    return plainText.trim();
  }

  showCopyMessage(ind: number) {
    const copiedMessageElement = document.getElementById("copied-message-" + `${ind}`);
    if (copiedMessageElement) {
      copiedMessageElement.innerHTML = "Copied";
      setTimeout(() => {
        copiedMessageElement.innerHTML = "";
      }, 400); // Clear the message after 400ms
    }
  }






  isButtonDisabled() {
    const currentTabForm = this.tabs[this.selectedTabIndex]?.myForm;
    const promptDetails = currentTabForm?.get('promptDetails')?.value;
    const isTitleAndDetailsValid = promptDetails;
    return !isTitleAndDetailsValid;
  }

  onInputChange(attach: any, event: any) {
    let otherAttachments = this.tabs[this.selectedTabIndex].myForm.value.attachment;
    const pageNumber = event.target.value.trim();
    this.attachments[attach].page_number = pageNumber;
  

    // Update the page_number for the specified attachment_index
    if (Array.isArray(otherAttachments) && otherAttachments[attach]) {
      // Update the page_number for the specified attachment index
      otherAttachments[attach].page_number = pageNumber;

      // If needed, reassign the updated array back to the form
      this.tabs[this.selectedTabIndex].myForm.patchValue({
        attachment: otherAttachments
      });
    } else {
      console.warn(`Attachment at index ${attach} does not exist.`);
    }
  }

  docsCleanup(projectCode: string) {
   
    if (projectCode && projectCode.includes("temp")) {
      this.promptCreateService.updateDocs(projectCode).subscribe((res: any) => {
        this.promptCreateService.deleteChunks(projectCode).subscribe();
        localStorage.removeItem("hasProjectCode");
      });
    }
    localStorage.removeItem('project_code');
  }

  callesAfterSaveSubmit(projectCode: string) {
    let renameS3Request: any = {
      "project_code": projectCode,
      "prompt_id": this.savedData?.prompt?.id || null,
      "prompt_detail_version_id": this.savedData?.prompt_details[0]?.id || null,
    }
    let updateDocsRequest: any = {
      "project_code": projectCode,
      "prompt_id": this.savedData?.prompt?.id || null,
      "prompt_detail_version_id": this.savedData?.prompt_details[0]?.id || null,
      "is_prompt_saved_or_submitted": true
    }
    if (!this.isS3ApiCalled) {
      this.promptCreateService.updateS3Names(renameS3Request).subscribe((res: any) => {
        this.promptCreateService.updateDocsPrompt(updateDocsRequest).subscribe((res: any) => {
          this.isS3ApiCalled = true;
          if (this.chatId) {
            this.updateChats(projectCode);
          }
        });
      });
    } else {
      if (this.chatId && !this.isUpdateChatCalled) {
        this.updateChats(projectCode);
      }
    }
  }

  updateChats(projectCode: string) {
    let updateChatRequest: any = {
      "chat_id": this.chatId,
      "project_code": projectCode,
      "prompt_id": this.savedData?.prompt?.id || null,
      "prompt_detail_version_id": this.savedData?.prompt_details[0]?.id || null,
      "is_prompt_saved_or_submitted": true
    }
    this.promptCreateService.updateChatPrompt(updateChatRequest).subscribe();
    this.isUpdateChatCalled = true;
  }

  //Variables helper funcs start
  parsePromptText(tabPositionIndex: number) {
    const promptDesc = this.tabs[tabPositionIndex].myForm.value.promptDetails
    const matches: [string] = promptDesc.match(/\[\[(.*?)\]\]/g);

    if (matches) {
      const variablesArray = this.tabs[tabPositionIndex].myForm.get('variables') as FormArray;
      const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;

      const newVariables = matches.map((match) => {
        const content = match.slice(2, -2); // Remove [ ]
        return content.includes('/') ? content.split('/') : content;
      });

      // Map existing values from promptVariablesCopy to newVariables
      const updatedVariables = newVariables.map((variable, index) => {
        // const existingVariable = this.promptVariables()[index];
        // const isDropdown = Array.isArray(variable);
        // const existingCopy = this.promptVariablesCopy()[index];
        const existingVariable = variablesArray.at(index)?.value;
        const isDropdown = Array.isArray(variable);
        const existingCopy = variablesCopyArray.at(index)?.value;

        // If the variable exists and matches the type, retain its value
        if (isDropdown && Array.isArray(existingVariable)) {
          // return existingCopy || variable;
          return (existingCopy != "" && existingCopy != null) ? existingCopy : "";
          // return existingCopy != "" ? existingCopy : variable;
        } else if (!isDropdown && typeof existingVariable === 'string') {
          // return existingCopy || variable;
          // return existingCopy == variable ? existingCopy : variable;
          return (existingCopy != "" && existingCopy != null) ? existingCopy : "";
        } else if (!isDropdown && typeof existingVariable === 'object') {
          // return existingCopy || variable;
          // return existingCopy == variable ? existingCopy : variable;
          return (existingCopy != "" && existingCopy != null) ? existingCopy : "";
        } else {
          // For new variables or type mismatches, initialize to default
          return "";
          // return variable;
        }
      });

      // this.promptVariables.set(newVariables); // Update with new variables
      // this.promptVariablesCopy.set(updatedVariables); // Retain updated values



      // Clear the current FormArray
      variablesArray.clear();

      // Populate the FormArray with the new values
      newVariables.forEach((item, i) => {
        if (Array.isArray(item)) {
          // If the item is an array, push a new FormArray
          variablesArray.push(this.fb.array(item.map((nested) => this.fb.control(nested))));
        } else if(typeof(updatedVariables[i]) == 'object') {
          variablesArray.push(this.fb.control(updatedVariables[i]));
        } else {
          // If the item is a string, push a FormControl
          variablesArray.push(this.fb.control(item));
        }
      });



      // Clear the current FormArray
      variablesCopyArray.clear();

      // Populate the FormArray with the new values
      updatedVariables.forEach((item) => {
        if (Array.isArray(item)) {
          // If the item is an array, push a new FormArray
          variablesCopyArray.push(this.fb.array(item.map((nested) => this.fb.control(nested))));
        } else {
          // If the item is a string, push a FormControl
          variablesCopyArray.push(this.fb.control(item));
        }
      });

    } else {
      // No matches; clear the variables
      // this.promptVariables.set([]);
      // this.promptVariablesCopy.set([]);

      const variablesArray = this.tabs[tabPositionIndex].myForm.get('variables') as FormArray;
      variablesArray.clear();

      const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;
      variablesCopyArray.clear();
    }

    this.updateInputPromptText(tabPositionIndex);
  }

  // Check if the variable is a string or array
  isString(variable: any): boolean {
    return typeof variable === 'string'
  }
  isArray(variable: any): boolean {
    return Array.isArray(variable)
  }
  isObject(variable: any): boolean {
    return typeof variable === 'object' && variable !== null && Object.keys(variable).length > 0
  }

  // onVariableChange(index: number, newValue: any, isDropdown: boolean, tabPositionIndex: number) {
  //   const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;

  //   //temp if
  //   if (variablesCopyArray.at(index)) {
  //     if (variablesCopyArray && variablesCopyArray.at(index)) {
  //       // Replace the control at the specified index with a new FormControl containing the string value
  //       const newControl = this.fb.control(isDropdown ? newValue.value : newValue);

  //       // Use the replace method to avoid type conflicts
  //       variablesCopyArray.setControl(index, newControl);
  //     } else {
  //       console.warn(`Index ${index} is out of bounds for variablesCopyArray`);
  //     }
  //   }

  //   this.updateInputPromptText(tabPositionIndex); // Sync inputText with updated variables
  //   this.promptModified.set(true);
  // }
  private variableChangeSubject = new Subject<{ index: number; newValue: any; isDropdown: boolean; tabPositionIndex: number; vLabel: string }>();

  onVariableChange(index: number, newValue: any, isDropdown: boolean, tabPositionIndex: number, vLabel: string = '') {
    const variablesArray = this.tabs[tabPositionIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;
    this.activeVarIndex = index;
    this.activeVarTabIndex = tabPositionIndex;

    //temp if
    if (variablesCopyArray.at(index)) {
      if (variablesCopyArray && variablesCopyArray.at(index)) {
        if(typeof(variablesCopyArray.at(index).value) != 'object') {
          // Replace the control at the specified index with a new FormControl containing the string value
          const newControl = this.fb.control(isDropdown ? newValue.value : newValue.target.value);

          // Use the replace method to avoid type conflicts
          variablesCopyArray.setControl(index, newControl);
        }
        if(variablesCopyArray.at(index).value == null) {
          // Replace the control at the specified index with a new FormControl containing the string value
          const newControl = this.fb.control(isDropdown ? newValue.value : newValue.target.value);

          // Use the replace method to avoid type conflicts
          variablesCopyArray.setControl(index, newControl);
        }

      } else {
        console.warn(`Index ${index} is out of bounds for variablesCopyArray`);
      }
    }

    if((typeof(variablesCopyArray.at(index).value) == 'object' && 
        newValue.target.value != '@' &&
        newValue.target.value.length > 0 &&
        variablesCopyArray.at(index).value?.historyFlowStates == 'inprogress')) {
          let curr_var = variablesCopyArray.at(index).value;

          const windowInnerHeight = window.innerHeight;
          const target = newValue.target as HTMLElement;
          const rect = target.getBoundingClientRect();

          let taglength = variablesCopyArray.at(index).value.tags.length;
          let subMenuHeightThrottle = 0;
          if(taglength == 1) {
            subMenuHeightThrottle = 83;
          } else if(taglength == 2) {
            subMenuHeightThrottle = 125;
          } else if(taglength == 3) {
            subMenuHeightThrottle = 170;
          }

          let varCardPosition = (windowInnerHeight - rect.top) - subMenuHeightThrottle;
          let transVarCardTopPosition: number = 0;
          if(varCardPosition < 0) {
            transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
          } else {
            transVarCardTopPosition = rect.top + 2
          }

          const currentVariablesValue = variablesArray.at(index).value;
          const currentVariablesCopyValue = variablesCopyArray.at(index).value;
          const updatedVariablesValue = {
            ...currentVariablesValue,
            showPopup: true,
            inputVal: '@',
            position: {
              top: `${transVarCardTopPosition}px`,
              left: `${curr_var.offset + 140}px`
            }
          }
          const updatedVariablesCopyValue = {
            ...currentVariablesCopyValue,
            showPopup: true,
            inputVal: '@',
            position: {
              top: `${transVarCardTopPosition}px`,
              left: `${curr_var.offset + 140}px`
            }
          }

          variablesArray.at(index).patchValue(updatedVariablesValue);
          variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
          this.isVariableScrollable = false;
    }

    if((typeof(variablesCopyArray.at(index).value) == 'object' && variablesCopyArray.at(index).value?.historyFlowStates == 'inprogress' && newValue.type == 'focus')) {
      let curr_var = variablesCopyArray.at(index).value;

      const windowInnerHeight = window.innerHeight;
      const target = newValue.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      let taglength = variablesCopyArray.at(index).value.tags.length;
      let subMenuHeightThrottle = 0;
      if(taglength == 1) {
        subMenuHeightThrottle = 83;
      } else if(taglength == 2) {
        subMenuHeightThrottle = 125;
      } else if(taglength == 3) {
        subMenuHeightThrottle = 170;
      }

      let varCardPosition = (windowInnerHeight - rect.top) - subMenuHeightThrottle;
      let transVarCardTopPosition: number = 0;
      if(varCardPosition < 0) {
        transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
      } else {
        transVarCardTopPosition = rect.top + 2
      }

      const currentVariablesValue = variablesArray.at(index).value;
      const currentVariablesCopyValue = variablesCopyArray.at(index).value;
      const updatedVariablesValue = {
        ...currentVariablesValue,
        showPopup: true,
        inputVal: '@',
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${curr_var.offset + 140}px`
        }
      }
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue,
        showPopup: true,
        inputVal: '@',
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${curr_var.offset + 140}px`
        }
      }

      variablesArray.at(index).patchValue(updatedVariablesValue);
      variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
      this.isVariableScrollable = false;
    }

    if((typeof(variablesCopyArray.at(index).value) == 'object' && 
        newValue.target.value == '@' && 
        variablesCopyArray.at(index).value?.historyFlowStates == 'inprogress')) {
      
      let curr_var = variablesCopyArray.at(index).value;

      const windowInnerHeight = window.innerHeight;
      const target = newValue.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      let taglength = variablesCopyArray.at(index).value.tags.length;
      let subMenuHeightThrottle = 0;
      if(taglength == 1) {
        subMenuHeightThrottle = 83;
      } else if(taglength == 2) {
        subMenuHeightThrottle = 125;
      } else if(taglength == 3) {
        subMenuHeightThrottle = 170;
      }

      let varCardPosition = (windowInnerHeight - rect.top) - subMenuHeightThrottle;
      let transVarCardTopPosition: number = 0;
      if(varCardPosition < 0) {
        transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
      } else {
        transVarCardTopPosition = rect.top + 2
      }

      variablesCopyArray.setControl(index, this.fb.control({
        inputVal: newValue.target.value,
        historyFlowStates: 'inprogress',
        showPopup: true,
        varGptData: curr_var.varGptData,
        label: curr_var.label,
        tags: [...curr_var.tags],
        offset: curr_var.offset,
        pdfDocData: {...curr_var.pdfDocData},
        chatVar: {...curr_var.chatVar},
        chatHistoryDocs: [...curr_var.chatHistoryDocs],
        historyOptions: [...curr_var.historyOptions],
        promptId: curr_var.promptId,
        promptVersionId: curr_var.promptVersionId,
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${curr_var.offset + 140}px`
          // left: `${rect.left + 20}px`
        }
      }));
      variablesArray.setControl(index, this.fb.control({
        inputVal: newValue.target.value,
        historyFlowStates: 'inprogress',
        showPopup: true,
        tags: [...curr_var.tags],
        offset: curr_var.offset,
        varGptData: curr_var.varGptData,
        label: curr_var.label,
        pdfDocData: {...curr_var.pdfDocData},
        chatVar: {...curr_var.chatVar},
        chatHistoryDocs: [...curr_var.chatHistoryDocs],
        historyOptions: [...curr_var.historyOptions],
        promptId: curr_var.promptId,
        promptVersionId: curr_var.promptVersionId,
        position: {
          top: `${transVarCardTopPosition}px`,
          left: `${curr_var.offset + 140}px`
          // left: `${rect.left + 20}px`
        }
      }));

      this.isVariableScrollable = false;
    }

    // if((typeof(variablesCopyArray.at(index).value) == 'object' && 
    //     newValue.target.value == '@' && 
    //     variablesCopyArray.at(index).value?.historyFlowStates == 'semi-completed')) {

    //     const currentVariablesValue = variablesArray.at(index).value;
    //     const currentVariablesCopyValue = variablesCopyArray.at(index).value;
    //     const updatedVariablesValue = {
    //       ...currentVariablesValue,
    //       historyFlowStates: 'inprogress',
    //       showPopup: true,
    //       inputVal: '@'
    //     }
    //     const updatedVariablesCopyValue = {
    //       ...currentVariablesCopyValue,
    //       historyFlowStates: 'inprogress',
    //       showPopup: true,
    //       inputVal: '@'
    //     }

    //     variablesArray.at(index).patchValue(updatedVariablesValue);
    //     variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
    //     this.isVariableScrollable = false;
    // }

    if((variablesCopyArray.at(index).value == "@" && variablesCopyArray.at(index).value.length == 1)) {
     
      this.variableChangeSubject.next({ index, newValue, isDropdown, tabPositionIndex, vLabel });

   
      // // let vOtherOttachments = this.tabs[tabPositionIndex].myForm.value?.attachment;
      // let vOtherOttachments: any = [];
      // // let vOtherOttachmentsList: any = [];
      // let vOtherOttachmentsListPromises: any = [];
      // this.tabs.forEach((item: any) => {
      //   if(item.myForm.value?.attachment?.length > 0) {
      //     item.myForm.value?.attachment.forEach((file: any) => {
      //       vOtherOttachments.push(file)
      //     })
      //   }
      // })
      // if(vOtherOttachments?.length > 0) {
      //   // vOtherOttachmentsList = vOtherOttachments.map((doc: any) => ({"menuName": doc.selected.name, "name": "From Input Document", "file_url": URL.createObjectURL(doc.selected)}));
      //   vOtherOttachmentsListPromises = vOtherOttachments.map((doc: any) => {
      //     if(doc?.selected?.type == 'application/pdf') {
      //       return Promise.resolve({"menuName": doc.selected.name, "name": "From Input Document", "file_url": URL.createObjectURL(doc.selected)})
      //     } else {
      //       try {
      //         const presSignedUrlRequest = {
      //           prompt_id: this.promptDetailsStored?.data?.prompt_id,
      //           title: this.tabs[this.selectedTabIndex].myForm.value.title,
      //           url_type: 'get_object',
      //           prompt_detail_id: this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id,
      //           attachment_type: "other_attachments",//"prompt_attachments",
      //           file_name: doc.selected.name,
      //           user_id:this.userid
      //         }
        
      //         return firstValueFrom(this.promptCreateService.getPresignedUrl(presSignedUrlRequest))
      //         .then((res: any) => {
    
      //           const fileUrl = res.data.url;
      //           return fetch(fileUrl);
      //         })
      //         .then((response: Response) => response.blob())
      //         .then((blob: Blob) => {
      //           return {
      //             "menuName": doc.selected.name,
      //             "name": "From Input Document",
      //             "file_url": URL.createObjectURL(blob)
      //           };
      //         })
      //         .catch((error) => {
   
      //           return {
      //             "menuName": doc.selected.name,
      //             "name": "From Input Document",
      //             "file_url": ""
      //           };
      //         });
      //       } catch (error) {
      //         return {"menuName": doc.selected.name, "name": "From Input Document", "file_url": ""}
      //       }
      //     }
      //   });
      // }

      // Promise.all(vOtherOttachmentsListPromises).then((vOtherOttachmentsList) => {
    
      //   const windowInnerHeight = window.innerHeight;
      //   const target = newValue.target as HTMLElement;
      //   const rect = target.getBoundingClientRect();

      //   let varCardPosition = (windowInnerHeight - rect.top) - 250;
      //   let transVarCardTopPosition: number = 0;
      //   if(varCardPosition < 0) {
      //     transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
      //   } else {
      //     transVarCardTopPosition = rect.top + 2
      //   }

      //   // const scrollableContentWrapper = document.querySelector('.scrollable-content-wrapper') as HTMLElement;
      //   // const scrollableContent = document.querySelector('.scrollable-content') as HTMLElement;
      //   // const promptSection = document.querySelector('.prompt-section') as HTMLElement;
      //   // const variableSection = document.querySelector('.variable-section') as HTMLElement;
      //   // const attachmentSection = document.querySelector('.attachment-section') as HTMLElement;
    

      //   // let transformPosition = {
      //   //   top: `${rect.top + 2}px`,
      //   //   left: `${rect.left + 20}px`
      //   // }

      //   // Calculate distance of input from the bottom
      //   // const distanceFromBottom = scrollableContent.scrollHeight - (target.offsetTop - scrollableContent.scrollTop + target.offsetHeight)
        
      //   // // Check if the input is within 100px of the bottom
      //   // const isNearBottom = distanceFromBottom <= 1500; // You can adjust the threshold
      //   // if (isNearBottom) {
      //   //   // Handle pop-up position or take any action

      //   //   // transformPosition = {
      //   //   //   top: `${rect.top + 2}px`,
      //   //   //   left: `${rect.left + 20}px`
      //   //   // }
      //   // }

      //   variablesCopyArray.setControl(index, this.fb.control({
      //     inputVal: newValue.target.value,
      //     historyFlowStates: 'inprogress',
      //     showPopup: true,
      //     tags: [],
      //     offset: 0,
      //     varGptData: "",
      //     label: vLabel,
      //     pdfDocData: {},
      //     chatVar: {},
      //     chatHistoryDocs: [],
      //     promptId: null,
      //     promptVersionId: null,
      //     historyOptions: [
      //       {
      //         enabled: tabPositionIndex == 0 ? false : true,
      //         name: 'Chat History'
      //       },
      //       {
      //         enabled: false, 
      //         name: 'Prompts', 
      //         subItems: []
      //       },
      //       {
      //         enabled: false, 
      //         name: 'Chat History Selection', 
      //         subItems: []
      //       },
      //       {
      //         enabled: false, 
      //         name: 'Chat Output Selection',
      //         subItems: []
      //       },
      //       {
      //         enabled: vOtherOttachmentsList.length > 0 ? true : false, 
      //         name: 'From Input Document', 
      //         subItems: [...vOtherOttachmentsList]
      //       },
      //       {
      //         enabled: false, 
      //         name: 'Page Selection',
      //         subItems: []
      //       },
      //     ],
      //     position: {
      //       top: `${transVarCardTopPosition}px`,
      //       left: `${rect.left + 20}px`
      //     }
      //   }));
      //   variablesArray.setControl(index, this.fb.control({
      //     inputVal: newValue.target.value,
      //     historyFlowStates: 'inprogress',
      //     showPopup: true,
      //     tags: [],
      //     offset: 0,
      //     varGptData: "",
      //     label: vLabel,
      //     pdfDocData: {},
      //     chatVar: {},
      //     chatHistoryDocs: [],
      //     promptId: null,
      //     promptVersionId: null,
      //     historyOptions: [
      //       {
      //         enabled: tabPositionIndex == 0 ? false : true,
      //         name: 'Chat History'
      //       },
      //       {
      //         enabled: false, 
      //         name: 'Prompts', 
      //         subItems: []
      //       },
      //       {
      //         enabled: false, 
      //         name: 'Chat History Selection', 
      //         subItems: []
      //       },
      //       {
      //         enabled: false, 
      //         name: 'Chat Output Selection',
      //         subItems: []
      //       },
      //       {
      //         enabled: vOtherOttachmentsList.length > 0 ? true : false,
      //         name: 'From Input Document', 
      //         subItems: [...vOtherOttachmentsList]
      //       },
      //       {
      //         enabled: false, 
      //         name: 'Page Selection',
      //         subItems: []
      //       },
      //     ],
      //     // position: transformPosition
      //     position: {
      //       top: `${transVarCardTopPosition}px`,
      //       left: `${rect.left + 20}px`
      //     }
      //   }));
      //   this.isVariableScrollable = false;
      // })
    }

    if((typeof(variablesCopyArray.at(index).value) == 'object' &&
        newValue.target.value.length > 0 &&
        variablesCopyArray.at(index).value?.historyFlowStates == 'completed')) {
          const currentVariablesValue = variablesArray.at(index).value;
          const currentVariablesCopyValue = variablesCopyArray.at(index).value;
          const updatedVariablesValue = {
            ...currentVariablesValue,
            inputVal: ''
          }
          const updatedVariablesCopyValue = {
            ...currentVariablesCopyValue,
            inputVal: ''
          }

          variablesArray.at(index).patchValue(updatedVariablesValue);
          variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
          this.isVariableScrollable = true;
    }
    

    this.updateInputPromptText(tabPositionIndex); // Sync inputText with updated variables
    this.promptModified.set(true);
  }

  private fileCache = new Map<string, string>();
  handleVariableInit(index: number, newValue: any, isDropdown: boolean, tabPositionIndex: number, vLabel: string = '') {
    this.isLoading = true;
    const variablesArray = this.tabs[tabPositionIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;
    let vOtherOttachments: any = [];
      // let vOtherOttachmentsList: any = [];
      let vOtherOttachmentsListPromises: any = [];
      this.tabs.forEach((item: any) => {
        if(item.myForm.value?.attachment?.length > 0) {
          item.myForm.value?.attachment.forEach((file: any) => {
            vOtherOttachments.push(file)
          })
        }
      })
      if(vOtherOttachments?.length > 0) {
        // vOtherOttachmentsList = vOtherOttachments.map((doc: any) => ({"menuName": doc.selected.name, "name": "From Input Document", "file_url": URL.createObjectURL(doc.selected)}));
        vOtherOttachmentsListPromises = vOtherOttachments.map((doc: any) => {
          if(doc?.selected?.type == 'application/pdf') {
            return Promise.resolve({"menuName": doc.selected.name, "name": "From Input Document", "file_url": URL.createObjectURL(doc.selected)})
          } else {
            try {
              const presSignedUrlRequest = {
                prompt_id: this.promptDetailsStored?.data?.prompt_id,
                title: this.tabs[this.selectedTabIndex].myForm.value.title,
                url_type: 'get_object',
                prompt_detail_id: this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id,
                attachment_type: "other_attachments",//"prompt_attachments",
                file_name: doc.selected.name,
                user_id:this.userid
              }

              // Check if presigned file is already cached
              if (this.fileCache.has(doc.selected.name)) {
                return Promise.resolve({
                  "menuName": doc.selected.name,
                  "name": "From Input Document",
                  "file_url": this.fileCache.get(doc.selected.name)!
                });
              }
        
              return firstValueFrom(this.promptCreateService.getPresignedUrl(presSignedUrlRequest))
              .then((res: any) => {
                
                const fileUrl = res.data.url;
                return fetch(fileUrl);
              })
              .then((response: Response) => response.blob())
              .then((blob: Blob) => {
                let blobURL = URL.createObjectURL(blob)

                // Store the blob URL in cache
                this.fileCache.set(doc.selected.name, blobURL)
                
                return {
                  "menuName": doc.selected.name,
                  "name": "From Input Document",
                  "file_url": blobURL
                };
              })
              .catch((error) => {
                console.log(error);
                return {
                  "menuName": doc.selected.name,
                  "name": "From Input Document",
                  "file_url": ""
                };
              });
            } catch (error) {
              return {"menuName": doc.selected.name, "name": "From Input Document", "file_url": ""}
            }
          }
        });
      }

      Promise.all(vOtherOttachmentsListPromises).then((vOtherOttachmentsList) => {
        if(tabPositionIndex == 0 && vOtherOttachmentsList.length == 0) {
          this.isLoading = false;
          return;
        }
        const windowInnerHeight = window.innerHeight;
        const target = newValue.target as HTMLElement;
        const rect = target.getBoundingClientRect();

        // let taglength = variablesCopyArray.at(index).value.tags.length;
        // let subMenuHeightThrottle = 0;
        // if(taglength == 1) {
        //   subMenuHeightThrottle = 42;
        // } else if(taglength == 2) {
        //   subMenuHeightThrottle = 84;
        // } else if(taglength == 3) {
        //   subMenuHeightThrottle = 126;
        // } else if(taglength == 4) {
        //   subMenuHeightThrottle = 168;
        // }

        let varCardPosition = (windowInnerHeight - rect.top) - 83;
        let transVarCardTopPosition: number = 0;
        if(varCardPosition < 0) {
          transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
        } else {
          transVarCardTopPosition = rect.top + 2
        }

        variablesCopyArray.setControl(index, this.fb.control({
          inputVal: newValue.target.value,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [],
          offset: 0,
          varGptData: "",
          label: vLabel,
          pdfDocData: {},
          chatVar: {},
          chatHistoryDocs: [],
          promptId: null,
          promptVersionId: null,
          historyOptions: [
            {
              enabled: tabPositionIndex == 0 ? false : true,
              grayedout: tabPositionIndex == 0 ? false : true,
              name: 'Chat History',
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Prompts', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: vOtherOttachmentsList.length > 0 ? true : false, 
              grayedout: vOtherOttachmentsList.length > 0 ? true : false, 
              name: 'From Input Document', 
              subItems: [...vOtherOttachmentsList]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          position: {
            top: `${transVarCardTopPosition}px`,
            left: `${rect.left + 20}px`
          }
        }));
        variablesArray.setControl(index, this.fb.control({
          inputVal: newValue.target.value,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [],
          offset: 0,
          varGptData: "",
          label: vLabel,
          pdfDocData: {},
          chatVar: {},
          chatHistoryDocs: [],
          promptId: null,
          promptVersionId: null,
          historyOptions: [
            {
              enabled: tabPositionIndex == 0 ? false : true,
              grayedout: tabPositionIndex == 0 ? false : true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Prompts', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: vOtherOttachmentsList.length > 0 ? true : false,
              grayedout: vOtherOttachmentsList.length > 0 ? true : false,
              name: 'From Input Document', 
              subItems: [...vOtherOttachmentsList]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // position: transformPosition
          position: {
            top: `${transVarCardTopPosition}px`,
            left: `${rect.left + 20}px`
          }
        }));
        this.isVariableScrollable = false;
        this.isLoading = false;
      })
  }

  handleVariableTagSelection(event: any, selectedOption: any, vIndex: number, tabIndex: number) {
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray.at(vIndex).value;
    const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

    if(selectedOption.name == "Chat History") {
      let promptData;
      if(this.promptDetailsStored) {
        promptData = this.promptDetailsStored.data.prompt_details.filter((_: any, i: number) => i < tabIndex).map((item: any, i: number) => ({
            menuName: 'Prompt ' + (i + 1),
            name: 'Prompts',
            promptId: this.promptDetailsStored.data.prompt_id,
            promptVersionId: item.prompt_detail_id,
        }))
      } else {
        this.isVariableScrollable = true;
        this.openSnackbar("Chat is not available", 'An error occurred', 'error-snackbar')
        return;
      }

      // Update only the specified key
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        tags: [{tag_name: 'Chat History', tag_url: ''}],
        // offset: 120,
        historyOptions: [
          {
            enabled: false,
            grayedout: true,
            name: 'Chat History'
          },
          {
            enabled: true, 
            grayedout: false,
            name: 'Prompts', 
            subItems: promptData
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'From Input Document', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        // position: {
        //   ...currentVariablesValue.position,
        //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 120}px`
        // }
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        // tags: ['Chat History'],
        tags: [{tag_name: 'Chat History', tag_url: ''}],
        // offset: 120,
        historyOptions: [
          {
            enabled: false,
            grayedout: true,
            name: 'Chat History'
          },
          {
            enabled: true,
            grayedout: false, 
            name: 'Prompts', 
            subItems: promptData
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'From Input Document', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        // position: {
        //   ...currentVariablesCopyValue.position,
        //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 120}px`
        // }
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
    } else if(selectedOption.name == 'Prompts') {
      this.copyChatHistory(selectedOption.promptId, selectedOption.promptVersionId).then((chatData) => {
        
        // Update only the specified key
        const updatedVariablesValue = {
          ...currentVariablesValue, // Keep existing values
          tags: [...currentVariablesValue.tags, {tag_name: selectedOption.menuName, tag_url: ''}],
          // tags: [...currentVariablesValue.tags, selectedOption.menuName],
          // offset: 228,
          promptId: selectedOption.promptId,
          promptVersionId: selectedOption.promptVersionId,
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: chatData
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 108}px`
          // }
        };

        // Update only the specified key
        const updatedVariablesCopyValue = {
          ...currentVariablesCopyValue, // Keep existing values
          tags: [...currentVariablesCopyValue.tags, {tag_name: selectedOption.menuName, tag_url: ''}],
          // tags: [...currentVariablesCopyValue.tags, selectedOption.menuName],
          // offset: 228,
          promptId: selectedOption.promptId,
          promptVersionId: selectedOption.promptVersionId,
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: chatData
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 108}px`
          // }
        };

        // Update the control with the new value
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.VariableSubMenu = [];
      }).catch((err) => {
        console.log(err)
      })
    } else if(selectedOption.name == 'Chat History Selection') {
      
      // Update only the specified key
      // const updatedVariablesValue = {
      //   ...currentVariablesValue, // Keep existing values
      //   tags: [...currentVariablesValue.tags, selectedOption.question],
      //   offset: 432,
      //   varGptData: selectedOption.answer,
      //   historyFlowStates: 'completed',
      //   inputVal: "",
      // };

      // let gptData = ""

      // if(chatMessages.messages.length > 0) {
      //   let chatSelectionData = chatMessages.messages.map((item: any) => {
  
      //       const chatQuest = marked(item.question);
      //       const chatAnswer = marked(item.answer);
  
      //       const safeQuest =
      //         chatQuest instanceof Promise
      //           ? chatQuest
      //               .then((htmlString: string) =>
      //                 this.htmlToPlainText(htmlString)
      //               )
      //               .catch((error) => {
      //                 console.error(
      //                   "Error processing async markdown:",
      //                   error
      //                 );
      //                 return null;
      //               })
      //           : this.htmlToPlainText(chatQuest);
  
      //       const safeAnswer =
      //         chatAnswer instanceof Promise
      //           ? chatAnswer
      //               .then((htmlString: string) =>
      //                 this.htmlToPlainText(htmlString)
      //               )
      //               .catch((error) => {
      //                 console.error(
      //                   "Error processing async markdown:",
      //                   error
      //                 );
      //                 return null;
      //               })
      //           : this.htmlToPlainText(chatAnswer);
          
      //     return {
      //       question: safeQuest,
      //       answer: chatAnswer 
      //     }
      //   })

      //   chatSelectionData.forEach((item: any) => {
      //     gptData += item.question + '<br>' + item.answer
      //   })
      // }

      let chatMessages = currentVariablesValue.historyOptions[2].subItems[0].chatData.find((chatItem: any) => {
        return chatItem.id == selectedOption.id
      });

      let chatDocs: any = [];
      if(chatMessages?.uploaded_attachments?.length > 0) {
        chatMessages.uploaded_attachments.forEach((item: any) => {
          chatDocs.push(item)
        })
      }
      // let selectedChatHistory = '@@@ ';
      // if(selectedOption.chatData && selectedOption.chatData.length > 0){
      //   let findItem = selectedOption.chatData.find((item:any) => {
      //     return item.name == selectedOption.question;
      //   });
      //   if(findItem){
      //     findItem.messages.forEach((messageItem:any) => {
      //       selectedChatHistory += messageItem.question + messageItem.answer + "\n\n";
      //     })
      //   }else{
      //     findItem = selectedOption.chatData.find((item:any) => {
      //       return item.name == null;
      //     });
      //     findItem.messages.forEach((messageItem:any) => {
      //       selectedChatHistory += messageItem.question + messageItem.answer + "\n\n";
      //     })
      //   }
        
      // }
      // selectedChatHistory += ' chat history retrieved.'
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        tags: [...currentVariablesValue.tags, {tag_name: selectedOption.question, tag_url: ''}],
        // varGptData: gptData,
        chatVar: {chat_id: selectedOption.id, chat_name: selectedOption.menuName?.trim()},
        chatHistoryDocs: [...currentVariablesValue.chatHistoryDocs, ...chatDocs],
        varGptData: '@@@ ' + selectedOption.question.trim()+ ' chat history retrieved.',
        // varGptData: selectedChatHistory,
        // tags: [...currentVariablesValue.tags, selectedOption.question],
        // offset: 432,
        // historyFlowStates: 'semi-completed',
        historyOptions: [
          {
            enabled: false,
            grayedout: true,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'Prompts', 
            subItems: [...currentVariablesValue.historyOptions[1].subItems]
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'Chat History Selection', 
            subItems: [...currentVariablesValue.historyOptions[2].subItems]
          },
          {
            enabled: true, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: [{
              menuName: 'All chats', 
              name: 'Chat Output Selection', 
              type: 'all',
              data: {
                selectedChat: selectedOption,
                chats: currentVariablesValue.historyOptions[2].subItems
              }
            }, 
            {menuName: 'custom', 
              name: 'Chat Output Selection', 
              type: 'custom',
              data: {
                selectedChat: selectedOption,
                chats: currentVariablesValue.historyOptions[2].subItems
              }
            }],
            // data: {
            //   selectedChat: selectedOption,
            //   chats: currentVariablesValue.historyOptions[2].subItems
            // }
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'From Input Document', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        // position: {
        //   ...currentVariablesValue.position,
        //   left: `${currentVariablesValue.offset}px`
        // }
        // position: {
        //   ...currentVariablesValue.position,
        //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 200}px`
        // }
      };

      // Update only the specified key
      
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        tags: [...currentVariablesCopyValue.tags, {tag_name: selectedOption.question, tag_url: ''}],
        // varGptData: gptData,
        chatVar: {chat_id: selectedOption.id, chat_name: selectedOption.menuName?.trim()},
        chatHistoryDocs: [...currentVariablesCopyValue.chatHistoryDocs, ...chatDocs],
        
        varGptData: '@@@ ' + selectedOption.question.trim()+ ' chat history retrieved.',
        // tags: [...currentVariablesCopyValue.tags, selectedOption.question],
        // offset: 432,
        // historyFlowStates: 'completed',
        // historyFlowStates: 'semi-completed',
        historyOptions: [
          {
            enabled: false,
            grayedout: true,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'Prompts', 
            subItems: [...currentVariablesCopyValue.historyOptions[1].subItems]
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'Chat History Selection', 
            subItems: [...currentVariablesCopyValue.historyOptions[2].subItems]
          },
          {
            enabled: true, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: [{
              menuName: 'All chats', 
              name: 'Chat Output Selection', 
              type: 'all',
              data: {
                selectedChat: selectedOption,
                chats: currentVariablesCopyValue.historyOptions[2].subItems
              }
            }, 
            {menuName: 'custom', 
              name: 'Chat Output Selection', 
              type: 'custom',
              data: {
                selectedChat: selectedOption,
                chats: currentVariablesCopyValue.historyOptions[2].subItems
              }
            }],
            // data: {
            //   selectedChat: selectedOption,
            //   chats: currentVariablesValue.historyOptions[2].subItems
            // }
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'From Input Document', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Page Selection',
            subItems: []
          },
        ],
        // position: {
        //   ...currentVariablesCopyValue.position,
        //   left: `${currentVariablesCopyValue.offset}px`
        // }
        // position: {
        //   ...currentVariablesCopyValue.position,
        //   left: `${parseInt(currentVariablesCopyValue.position.left.split('px')[0]) + 200}px`
        // }
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      // this.updateInputPromptText(tabIndex);
      // this.isVariableScrollable = true;
    } else if(selectedOption.name == "Chat Output Selection") {
      // Update only the specified key
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        showPopup: false,
        // tags: [...currentVariablesValue.tags, selectedOption.type == 'all' ? 'All chats' : null],
        historyFlowStates: selectedOption.type == 'all' ? 'completed' : 'inprogress',
        chatSelectionType: selectedOption.type,
        tags: [...currentVariablesValue.tags, ...(selectedOption.type === 'all' ? [{tag_name: 'All chats', tag_url: ''}] : [])],
        inputVal: "",
        chatVar: {...currentVariablesValue.chatVar, messages_selected: [], label_name: selectedOption.type == 'all' ? `@@@ ${selectedOption.data.selectedChat.menuName.replace('\n', '').trim('')} chat history retrieved.` : ''},
        varGptData: selectedOption.type == 'all' ? '@@@ ' + selectedOption.data.selectedChat.question.trim()+ ' chat history retrieved.' : currentVariablesValue.varGptData,
        // tags: [
        //   ...currentVariablesValue.tags,
        //   ...(selectedOption.type === 'all' ? ['All chats'] : [])
        // ],
        // offset: 432,
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        showPopup: false,
        // tags: [...currentVariablesCopyValue.tags, selectedOption.type == 'all' ? 'All chats' : null],
        historyFlowStates: selectedOption.type == 'all' ? 'completed' : 'inprogress',
        chatSelectionType: selectedOption.type,
        tags: [...currentVariablesCopyValue.tags, ...(selectedOption.type === 'all' ? [{tag_name: 'All chats', tag_url: ''}] : [])],
        inputVal: "",
        chatVar: {...currentVariablesCopyValue.chatVar, messages_selected: [], label_name: selectedOption.type == 'all'  ? `@@@ ${selectedOption.data.selectedChat.menuName.replace('\n', '').trim('')} chat history retrieved.` : ''},
        varGptData: selectedOption.type == 'all' ? '@@@ ' + selectedOption.data.selectedChat.question.trim()+ ' chat history retrieved.' : currentVariablesCopyValue.varGptData,
        // tags: [
        //   ...currentVariablesCopyValue.tags,
        //   ...(selectedOption.type === 'all' ? ['All chats'] : [])
        // ],
        // offset: 432,
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      this.isVariableScrollable = true;
      if(selectedOption.type == 'custom') {
        this.handlePartialChatSelection(selectedOption, vIndex, tabIndex);
      }
      this.updateInputPromptText(tabIndex);
    } else if(selectedOption.name == 'From Input Document') {
     
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        tags: [...currentVariablesValue.tags, {tag_name: selectedOption.menuName, tag_url: selectedOption.file_url}],
        // tags: [selectedOption.menuName],
        // offset: 160,
        pdfDocData: {"file_name": selectedOption.menuName, 'selected_pages': [], 'label_name': '@@@ ' + selectedOption.menuName.replace('\n', '').trim('')+ ' extracted.'},
        varGptData: '@@@ ' + selectedOption.menuName.trim()+ ' extracted.',
        // historyFlowStates: 'semi-completed',
        historyFlowStates: 'inprogress',
        inputVal: "@",
        historyOptions: [
          {
            enabled: false,
            grayedout: false,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Prompts', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'From Input Document', 
            subItems: [...currentVariablesValue.historyOptions[4].subItems]
          },
          {
            enabled: true,
            grayedout: false,
            name: 'Page Selection',
            subItems: [{
              menuName: 'All pages', 
              name: 'Page Selection', 
              type: 'all'},
              {
                menuName: 'Custom', 
                name: 'Page Selection', 
                type: 'custom'
              }
            ]
          },
        ],
        // position: {
        //   ...currentVariablesValue.position,
        //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) + 160}px`
        // }
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        tags: [...currentVariablesCopyValue.tags, {tag_name: selectedOption.menuName, tag_url: selectedOption.file_url}],
        // tags: [selectedOption.menuName],
        // offset: 160,
        pdfDocData: {"file_name": selectedOption.menuName, 'selected_pages': [], 'label_name': '@@@ ' + selectedOption.menuName.replace('\n', '').trim('')+ ' extracted.'},
        varGptData: '@@@ ' + selectedOption.menuName.trim()+ ' extracted.',
        historyFlowStates: 'inprogress',
        // historyFlowStates: 'semi-completed',
        inputVal: "@",
        historyOptions: [
          {
            enabled: false,
            grayedout: false,
            name: 'Chat History'
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Prompts', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat History Selection', 
            subItems: []
          },
          {
            enabled: false, 
            grayedout: false,
            name: 'Chat Output Selection',
            subItems: []
          },
          {
            enabled: false, 
            grayedout: true,
            name: 'From Input Document', 
            subItems: [...currentVariablesCopyValue.historyOptions[4].subItems]
          },
          {
            enabled: true,
            grayedout: false,
            name: 'Page Selection',
            subItems: [{
              menuName: 'All pages', 
              name: 'Page Selection', 
              type: 'all'},
              {
                menuName: 'Custom', 
                name: 'Page Selection', 
                type: 'custom'
              }
            ]
          },
        ],
        // position: {
        //   ...currentVariablesCopyValue.position,
        //   left: `${parseInt(currentVariablesCopyValue.position.left.split('px')[0]) + 160}px`
        // }
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      this.updateInputPromptText(tabIndex);
      // this.isVariableScrollable = true;
    } else if(selectedOption.name == 'Page Selection') {
      
      // Update only the specified key
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        historyFlowStates: selectedOption.type == 'all' ? 'completed' : 'inprogress',
        tags: [...currentVariablesValue.tags, ...(selectedOption.type === 'all' ? [{tag_name: 'All pages', tag_url: ''}] : [{tag_name: 'Page Selection', tag_url: ''}])],
        pdfDocData: {...currentVariablesValue.pdfDocData, 'selected_pages': []},
        varGptData: selectedOption.type == 'all' ? '@@@ ' + currentVariablesValue.pdfDocData.file_name.trim()+ ' extracted.' : '',
        // tags: [
        //   ...currentVariablesValue.tags,
        //   ...(selectedOption.type === 'all' ? ['All pages'] : ['Page Selection'])
        // ],
        showPopup: false,
        // tags: [...currentVariablesValue.tags, 'Page Selection'],
        // offset: 432,
        inputVal: ""
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        historyFlowStates: selectedOption.type == 'all' ? 'completed' : 'inprogress',
        tags: [...currentVariablesCopyValue.tags, ...(selectedOption.type === 'all' ? [{tag_name: 'All pages', tag_url: ''}] : [{tag_name: 'Page Selection', tag_url: ''}])],
        pdfDocData: {...currentVariablesCopyValue.pdfDocData, 'selected_pages': []},
        varGptData: selectedOption.type == 'all' ? '@@@ ' + currentVariablesValue.pdfDocData.file_name.trim()+ ' extracted.' : '',
        // tags: [
        //   ...currentVariablesCopyValue.tags,
        //   ...(selectedOption.type === 'all' ? ['All pages'] : ['Page Selection'])
        // ],
        showPopup: false,
        // tags: [...currentVariablesCopyValue.tags, 'Page Selection'],
        // offset: 432,
        inputVal: ""
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      if(selectedOption.type == 'custom') {
        this.handleShowVariablePageSelection(currentVariablesCopyValue.position, vIndex);
      } else {
        this.isVariableScrollable = true;
      }
      this.updateInputPromptText(tabIndex);
    }
  }

  chatHistorySelectionData: {question: string,answer: string}[] = [];
  handlePartialChatSelection(chatData: any, vIndex: number, tabIndex: number) {
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray.at(vIndex).value;
    const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

    
    let chatMessages = chatData.data.chats[0].chatData.find((chatItem: any) => {
      return chatItem.id == chatData.data.selectedChat.id
    });
   
    if(chatMessages.messages.length > 0) {
      let transChatMessages = chatMessages.messages.flatMap(({message_id, question, answer}: {message_id: number, question: string, answer: string}) => [
        {
          message_id: message_id,
          message_text: question.trim(),
          type: 'question'
        },
        {
          message_id: message_id,
          message_text: answer.trim(),
          type: 'answer'
        }
      ])
      let chatSelectionData = transChatMessages.map((item: any) => {

          // const chatQuest = marked(item.question);
          // const chatAnswer = marked(item.answer);
          const message_text = marked(this.escapeNonHtmlTags(item.message_text).replace(/\[\^\d+\^\]/g, ''));
          const safe_message_text = message_text;
          // const safe_message_text =
          // message_text instanceof Promise
          //     ? message_text
          //         .then((htmlString: string) =>
          //           this.htmlToPlainText(htmlString)
          //         )
          //         .catch((error) => {
          //           console.error(
          //             "Error processing async markdown:",
          //             error
          //           );
          //           return null;
          //         })
          //     : this.htmlToPlainText(message_text);

          // const safeQuest =
          //   chatQuest instanceof Promise
          //     ? chatQuest
          //         .then((htmlString: string) =>
          //           this.htmlToPlainText(htmlString)
          //         )
          //         .catch((error) => {
          //           console.error(
          //             "Error processing async markdown:",
          //             error
          //           );
          //           return null;
          //         })
          //     : this.htmlToPlainText(chatQuest);

          // const safeAnswer =
          //   chatAnswer instanceof Promise
          //     ? chatAnswer
          //         .then((htmlString: string) =>
          //           this.htmlToPlainText(htmlString)
          //         )
          //         .catch((error) => {
          //           console.error(
          //             "Error processing async markdown:",
          //             error
          //           );
          //           return null;
          //         })
          //     : this.htmlToPlainText(chatAnswer);
                
        // return {
        //   question: safeQuest,
        //   answer: chatAnswer,
        //   message_id: item.message_id
        // }
        return {
          message_id: item.message_id,
          message_text: safe_message_text,
          type: item.type
        }
      })

      const dialogRef = this.dailog.open(ChatHistorySelectionComponent, {
        data: {
          chatData: chatSelectionData,
          selectedQuestion: chatData.data.selectedChat.question
        },
      });
      
      dialogRef.afterClosed().subscribe((res) => {

        if(res?.type == 'submitted' && res?.selectedChatData?.length > 0) {
          
          let gptData = ''
          let msg_selected: any = []
          res?.selectedChatData.forEach((item: any) => {
            // gptData += item.question + '<br>' + item.answer
            // msg_selected.push(item.message_id)
            gptData += item.message_text

            msg_selected = msg_selected.map((msg: any) =>
              msg.id == item.message_id ? { ...msg, [item.type]: true } : msg
            );
            
            // If the message_id doesn't exist, add it
            if (!msg_selected.some((msg: any) => msg.id == item.message_id)) {
              msg_selected.push({
                id: item.message_id,
                question: item.type === 'question',
                answer: item.type === 'answer'
              });
            }
            
          })
          const updatedVariablesValue = {
            ...currentVariablesValue, // Keep existing values
            varGptData: gptData,
            // tags: [...currentVariablesValue.tags, `${res?.selectedChatData?.length} chat output selected`],
            tags: [...currentVariablesValue.tags, {tag_name: `${res?.selectedChatData?.length} chat output selected`, tag_url: ''}],
            historyFlowStates: 'completed',
            inputVal: "",
            chatVar: {...currentVariablesValue.chatVar, messages_selected: msg_selected},
          };
    
          // Update only the specified key
          const updatedVariablesCopyValue = {
            ...currentVariablesCopyValue, // Keep existing values
            varGptData: gptData,
            // tags: [...currentVariablesValue.tags, `${res?.selectedChatData?.length} chat output selected`],
            tags: [...currentVariablesCopyValue.tags, {tag_name: `${res?.selectedChatData?.length} chat output selected`, tag_url: ''}],
            historyFlowStates: 'completed',
            inputVal: "",
            chatVar: {...currentVariablesCopyValue.chatVar, messages_selected: msg_selected},
          };
    
          // Update the control with the new value
          variablesArray.at(vIndex).patchValue(updatedVariablesValue);
          variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
          this.updateInputPromptText(tabIndex);
          this.isVariableScrollable = true;
          
        } else if(res?.type == 'cancled') {
          console.log('cancled')
        }
      });

      // Detect backdrop click and close manually
      // dialogRef.backdropClick().subscribe(() => {
      //   console.log('Backdrop clicked, closing dialog');
      //   dialogRef.close();
      // });

      // chatMessages.messages.map((item: any) => {
      //   this.chatHistorySelectionData.push({
      //     question: item.question,
      //     answer: item.answer
      //   })
      // })
    }
  }
 
  @ViewChildren('tagsContainerWrapper') tagsContainerWrappers!: QueryList<ElementRef>;
  @ViewChildren('tagsContainer') tagsContainers!: QueryList<ElementRef>;
  @ViewChildren('tagElement') tags!: QueryList<ElementRef>;
  inputOffset: number = 0;
  updateInputOffset() {
    const variablesArray = this.tabs[this.selectedTabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[this.selectedTabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    // const currentVariablesValue = variablesArray.at(vIndex).value;
    // const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;
    // setTimeout(() => {
    //   // const tagsWidth = this.tagsContainer.nativeElement.offsetWidth;
    //   // this.inputOffset = tagsWidth + 10; // Add some padding
    //   // const totalWidth = this.tags.toArray().reduce((sum, tag) => sum + tag.nativeElement.offsetWidth, 0);
    //   // console.log(this.tags)

    //   this.tagsContainers?.forEach((containerRef, index) => {
    //     const tagsInContainer = this.tags?.filter(
    //         tagRef => containerRef?.nativeElement?.contains(tagRef.nativeElement)
    //     );

    //     const totalWidth = tagsInContainer?.reduce(
    //         (sum, tag) => sum + tag?.nativeElement?.offsetWidth + 5, 0
    //     );

    //     // this.variables[index].offset = totalWidth + 10; // Adjust padding if needed
   
    //     if(variablesArray.at(index)?.value?.tags) {
  

    //       const updatedVariablesValue = {
    //         ...variablesArray.at(index).value, // Keep existing values
    //         offset: totalWidth
    //       };
    
    //       // Update only the specified key
    //       const updatedVariablesCopyValue = {
    //         ...variablesCopyArray.at(index).value, // Keep existing values
    //         offset: totalWidth
    //       };
    
    //       // Update the control with the new value
    //       variablesArray.at(index).patchValue(updatedVariablesValue);
    //       variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
    //     }
        
    //   });
    
    // });
    // activeVarIndex

    setTimeout(() => {
      const wrapperRef = this.tagsContainerWrappers.toArray()[this.selectedTabIndex];
      if (!wrapperRef) return; // Ensure the wrapper exists

      // Get only the tagsContainers inside the specified wrapper
      // const containersInWrapper = wrapperRef.nativeElement.querySelectorAll('[tagsContainer]');
      const containersInWrapper = wrapperRef.nativeElement.querySelectorAll('.tagsContainer');

      containersInWrapper.forEach((containerRef: HTMLElement, index: number) => {
          // Get only the tags inside the current container
          // const tagsInContainer = containerRef.querySelectorAll('[tagElement]');
          const tagsInContainer = containerRef.querySelectorAll('.tag');

          const totalWidth = Array.from(tagsInContainer).reduce(
            (sum, tag) => sum + (tag as HTMLElement).offsetWidth + 5,
            0
          );

          if (variablesArray.at(index).value?.tags) {
              

              const updatedVariablesValue = {
                  ...variablesArray.at(index).value,
                  offset: totalWidth
              };

              const updatedVariablesCopyValue = {
                  ...variablesCopyArray.at(index).value,
                  offset: totalWidth
              };

              variablesArray.at(index).patchValue(updatedVariablesValue);
              variablesCopyArray.at(index).patchValue(updatedVariablesCopyValue);
          }
      });

      // Get the input element
      const inputElement = containersInWrapper[this.activeVarIndex].querySelectorAll('.mat-mdc-input-element')[0];

      // Check if the element exists
      if (inputElement) {
        // Create a KeyboardEvent for 'keyup' with '@' as the key
        const keyupEvent = new KeyboardEvent('keyup', { key: '@' });

        // Dispatch the event on the input element
        inputElement.dispatchEvent(keyupEvent);

        console.log("Keyup '@' triggered successfully.");
      }
      
    }, 100);
  }

  showVariablePageSelection: boolean = false;
  pageSelectionTooltipStyles: { top: string; left: string } = { top: '0px', left: '0px' };
  vpageSelectionIndex: any;
  handleShowVariablePageSelection(position: any, index: number) {
    this.showVariablePageSelection = true;
    this.pageSelectionTooltipStyles = position
    this.vpageSelectionIndex = index
  }

  handlePageSelection(ele: HTMLInputElement, vIndex: number, tabIndex: number) {
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray.at(vIndex).value;
    const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

    let pageInput = ele.value.trim();
    
    if (pageInput.length === 0) {
        this.openSnackbar('Please enter page no. (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
        return;
    }

    let pageNumbers: number[] = [];
    let isValid = true;

    for (let item of pageInput.split(',')) {
        // let num = parseInt(item.trim(), 10);

        item = item.trim();
        if (item.includes('-')) {
          if(item[0] == '-') {
            this.openSnackbar('Please enter valid page numbers (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
            pageNumbers = []; // Clear the array
            isValid = false;
            break; // Stop processing further
          }

          const [start, end] = item.split('-').map(Number);
          if (isNaN(start) || isNaN(end) || start == 0 || end == 0) {
            this.openSnackbar('Please enter valid page numbers (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
            pageNumbers = []; // Clear the array
            isValid = false;
            break; // Stop processing further
          }

          for (let i = start; i <= end; i++) {
              pageNumbers.push(i);
          }
        } else {
          let num = Number(item.trim());
          if(Math.sign(num) == -1) {
            this.openSnackbar('Please enter valid page numbers (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
            pageNumbers = []; // Clear the array
            isValid = false;
            break;
          }
          if (isNaN(num) || item.trim() == "" || num == 0) {
              this.openSnackbar('Please enter valid page numbers (Eg 2,3,9-12)', 'An error occurred', 'error-snackbar');
              pageNumbers = []; // Clear the array
              isValid = false;
              break; // Stop processing further
          }
          pageNumbers.push(num);
        }

        // let num = Number(item.trim());
        // if (isNaN(num) || item.trim() == "") {
        //     this.openSnackbar('Please enter valid page numbers (Eg 2,3)', 'error', 'error-snackbar');
        //     pageNumbers = []; // Clear the array
        //     isValid = false;
        //     break; // Stop processing further
        // }
        // pageNumbers.push(num);
    }

    if (isValid) {
      
      const updatedVariablesValue = {
        ...currentVariablesValue, // Keep existing values
        pdfDocData: {'file_name': currentVariablesValue.pdfDocData.file_name, 'selected_pages': pageNumbers, 'label_name': ''},
        // tags: [currentVariablesValue.tags[0], `Page's ${pageInput}`],
        tags: [currentVariablesValue.tags[0], {tag_name: `Page's ${pageInput}`, tag_url: ''}],
        historyFlowStates: 'completed',
        inputVal: ""
      };

      // Update only the specified key
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue, // Keep existing values
        pdfDocData: {'file_name': currentVariablesCopyValue.pdfDocData.file_name, 'selected_pages': pageNumbers, 'label_name': ''},
        // tags: [currentVariablesCopyValue.tags[0], `Page's ${pageInput}`],
        tags: [currentVariablesCopyValue.tags[0], {tag_name: `Page's ${pageInput}`, tag_url: ''}],
        historyFlowStates: 'completed',
        inputVal: ""
      };

      // Update the control with the new value
      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.showVariablePageSelection = false;
      this.isVariableScrollable = true;
      this.updateInputPromptText(tabIndex);
   
    }
  }

  closePageSelection(ele: HTMLInputElement, vIndex: number, tabIndex: number) {
    this.showVariablePageSelection = false
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray.at(vIndex).value;
    const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

    const updatedVariablesValue = {
      ...currentVariablesValue, // Keep existing values
      tags: [...currentVariablesValue.tags].slice(0, -1)
    };

    // Update only the specified key
    const updatedVariablesCopyValue = {
      ...currentVariablesCopyValue, // Keep existing values
      tags: [...currentVariablesCopyValue.tags].slice(0, -1)
    };

    // Update the control with the new value
    variablesArray.at(vIndex).patchValue(updatedVariablesValue);
    variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
    this.isVariableScrollable = true;
  }

  VariableSubMenu: any = []
  tooltipStyles: { top: string; left: string } = { top: '0px', left: '0px' };
  showVariableSubMenu(subMenu: any, event: MouseEvent): void {
    this.VariableSubMenu = subMenu;
    const windowInnerHeight = window.innerHeight;
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();

    let subMenuHeightThrottle = 0;
    if(subMenu.length == 1) {
      subMenuHeightThrottle = 42;
    } else if(subMenu.length == 2) {
      subMenuHeightThrottle = 84;
    } else if(subMenu.length == 3) {
      subMenuHeightThrottle = 126;
    } else if(subMenu.length == 4) {
      subMenuHeightThrottle = 168;
    } else {
      subMenuHeightThrottle = 200;
    }
    

    let varCardPosition = (windowInnerHeight - rect.top) - subMenuHeightThrottle;
    let transVarCardTopPosition: number = 0;
    if(varCardPosition < 0) {
      transVarCardTopPosition = rect.top - Math.abs(varCardPosition) - 10;
    } else {
      transVarCardTopPosition = rect.top + 2
    }
    
    this.tooltipStyles = {
      top: `${transVarCardTopPosition}px`,
      left: `${rect.left + 213}px` // Position to the right of the hovered element
    };
  }

  handleRemoveTag(event: any, vIndex: number, tabIndex: number) {
    const variablesArray = this.tabs[tabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[tabIndex].myForm.get('variablesCopy') as FormArray;

    const inputElement = event.target as HTMLInputElement;
    const cursorPosition = inputElement.selectionStart;

    if ((event.key === 'Backspace' || event.key === 'Delete') && cursorPosition === 0 && variablesCopyArray.at(vIndex).value.tags.length > 0) {

      const currentVariablesValue = variablesArray.at(vIndex).value;
      const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;

      let updatedVariablesValue: any = {};
      let updatedVariablesCopyValue: any = {};
      
      if(currentVariablesValue.historyOptions[1].enabled  && currentVariablesValue.tags.length == 1) {
        variablesArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      } else if(currentVariablesValue.historyOptions[2].enabled  && currentVariablesValue.tags.length == 2) {
        updatedVariablesValue = {
          ...currentVariablesValue,
          showPopup: true,
          tags: [...currentVariablesValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 120,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) - 120}px`
          // }  
        }
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesValue.historyOptions[3].enabled  && currentVariablesValue.tags.length == 3) {
        updatedVariablesValue = {
          ...currentVariablesValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesValue.tags].slice(0, -1),
          inputVal: '@',
          chatHistoryDocs: [],
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: [...currentVariablesValue.historyOptions[2].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 228,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          // }
        }
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesValue.historyOptions[3].enabled  && currentVariablesValue.tags.length == 4) {
        updatedVariablesValue = {
          ...currentVariablesValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Chat History Selection', 
              subItems: [...currentVariablesValue.historyOptions[2].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: [...currentVariablesValue.historyOptions[3].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 228,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          // }
        }
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesValue.historyOptions[4].enabled  && currentVariablesValue.tags.length == 1) {
        variablesArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      } else if(currentVariablesValue.historyOptions[5].enabled  && currentVariablesValue.tags.length == 1) {
        variablesArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      } else if(currentVariablesValue.historyOptions[5].enabled  && currentVariablesValue.tags.length == 2) {
        updatedVariablesValue = {
          ...currentVariablesValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: false,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Prompts', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'From Input Document', 
              subItems: [...currentVariablesValue.historyOptions[4].subItems]
            },
            {
              enabled: true,
              grayedout: false,
              name: 'Page Selection',
              subItems: [...currentVariablesValue.historyOptions[5].subItems]
            },
          ],
          position: {
            ...currentVariablesValue.position,
            left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          }
        }
        variablesArray.at(vIndex).patchValue(updatedVariablesValue);
        this.showVariablePageSelection = false;
        this.isVariableScrollable = false;
      }
      
      if(currentVariablesCopyValue.historyOptions[1].enabled && currentVariablesCopyValue.tags.length == 1) {
        variablesCopyArray.setControl(vIndex, this.fb.control(""));
      } else if(currentVariablesCopyValue.historyOptions[2].enabled && currentVariablesCopyValue.tags.length == 2) {
        updatedVariablesCopyValue = {
          ...currentVariablesCopyValue,
          showPopup: true,
          tags: [...currentVariablesCopyValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 120,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0]) - 120}px`
          // } 
        }
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesCopyValue.historyOptions[3].enabled && currentVariablesCopyValue.tags.length == 3) {
        updatedVariablesCopyValue = {
          ...currentVariablesCopyValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesCopyValue.tags].slice(0, -1),
          inputVal: '@',
          chatHistoryDocs: [],
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: [...currentVariablesValue.historyOptions[2].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 228,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          // }
        }
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesCopyValue.historyOptions[3].enabled && currentVariablesCopyValue.tags.length == 4) {
        updatedVariablesCopyValue = {
          ...currentVariablesCopyValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesCopyValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: true,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Prompts', 
              subItems: [...currentVariablesValue.historyOptions[1].subItems]
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'Chat History Selection', 
              subItems: [...currentVariablesValue.historyOptions[2].subItems]
            },
            {
              enabled: true, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: [...currentVariablesValue.historyOptions[3].subItems]
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'From Input Document', 
              subItems: []
            },
            {
              enabled: false,
              grayedout: false,
              name: 'Page Selection',
              subItems: []
            },
          ],
          // offset: 228,
          // position: {
          //   ...currentVariablesValue.position,
          //   left: `${parseInt(currentVariablesValue.position.left.split('px')[0])}px`
          // }
        }
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.isVariableScrollable = false;
      } else if(currentVariablesValue.historyOptions[4].enabled) {
        variablesCopyArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      } else if(currentVariablesCopyValue.historyOptions[5].enabled  && currentVariablesCopyValue.tags.length == 1) {
        variablesCopyArray.setControl(vIndex, this.fb.control(""));
      } else if(currentVariablesCopyValue.historyOptions[5].enabled  && currentVariablesCopyValue.tags.length == 2) {
        updatedVariablesCopyValue = {
          ...currentVariablesCopyValue,
          historyFlowStates: 'inprogress',
          showPopup: true,
          tags: [...currentVariablesCopyValue.tags].slice(0, -1),
          inputVal: '@',
          historyOptions: [
            {
              enabled: false,
              grayedout: false,
              name: 'Chat History'
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Prompts', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat History Selection', 
              subItems: []
            },
            {
              enabled: false, 
              grayedout: false,
              name: 'Chat Output Selection',
              subItems: []
            },
            {
              enabled: false, 
              grayedout: true,
              name: 'From Input Document', 
              subItems: [...currentVariablesCopyValue.historyOptions[4].subItems]
            },
            {
              enabled: true,
              grayedout: false,
              name: 'Page Selection',
              subItems: [...currentVariablesCopyValue.historyOptions[5].subItems]
            },
          ],
          position: {
            ...currentVariablesCopyValue.position,
            left: `${parseInt(currentVariablesCopyValue.position.left.split('px')[0])}px`
          }
        }
        variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
        this.showVariablePageSelection = false;
        this.isVariableScrollable = false;
      }

      // variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      // variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
    }

    if ((event.key === 'Backspace' || event.key === 'Delete') && cursorPosition === 1 && variablesCopyArray.at(vIndex).value.showPopup) {
     

      const currentVariablesValue = variablesArray.at(vIndex).value;
      const currentVariablesCopyValue = variablesCopyArray.at(vIndex).value;
      const updatedVariablesValue = {
        ...currentVariablesValue,
        inputVal: '',
        showPopup: false,
      }
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue,
        inputVal: '',
        showPopup: false,
      }

      variablesArray.at(vIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(vIndex).patchValue(updatedVariablesCopyValue);
      this.VariableSubMenu = [];
      this.isVariableScrollable = true;
    }

    if ((event.key === 'Backspace' || event.key === 'Delete') && cursorPosition === 1 && variablesCopyArray.at(vIndex).value.tags.length == 0 && event.target.value == '@')   {
      const currentVariablesValue = variablesArray.at(vIndex).value;
      variablesArray.setControl(vIndex, this.fb.control(currentVariablesValue.label));
      variablesCopyArray.setControl(vIndex, this.fb.control(""));
    }
  }

  updateInputPromptText(tabPositionIndex: number) {
    const variablesCopyArray = this.tabs[tabPositionIndex].myForm.get('variablesCopy') as FormArray;
    let updatedText = this.tabs[tabPositionIndex].myForm.value.promptDetails;
    let matcheVal: [string] = updatedText.match(/\[\[(.*?)\]\]/g);
    let matches;

    if (matcheVal) {
      matches = matcheVal.map((match) => {
        return match.slice(1, -1); // Remove [ ]
      });
    }

    if (matches) {
      matches.forEach((match, index) => {
        //const newVal = Array.isArray(this.promptVariables[index]) ? `[${(this.promptVariables[index] as string[]).join('/')}]`
        //: this.promptVariables[index];

        //temp if
        if (variablesCopyArray.at(index)) {
          const newVal = Array.isArray(variablesCopyArray.at(index).value) ? `[${(variablesCopyArray.at(index).value as string[]).join('/')}]`
            : variablesCopyArray.at(index).value;
          // updatedText = updatedText.replace(match, `${newVal}`);
          if (Array.isArray(variablesCopyArray.at(index).value)) {
            updatedText = updatedText.replace(`[${match}]`, `<span class="var-text">[${newVal}]</span>`);
          } else if((typeof(variablesCopyArray.at(index).value) == 'object' && 
                    (variablesCopyArray.at(index).value?.historyFlowStates == 'completed' || 
                    variablesCopyArray.at(index).value?.historyFlowStates == 'semi-completed'))) {
              let var_type: string = "";
              let chatSelectionType = newVal?.chatSelectionType == 'all' ? 'allChat' : 'partialChat'
              if(Object.keys(newVal.pdfDocData).length > 0) {
                var_type = 'doc'
              } else {
                var_type = 'chat'
              }
              updatedText = updatedText.replace(`[${match}]`, `<span class="var-text ${var_type} ${chatSelectionType}">${newVal.varGptData}</span>`)
          } else {
            updatedText = updatedText.replace(`[${match}]`, `<span class="var-text">${newVal}</span>`);
          }

        } else {
          updatedText = updatedText.replace(`[${match}]`, ``);
        }

      })
    }

    this.tabs[tabPositionIndex].myForm.patchValue({
      gptQuestion: updatedText
    })

  }

  onVariableFocus(v: any, event: FocusEvent, i: number, label: string) {
    setTimeout(() => {
        this.onVariableChange(v, event, false, i, label);
    }, 0);
  }

  toggleExpansion() {
    this.isExpansion = !this.isExpansion
  }

  loadChats(item: any, showSidePanel: boolean) {
    let chatMessages = this.chatHistoryData.find((chatItem: any) => {
      this.SELECTED_CHAT_HISTORY_ID = item.chat_id;
      return chatItem.id == item.chat_id
    });
    if (chatMessages) {
      this.chatId = chatMessages.id;
      this.currChatId.set({ chat_id: chatMessages.id, message_id: "" });
      this.messages = [];

      chatMessages.uploaded_attachments.forEach((file: any) => {
        this.messages.push({
          type: "file",
          value: file.file_name,
          isPrompt: true,
          page_number: "",
          question: '',
        });
      });

      chatMessages.messages.forEach((messageItem: any) => {
        this.messages.push({
          type: "text",
          value: this.template_converted?messageItem.question:this.escapeNonHtmlTags(messageItem.question),
          isPrompt: true,
          question: ''
        });
        this.messages.push({
          type: "text",
          value: messageItem.answer,
          isPrompt: false,
          question: messageItem.question,
          citations: messageItem.citations
        });
      });
      if(showSidePanel) {
        this.toggleSidebar();
      }
      this.enableChatPrompt = true;

      // let citations = messageItem.citations
      // let citations = {
      //   "[^1^]": {
      //     "type":  "document",
      //     "document_name": "abc.pdf",
      //     "highlight_content": "Deep learning models are based on artificial neural networks, which are inspired by the structure and function of the human brain.",
      //     "coordinates": [{
      //         "Width": 0.4215604364871979,
      //         "Height": 0.011238890700042248,
      //         "Left": 0.5212028622627258,
      //         "Top": 0.36133435368537903,
      //         "Page": 0
      //     }]
      //   },
      //   "[^2^]" : {
      //       "type":  "chat_history",
      //       "document_name": null,
      //       "chat_name": "abc",
      //       "chat_id": "a71f7055-6a4b-497a-996d-c22036d97606",
      //       "prompt_id": 1667,
      //       "prompt_detail_version_id": 2531,
      //       "highlight_content": "The final layer that produces the output, such as classification or prediction.",
      //       "coordinates": null,
      //       "chat_details": [{question: 'test question example',answer: 'test answer example'}]
      //   },
      //   "[^3^]": {
      //     "type":  "document",
      //     "document_name": "xyz.pdf",
      //     "highlight_content": "This process often involves techniques like backpropagation and optimization algorithms.",
      //     "coordinates": [{
      //         "Width": 0.4215604364871979,
      //         "Height": 0.011238890700042248,
      //         "Left": 0.5212028622627258,
      //         "Top": 0.36133435368537903,
      //         "Page": 0
      //     }]
      //   },
      //   "[^4^]" : {
      //       "type":  "chat_history",
      //       "document_name": null,
      //       "chat_name": "chat history 123",
      //       "chat_id": "0f1aa72d-3a41-4cda-ab5d-1ede34600214",
      //       "prompt_id": 1667,
      //       "prompt_detail_version_id": 2531,
      //       "highlight_content": "computations and extract features from the data. Deep learning models typically have multiple hidden layers.",
      //       "coordinates": null,
      //       "chat_details": [{question: 'test question example',answer: 'test answer example'}]
      //   },
      // }
      this.renderBotMsg(this.messages);
    }
  }
  //Variables helper funcs end
  onTabChange(event: MatTabChangeEvent) {

      this.chatHistory = [];
    let prompt_id = this.promptDetailsStored?.data?.prompt_id;
    if(this.selectedTabIndex < this.promptDetailsStored?.data?.prompt_details.length){
    let prompt_detail_id = this.promptDetailsStored?.data?.prompt_details[this.selectedTabIndex]?.prompt_detail_id;
    this.fetchChats(prompt_id, prompt_detail_id);
    this.messages = [];
    this.renderBotMsg(this.messages);
    }else{
      this.messages = [];
    this.renderBotMsg(this.messages);
    }
    if(this.selectedTabIndex == 0 || this.selectedTabIndex ){
      //const { model_id, model_name } = this.promptUserDetails?.prompt_details?.[this.selectedIndex]?.llm || {};
      this.selectedModelId=this.selectedModels()[this.selectedTabIndex]?? null;
    }
  
  }

  isDropdownVisible = false;

  // Toggle dropdown visibility
  toggleRearrangeDropdown(event: MouseEvent) {
    event.stopPropagation(); 
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  activeVarIndex: any = 0;
  activeVarTabIndex: any = 0;
  // Close dropdown on clicking outside
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent) {
    const targetElement = event.target as HTMLElement;

    if (this.citationTooltipVisible && !targetElement.closest('.citation-tooltip')) {
      this.citationTooltipVisible = false;
    }
    if (this.isDropdownVisible) {
      this.isDropdownVisible = false;
    }
    const target_ele = event.target as HTMLElement;
    if(!target_ele.closest('.moreOptionsIcon') && this.selectedChatIndex != null) {
      this.isChatContainerScrollable = true;
      this.selectedChatIndex = null;
    }

    if (!this.tabs.length) return;
    
    const variablesArray = this.tabs[this.selectedTabIndex].myForm.get('variables') as FormArray;
    const variablesCopyArray = this.tabs[this.selectedTabIndex].myForm.get('variablesCopy') as FormArray;

    // Get the current control value
    const currentVariablesValue = variablesArray?.at(this.activeVarIndex)?.value;
    const currentVariablesCopyValue = variablesCopyArray?.at(this.activeVarIndex)?.value;
    
    // const targetElement = event.target as HTMLElement;

    if (currentVariablesCopyValue?.showPopup && !targetElement.closest('.mat-mdc-card')) {
      const updatedVariablesValue = {
        ...currentVariablesValue,
        showPopup: false,
        inputVal: ''
      }
      const updatedVariablesCopyValue = {
        ...currentVariablesCopyValue,
        showPopup: false,
        inputVal: ''
      }

      variablesArray.at(this.activeVarIndex).patchValue(updatedVariablesValue);
      variablesCopyArray.at(this.activeVarIndex).patchValue(updatedVariablesCopyValue);
      this.isVariableScrollable = true;
      this.VariableSubMenu = [];
    }
    if(currentVariablesValue?.tags?.length == 0 && !targetElement.closest('.mat-mdc-card')) {
      variablesArray.setControl(this.activeVarIndex, this.fb.control(currentVariablesValue.label));
      variablesCopyArray.setControl(this.activeVarIndex, this.fb.control(""));
    }

    if (this.showVariablePageSelection && !targetElement.closest('.mat-mdc-card')) {
      this.closePageSelection(this.pageInput, this.activeVarIndex, this.selectedTabIndex)
    }
  }

  onPromptDelete(event: Event,promptDetailsStored:any, promptId: number, title: string) {
   
    const dialogRef = this.dailog.open(OnPromptDeleteComponent, {
      data: {
        promptId: promptId,
        title: title,
        promptDetailsStored: promptDetailsStored?.data?.prompt_details
      },
      height: '400px',
      width: '450px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if(result.promptDelete == "success") {
        this.router.navigateByUrl('/home/dashboard');
      }
    });
  }

  expandedTextarea: string | null = null;
  expandedTextTitle: string | null = null;
  isTextareaExpanded: boolean = false;
  onPromptEditHandler(event: Event, title: string, selector: string) {
    this.expandedTextarea = selector;
    this.expandedTextTitle = title;
    this.isTextareaExpanded = true;
  }

  onPromptEditCloseHandler() {
    this.expandedTextarea = "";
    this.expandedTextTitle = "title";
    this.isTextareaExpanded = false;

    this.adjustHeight();
  }

 


  showTooltip(tooltip: string) {
    if(tooltip == 'prompt-tooltip') {
      this.showPromptInstruction = true;
    } else if(tooltip == 'var-tooltip') {
      this.showTooltipInstruction = true;
    }
  }
  hideTooltio(tooltip: string) {
    if(tooltip == 'prompt-tooltip') {
      this.showPromptInstruction = false;
    } else if(tooltip == 'var-tooltip') {
      this.showTooltipInstruction = false;
    }
  }

  // Renaming of ChatHistory
  selectedChatIndex: number | null = null;
  selectedChatItem: any;
  chatHistoryMoreOptionsPosition = { top: 0, left: 0 };
  chatHistoryRenameTimeout: any;
  chatHistoryPanelIndex: number = 0
  @ViewChildren('chatHistoryContainer') chatHistoryContainers!: QueryList<ElementRef>;
  isChatContainerScrollable =  true;

  showChatHistoryOptions(event: MouseEvent, index: number, chatPanelIndex: number, chat: any) {
      this.isChatContainerScrollable = false;
      this.selectedChatIndex = index;
      this.chatHistoryPanelIndex = chatPanelIndex;
      this.selectedChatItem = chat;
      this.chatHistoryMoreOptionsPosition = {
        top: event.clientY + 10,
        left: event.clientX - 10
      };
  }
  
  editChatName(chat: any, chatIndex: number) {
    this.isChatContainerScrollable = true;
    chat.isEdit = true;
    this.selectedChatIndex = null;

    // Auto-focus input after it appears in the DOM
    setTimeout(() => {
      const wrapperRef = this.chatHistoryContainers.toArray()[this.selectedTabIndex];
      if (!wrapperRef) return; // Ensure the wrapper exists

      // Find all input fields with the class `.chatHistory-edit-input`
      const chatInputsWrap = wrapperRef.nativeElement.querySelectorAll('.history-body-wrap');
      const chatInputs = chatInputsWrap[this.chatHistoryPanelIndex].querySelectorAll('.history-item-body-content');
      // const chatInputs = wrapperRef.nativeElement.querySelectorAll('.history-item-body-content');

      // Select the correct input based on `chatIndex`
      const inputElement = chatInputs[chatIndex].getElementsByClassName('chatHistory-edit-input')[0] as HTMLElement;

      if (inputElement) {
        inputElement.focus();
      }
    }, 100);
  }

  startRenameTimer(event:any, chat: any, prevChatName: string) {
    
    clearTimeout(this.chatHistoryRenameTimeout);
    this.chatHistoryRenameTimeout = setTimeout(() => this.saveChatName(event, chat, prevChatName), 5000);
  }

  saveChatName(event:any, chat: any, prevChatName: string) {
    // Clear the rename timer to prevent duplicate calls
    clearTimeout(this.chatHistoryRenameTimeout);

    chat.isEdit = false;

    if(event.target.value.trim() == "") {
      // this.openSnackbar('Please rename Chat History', 'An error occurred', 'error-snackbar')
      return;
    }

    let prompt_id = this.promptDetailsStored.data.prompt_id;
    let prompt_detail_version_id = this.promptDetailsStored.data.prompt_details[this.selectedTabIndex].prompt_detail_id;
    let requestData = {
      "chat_id": chat.chat_id,
      "chat_name": event.target.value,
      "project_code": "1311_promptid",
      "prompt_id": prompt_id,
      "prompt_detail_version_id": prompt_detail_version_id,
      "is_prompt_saved_or_submitted": this.savedData?.prompt?.id === null ? false : this.promptDetailsStored.data.prompt_details[this.selectedTabIndex]?.status == 'DRAFT' ? true : false,
    }

    this.promptCreateService.updateChatName(requestData).subscribe((res) => {
      if (res && res["status_code"] === 200) {
        this.fetchChats(prompt_id, prompt_detail_version_id);
        // this.openSnackbar(`${prevChatName} renamed as ${event.target.value}`, 'Chat History renamed', 'success-snackbar')
      }
    });
  }

  trackByFn(index: number, item: any): number {
    return index; // Ensures the correct index is used
  }
  

  show_Tooltip() {
    clearTimeout(this.hideTimeout); // Prevent hiding if quickly re-hovered
    this.showTooltip1 = true;
  }

  hide_Tooltip() {
    this.hideTimeout = setTimeout(() => {
      this.showTooltip1 = false;
    }, 1000); // Hide tooltip after 5 seconds
  }

  
  showVersionTooltip(event: MouseEvent,tooltip: string,prompt:any) {
    if(tooltip == 'version'){
      this.showVersionInstruction = true;
      this.version_reason=prompt?.version_reason;
      this.created_from=prompt?.source_version == 0?'Initial Prompt':`version ${prompt?.source_version}`;
      const target = event.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      const tooltipWidth = 150; // Adjust based on actual tooltip width or estimate
      
      const padding = 10;

      let left = rect.right;
      let transform = 'translateX(0%)';

  //  If tooltip would overflow the screen to the right, shift to left side
  if (rect.right + tooltipWidth + padding > window.innerWidth) {
    left = rect.left-tooltipWidth+40 ;
  
    transform = 'translateX(0%)'; // Or leave as is
  }

  this.tooltipStyle = {
    top: rect.bottom-10 + 'px',
    left: left + 'px',
    transform,
    position: 'absolute',
  };
    
    }else
    if(tooltip == 'variant'){
      this.showVariantInstruction = true;
      this.variant_reason=prompt?.variant_reason;
      this.variant_created_from=prompt?.variant_source == 0?'Initial Prompt':`${prompt?.variant_source}`;
     
      
      const target = event.target as HTMLElement;
      const rect = target.getBoundingClientRect();

      const tooltipWidth = 150; // Adjust based on actual tooltip width or estimate
      
      const padding = 10;

      let left = rect.right;
      let transform = 'translateX(0%)';

  //  If tooltip would overflow the screen to the right, shift to left side
  if (rect.right + tooltipWidth + padding > window.innerWidth) {
    left = rect.left-tooltipWidth+40 ;
   
    transform = 'translateX(0%)'; // Or leave as is
  }

  this.tooltipStyle = {
    top: rect.bottom-10 + 'px',
    left: left + 'px',
    transform,
    position: 'absolute',
  };
      
    }
  }
  hideVersionTooltio(tooltip: string) {
    if(tooltip == 'version'){
      this.showVersionInstruction = false;

    }
    else if(tooltip == 'variant'){
      this.showVariantInstruction = false;

    }
  }


  ngOnDestroy(): void {
    if (!this.savedData && this.projectCode) {
      this.docsCleanup(this.projectCode);
      localStorage.removeItem("hasProjectCode");
    }
    this.clearPolling(); // Stop polling
  }

}
